// ════════════════════════════════════════════════════════════════
// Игры на сайте f1-hub.ru/games (static/site/games.html).
// Сами игры — src/games.jsx, тот же код, что в мини-аппе: build.js
// подставляет его сюда и собирает static/site/games.min.js.
// Здесь только «хозяин»: запросы с токеном входа сайта, вход/рекорды
// и раскладка страницы под компьютер и телефон.
// ════════════════════════════════════════════════════════════════
const { useState, useEffect, useMemo, useCallback, useRef } = React;

const _siteToken = () => { try { return localStorage.getItem('f1hub_auth_token'); } catch (e) { return null; } };
const _getAuthHeaders = () => { const t = _siteToken(); return t ? {'Authorization': 'TgLogin ' + t} : {}; };
const _f1media = (o) => {
    if (typeof o === 'string') return o.startsWith('https://media.formula1.com/') ? o.replace('https://media.formula1.com/', '/f1media/') : o;
    if (Array.isArray(o)) { for (let i = 0; i < o.length; i++) o[i] = _f1media(o[i]); return o; }
    if (o && typeof o === 'object') { for (const k in o) o[k] = _f1media(o[k]); return o; }
    return o;
};
let _siteAuthBad = false;
const _siteReq = async (url, opt) => {
    const res = await fetch(url, opt);
    if (res.status === 401) { _siteAuthBad = true; SG.set({loggedIn: false}); return null; }
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
};
const api = {
    get: async (url) => {
        try { return _f1media(await _siteReq(url, {headers: _getAuthHeaders()})); }
        catch (e) { console.warn('API GET ' + url + ':', e.message); return null; }
    },
    post: async (url, body) => {
        try { return await _siteReq(url, {method: 'POST', headers: {'Content-Type': 'application/json', ..._getAuthHeaders()}, body: JSON.stringify(body)}); }
        catch (e) { console.warn('API POST ' + url + ':', e.message); return null; }
    },
    del: async (url) => {
        try { return await _siteReq(url, {method: 'DELETE', headers: _getAuthHeaders()}); }
        catch (e) { console.warn('API DELETE ' + url + ':', e.message); return null; }
    },
};

// маленькое общее состояние страницы: вход и события результатов
const SG = {
    s: {loggedIn: _siteToken() ? null : false, name: '', note: null, saved: 0},
    subs: new Set(),
    set(p) { this.s = {...this.s, ...p}; this.subs.forEach(f => f(this.s)); },
};
const useSG = () => {
    const [s, setS] = useState(SG.s);
    useEffect(() => { SG.subs.add(setS); return () => SG.subs.delete(setS); }, []);
    return s;
};

window.__gmHost = {
    needLogin: () => SG.s.loggedIn === false,
    loginUrl: '/login',
    inviteLink: (code) => location.origin + '/games?durak=' + code,
    // без входа играем, но рекорд не отправляем — и предлагаем войти
    onResult: () => {
        if (SG.s.loggedIn === true && !_siteAuthBad) return true;
        SG.set({note: {k: Date.now(), kind: 'nosave'}});
        return false;
    },
    afterSave: () => SG.set({saved: SG.s.saved + 1, note: {k: Date.now(), kind: 'saved'}}),
};

// ==== MINI-GAMES ====
// Общий код игр: мини-апп (src/app.jsx через «// @include games.jsx») и сайт
// (src/site_games.jsx → static/site/games.min.js). От хозяина нужны: React-хуки,
// api, _f1media, _getAuthHeaders. Сайт дополнительно кладёт window.__gmHost:
//   onResult(body) → false — не сохранять (сайт без входа), afterSave(body),
//   needLogin() — онлайн-дурак только после входа, loginUrl, inviteLink(code).
// В мини-аппе __gmHost нет — всё работает как раньше.
const gmHost = () => window.__gmHost || {};

// Клавиатура на компьютере: обработчик всегда видит свежие функции компонента.
// Вернул true — клавиша «съедена» (пробел не прокручивает страницу).
const useGmKeys = (fn) => {
    const ref = useRef(fn);
    ref.current = fn;
    useEffect(() => {
        const on = (e) => {
            const t = e.target;
            if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
            if (e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
            if (ref.current(e) === true) e.preventDefault();
        };
        window.addEventListener('keydown', on);
        return () => window.removeEventListener('keydown', on);
    }, []);
};
const gmKeyGo = (e) => e.code === 'Space' || e.key === ' ' || e.key === 'Enter';
// Три игры под телефон: пит-стоп, дурак на картах F1, реакция на стартовых
// огнях. Квиз убран (решение Егора 24.09.2026: вопросы повторялись).

// Вибро-отклик: в Telegram — его HapticFeedback, в RuStore-обёртке — vibrate.
const gHaptic = (kind = 'light') => {
    try {
        const h = window.Telegram?.WebApp?.HapticFeedback;
        if (h) {
            if (kind === 'success' || kind === 'error' || kind === 'warning') h.notificationOccurred(kind);
            else h.impactOccurred(kind);
        } else if (navigator.vibrate) {
            navigator.vibrate(kind === 'heavy' || kind === 'error' ? 30 : 12);
        }
    } catch (e) {}
};


// Отправка результата игры с повтором. Раньше при сбое (502 во время
// перезапуска сервера) результат молча терялся — так пропало 100 мс Даниила.
// Теперь: 3 попытки, а если связи нет — очередь в памяти телефона, отправим
// при следующем заходе в игры.
const GM_PENDING = 'gm_pending_results';
const gmPostResult = async (body) => {
    const host = gmHost();
    if (host.onResult && host.onResult(body) === false) return null;   // сайт без входа: играем, но не сохраняем
    for (let i = 0; i < 3; i++) {
        const r = await api.post('/api/games/result', body);
        if (r) { if (host.afterSave) host.afterSave(body, r); return r; }
        await new Promise(z => setTimeout(z, 1200 * (i + 1)));
    }
    try { const q = JSON.parse(localStorage.getItem(GM_PENDING) || '[]'); q.push(body); localStorage.setItem(GM_PENDING, JSON.stringify(q.slice(-20))); } catch (e) {}
    return null;
};
const gmFlushPending = async () => {
    let q = [];
    try { q = JSON.parse(localStorage.getItem(GM_PENDING) || '[]'); } catch (e) {}
    if (!q.length) return;
    const left = [];
    for (const body of q) { if (!(await api.post('/api/games/result', body))) left.push(body); }
    try { localStorage.setItem(GM_PENDING, JSON.stringify(left)); } catch (e) {}
};

const GameTop = ({title, onBack, right}) => (
    <div className="gm-top">
        <div className="gm-back" onClick={e => { e.stopPropagation(); onBack(); }}>← Назад</div>
        <div className="gm-title">{title}</div>
        <div className="gm-top-r">{right || null}</div>
    </div>
);

// Рекорды игры из /api/games/leaderboard (для пит-стопа и реакции — меньше = лучше)
const GameBoard = ({type, fmt, refreshKey}) => {
    const [d, setD] = useState(null);
    useEffect(() => { api.get('/api/games/leaderboard?game_type=' + type).then(setD); }, [type, refreshKey]);
    const rows = d?.leaderboard || [];
    if (!rows.length) return null;
    return (
        <div className="gm-board">
            <div className="gm-board-h">Лучшие в F1 Hub</div>
            {rows.slice(0, 5).map(r => (
                <div className="gm-board-r" key={r.user_id}>
                    <span className={'gm-board-p' + (r.rank === 1 ? ' gold' : '')}>{String(r.rank).padStart(2, '0')}</span>
                    <span className="gm-board-n">{r.first_name || 'Игрок'}</span>
                    <span className="gm-board-s">{fmt(r.best_score)}</span>
                </div>
            ))}
            {d.my_best != null && d.my_rank > 5 && (
                <div className="gm-board-r mine">
                    <span className="gm-board-p">{String(d.my_rank).padStart(2, '0')}</span>
                    <span className="gm-board-n">Ты</span>
                    <span className="gm-board-s">{fmt(d.my_best)}</span>
                </div>
            )}
            {d.my_best != null
                ? <div className="gm-board-me">Твоё место: <b>{d.my_rank || '—'}</b> из {d.players} · рекорд <b>{fmt(d.my_best)}</b></div>
                : <div className="gm-board-me">Сыграй — и попадёшь в таблицу ({d.players} {plural(d.players, 'игрок', 'игрока', 'игроков')})</div>}
        </div>
    );
};

// Секундомер на requestAnimationFrame — ровный, без setInterval
const LiveTimer = ({t0, offset = 0}) => {
    const [ms, setMs] = useState(0);
    const off = useRef(offset); off.current = offset;
    useEffect(() => {
        let raf;
        const tick = () => { setMs(performance.now() - t0 + off.current); raf = requestAnimationFrame(tick); };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [t0]);
    return <>{(ms / 1000).toFixed(2)}</>;
};

// ─────────────────────────── ПИТ-СТОП ───────────────────────────
const PIT_TEAMS = [
    {name: 'Ferrari', c: '#E8002D', c2: '#FFE200'},
    {name: 'McLaren', c: '#FF8000', c2: '#101010'},
    {name: 'Mercedes', c: '#1d1f22', c2: '#27F4D2'},
    {name: 'Red Bull', c: '#1B2A55', c2: '#E4002B'},
    {name: 'Aston Martin', c: '#0B5E45', c2: '#CEDC00'},
    {name: 'Williams', c: '#0A2D6E', c2: '#64C4FF'},
    {name: 'Alpine', c: '#0B1F3F', c2: '#FF87BC'},
];
const PIT_COMPOUNDS = [
    {name: 'SOFT', c: '#FF2A2A'}, {name: 'MEDIUM', c: '#FFD21F'}, {name: 'HARD', c: '#F2F2F2'},
];
const PIT_STEPS = ['Открути', 'Смени', 'Закрути', 'Готово'];

const PitCar = ({c, c2}) => { const gid = 'pb' + String(c).replace(/[^a-z0-9]/gi, ''); return (
    <svg className="pit-car-svg" viewBox="0 0 120 280" aria-hidden="true">
        <defs>
            <linearGradient id={gid} x1="0" x2="1">
                <stop offset="0" stopColor={c} stopOpacity=".78"/>
                <stop offset=".5" stopColor={c}/>
                <stop offset="1" stopColor={c} stopOpacity=".78"/>
            </linearGradient>
        </defs>
        {/* переднее крыло */}
        <path d="M8 22 H112 L108 34 H12 Z" fill="#111"/>
        <path d="M12 26 H108" stroke={c2} strokeWidth="3"/>
        {/* нос */}
        <path d="M52 12 Q60 4 68 12 L72 70 H48 Z" fill={`url(#${gid})`}/>
        {/* подвеска */}
        <path d="M30 62 L52 70 M90 62 L68 70 M30 216 L46 206 M90 216 L74 206" stroke="#2a2a2a" strokeWidth="3"/>
        {/* монокок и понтоны */}
        <path d="M46 68 H74 L78 104 Q100 112 100 138 L96 196 Q86 222 60 226 Q34 222 24 196 L20 138 Q20 112 42 104 Z" fill={`url(#${gid})`}/>
        <path d="M60 70 V226" stroke={c2} strokeWidth="3" opacity=".9"/>
        {/* кокпит + гало */}
        <ellipse cx="60" cy="122" rx="11" ry="18" fill="#07070a"/>
        <circle cx="60" cy="118" r="6" fill={c2}/>
        <path d="M47 108 Q60 92 73 108" stroke="#1a1a1a" strokeWidth="4" fill="none"/>
        {/* двигатель и заднее крыло */}
        <rect x="52" y="150" width="16" height="48" rx="6" fill="#0d0d0d" opacity=".55"/>
        <path d="M18 236 H102 V256 H18 Z" fill="#111"/>
        <path d="M18 240 H102" stroke={c2} strokeWidth="4"/>
        <rect x="56" y="226" width="8" height="12" fill="#111"/>
    </svg>
); };

// Пит-стоп v3 (правка Егора 24.09: «нереалистично»). Как в настоящем F1:
//  1) заезд — жмёшь «Тормоз», чтобы встать ровно на отметку (промах =
//     механики переставляют машину, плюс время);
//  2) колёса — четыре бригады работают параллельно: на каждом колесе
//     «отвернуть» → шину меняют → «завернуть»;
//  3) выпуск — если по быстрой полосе едет соперник, горит красный;
//     выпустишь на красный — штраф 5 с за небезопасный выпуск.
// Время считается с момента остановки машины и до выпуска, как на ТВ-графике.
const PIT_WHEELS = [
    {id: 'fl', short: 'ПЛ', label: 'Переднее левое'},
    {id: 'fr', short: 'ПП', label: 'Переднее правое'},
    {id: 'rl', short: 'ЗЛ', label: 'Заднее левое'},
    {id: 'rr', short: 'ЗП', label: 'Заднее правое'},
];
const PIT_SWAP_MS = 480;          // сколько бригада снимает старую шину и ставит новую
const PIT_UNSAFE = 5000;          // штраф за небезопасный выпуск

const PitStopGame = ({onBack}) => {
    const [teams, setTeams] = useState([]);
    const [phase, setPhase] = useState('intro');       // intro | approach | wheels | release | done
    const [team, setTeam] = useState(null);
    const [tyre, setTyre] = useState(PIT_COMPOUNDS[0]);
    const [wheels, setWheels] = useState({});
    const [tStop, setTStop] = useState(0);
    const [res, setRes] = useState(null);
    const [msg, setMsg] = useState(null);
    const [light, setLight] = useState('red');
    const [traffic, setTraffic] = useState(false);
    const [canLeave, setCanLeave] = useState(false);   // защита от «проскочившего» тапа на экране итога
    const [boardKey, setBoardKey] = useState(0);
    const [ach, setAch] = useState(false);
    const stageRef = useRef(null);
    const carRef = useRef(null);
    const st = useRef({});
    const timers = useRef([]);
    const later = (fn, ms) => timers.current.push(setTimeout(fn, ms));
    useEffect(() => () => { timers.current.forEach(clearTimeout); cancelAnimationFrame(st.current.raf); }, []);

    useEffect(() => {
        api.get('/api/standings/constructors?season=2026').then(t => {
            const l = (t?.standings || t || []).filter(x => x.car_url);
            setTeams(l);
            if (l.length) setTeam(l[gmRand(l.length)]);
        });
    }, []);

    const say = (text, bad) => setMsg({text, bad, k: Date.now()});

    // ─ 1. заезд: машина едет к отметке, игрок тормозит ─
    const start = () => {
        timers.current.forEach(clearTimeout); timers.current = [];
        if (teams.length) setTeam(teams[gmRand(teams.length)]);
        setTyre(PIT_COMPOUNDS[gmRand(PIT_COMPOUNDS.length)]);
        setWheels(Object.fromEntries(PIT_WHEELS.map(w => [w.id, 0])));
        setRes(null); setMsg(null); setLight('red'); setTraffic(false); setCanLeave(false); setAch(false);
        st.current = {pen: 0, stopErr: 0, braking: false};
        setPhase('approach');
        later(() => {
            const W = stageRef.current?.clientWidth || 360;
            const carW = carRef.current?.clientWidth || W * 0.8;
            const target = (W - carW) / 2;               // отметка: машина ровно в боксе
            const s = st.current;
            s.W = W; s.carW = carW; s.target = target; s.x = -carW - 20; s.v = W * 1.05; s.t = performance.now();
            const tick = (now) => {
                const dt = Math.min(0.05, (now - s.t) / 1000); s.t = now;
                if (s.braking) s.v = Math.max(0, s.v - s.decel * dt);
                s.x += s.v * dt;
                // не нажал вовремя — механик ловит машину сам, с большим перелётом
                if (!s.braking && s.x > s.target + carW * 0.22) { s.braking = true; s.decel = s.v * s.v / (2 * 6); }
                if (carRef.current) carRef.current.style.transform = 'translateX(' + s.x + 'px)';
                if (s.v <= 0) { stopped(); return; }
                s.raf = requestAnimationFrame(tick);
            };
            s.raf = requestAnimationFrame(tick);
        }, 60);
    };
    const brake = () => {
        const s = st.current;
        if (phase !== 'approach' || s.braking) return;
        s.braking = true;
        s.decel = s.v * s.v / (2 * (s.carW * 0.09));    // тормозной путь ~ полметра
        gHaptic('medium');
    };
    const stopped = () => {
        const s = st.current;
        const meters = (s.x - s.target) / s.carW * 5.6;   // длина болида ~5.6 м
        s.stopErr = meters;
        const miss = Math.abs(meters);
        const pen = miss <= 0.15 ? 0 : Math.round(miss * 900);
        s.pen += pen;
        say(miss <= 0.15 ? 'Ровно на отметке!' : (meters > 0 ? 'Перелёт ' : 'Недоезд ') + miss.toFixed(2) + ' м · механики двигают машину +' + (pen / 1000).toFixed(1) + ' с', miss > 0.15);
        gHaptic(miss <= 0.15 ? 'success' : 'warning');
        const t = performance.now();
        s.tStop = t; setTStop(t);
        setPhase('wheels');
    };

    // ─ 2. колёса: 0 — стоит старая, 1 — меняют, 2 — новая, не затянута, 3 — готово ─
    const tapWheel = (id) => {
        if (phase !== 'wheels') return;
        const w = wheels[id];
        if (w === 0) {
            setWheels(p => ({...p, [id]: 1})); gHaptic('light');
            later(() => setWheels(p => ({...p, [id]: 2})), PIT_SWAP_MS);
        } else if (w === 1) {
            st.current.pen += 250; gHaptic('warning'); say('Рано — шину ещё не поставили · +0.25 с', true);
        } else if (w === 2) {
            const next = {...wheels, [id]: 3};
            setWheels(next); gHaptic('light');
            if (PIT_WHEELS.every(x => next[x.id] === 3)) release();
        }
    };

    // ─ 3. выпуск: следи за быстрой полосой ─
    const release = () => {
        setPhase('release');
        const busy = Math.random() < 0.5;
        setTraffic(busy);
        if (busy) {
            setLight('red');
            later(() => setLight('green'), 350 + Math.random() * 1100);
        } else later(() => setLight('green'), 200);
    };
    const go = () => {
        if (phase !== 'release') return;
        const s = st.current;
        const unsafe = light !== 'green';
        if (unsafe) { s.pen += PIT_UNSAFE; gHaptic('error'); } else gHaptic('success');
        const raw = performance.now() - s.tStop;
        const total = raw + s.pen;
        setRes({total, raw, pen: s.pen, unsafe, stopErr: s.stopErr});
        setPhase('done');
        later(() => setCanLeave(true), 700);
        gmPostResult({game_type: 'pit_real', score: Math.round(total)})
            .then(r => { if (r?.new_achievements?.length) setAch(true); setBoardKey(k => k + 1); });
    };

    useGmKeys(e => {
        if (gmKeyGo(e)) {
            if (phase === 'approach') brake();
            else if (phase === 'release') go();
            else if (phase === 'intro' || (phase === 'done' && canLeave)) start();
            else return;
            return true;
        }
        const n = '1234'.indexOf(e.key);
        if (n >= 0 && phase === 'wheels') { tapWheel(PIT_WHEELS[n].id); return true; }
    });

    const verdict = (ms) => ms < 2500 ? {t: 'Уровень McLaren', s: 'Рекорд F1 — 1.80 с, McLaren, Катар-2023'}
        : ms < 3200 ? {t: 'Топ-команда', s: 'Так меняют колёса в лидерах пелотона'}
        : ms < 4500 ? {t: 'Середина пелотона', s: 'Соперник уже прошёл под андеркатом'}
        : {t: 'Долгая остановка', s: 'В гонке это минус пара позиций'};

    const car = team?.car_url;
    const doneN = PIT_WHEELS.filter(w => wheels[w.id] === 3).length;

    return (
        <div className="page-container fade-in gm-page pit-page">
            <GameTop title="Пит-стоп" onBack={onBack}/>

            {phase === 'intro' && (
                <div className="gm-intro">
                    <div className="pit3-lane small">
                        {car && <img className="pit3-car" src={car} alt="" draggable="false" style={{transform: 'translateX(9%)'}}/>}
                    </div>
                    <div className="gm-h">Пит-стоп как в F1</div>
                    <div className="gm-p left">
                        <b>1. Заезд.</b> Жми «Тормоз», чтобы встать ровно на жёлтую отметку. Промах — механики двигают машину.<br/>
                        <b>2. Колёса.</b> На каждом: тап — отвернуть, шину меняют, второй тап — завернуть. Колёса в любом порядке.<br/>
                        <b>3. Выпуск.</b> Если по пит-лейну едет соперник, горит красный. Выпуск на красный — штраф 5 с.
                    </div>
                    <div className="gm-btn" onClick={start}>Машина в боксы</div>
                    <GameBoard type="pit_real" fmt={ms => (ms / 1000).toFixed(2) + ' с'} refreshKey={boardKey}/>
                </div>
            )}

            {phase !== 'intro' && phase !== 'done' && (
                <div className="pit3-stage">
                    <div className="pit-hud">
                        <div className={'pit-light ' + (phase === 'release' && light === 'green' ? 'go' : 'stop')}/>
                        <div className="pit-time">{phase === 'approach' ? '0.00' : <LiveTimer t0={tStop} offset={st.current.pen || 0}/>}<span>с</span></div>
                        <div className="pit-tyre"><i style={{background: tyre.c}}/>{tyre.name}</div>
                    </div>
                    {team && <div className="pit2-team">Бокс {team.team}</div>}
                    <div className="pit3-lane" ref={stageRef}>
                        <div className="pit3-fast">{phase === 'release' && traffic && light === 'red' && <div className="pit3-rival"/>}</div>
                        <div className="pit3-box" style={{'--tc': team?.team_color || '#E10600'}}><div className="pit3-mark"/></div>
                        {car && <img ref={carRef} className={'pit3-car' + (phase === 'wheels' ? ' up' : '') + (phase === 'release' ? ' down' : '')}
                                     src={car} alt="" draggable="false" style={{transform: 'translateX(-120%)'}}/>}
                    </div>
                    {msg && <div key={msg.k} className={'pit2-flash' + (msg.bad ? ' bad' : ' ok')}>{msg.text}</div>}

                    {phase === 'approach' && <div className="pit2-gun" onPointerDown={e => { e.preventDefault(); brake(); }}>ТОРМОЗ</div>}

                    {phase === 'wheels' && (
                        <div className="pit3-wheels">
                            {PIT_WHEELS.map(w => {
                                const s = wheels[w.id];
                                return (
                                    <div key={w.id} className={'pit3-w s' + s} style={{'--tc': tyre.c}} onPointerDown={e => { e.preventDefault(); tapWheel(w.id); }}>
                                        <div className="pit3-tyre"><i/></div>
                                        <b>{w.label}</b>
                                        <span>{s === 0 ? 'Отвернуть' : s === 1 ? 'Меняют шину…' : s === 2 ? 'Завернуть' : 'Готово ✓'}</span>
                                    </div>
                                );
                            })}
                            <div className="pit3-count">{doneN} / 4</div>
                        </div>
                    )}

                    {phase === 'release' && (
                        <div className={'pit3-go ' + light} onPointerDown={e => { e.preventDefault(); go(); }}>
                            {light === 'green' ? 'ВЫПУСК' : 'ЖДИ — СОПЕРНИК НА ПИТ-ЛЕЙНЕ'}
                        </div>
                    )}
                </div>
            )}

            {phase === 'done' && res && (() => { const v = verdict(res.total); return (
                <div className="gm-result">
                    <div className="gm-result-k">Время остановки</div>
                    <div className="gm-result-big">{(res.total / 1000).toFixed(2)}<span>с</span></div>
                    <div className="gm-result-t">{v.t}</div>
                    <div className="gm-result-s">{v.s}</div>
                    <div className="pit3-break">
                        <div><span>Работа бригады</span><b>{(res.raw / 1000).toFixed(2)} с</b></div>
                        <div><span>Остановка</span><b>{Math.abs(res.stopErr) <= 0.15 ? 'на отметке' : (res.stopErr > 0 ? 'перелёт ' : 'недоезд ') + Math.abs(res.stopErr).toFixed(2) + ' м'}</b></div>
                        {res.unsafe && <div className="bad"><span>Небезопасный выпуск</span><b>+5.0 с</b></div>}
                        {res.pen > 0 && <div><span>Штрафы всего</span><b>+{(res.pen / 1000).toFixed(2)} с</b></div>}
                    </div>
                    {ach && <div className="gm-ach">🏅 Новое достижение!</div>}
                    <div className={'gm-row' + (canLeave ? '' : ' wait')}>
                        <div className="gm-btn" onClick={() => canLeave && start()}>Ещё раз</div>
                        <div className="gm-btn ghost" onClick={() => canLeave && onBack()}>К играм</div>
                    </div>
                    <GameBoard type="pit_real" fmt={ms => (ms / 1000).toFixed(2) + ' с'} refreshKey={boardKey}/>
                </div>
            ); })()}
        </div>
    );
};

// ─────────────────────────── РЕАКЦИЯ ───────────────────────────
const REACTION_FACTS = [
    {max: 150, text: 'Быстрее моргания глаза. Ты вообще человек?'},
    {max: 150, text: 'Это уже рефлекс — мозг даже не успел подумать.'},
    {max: 220, text: 'Реакция уровня пилота F1 на стартовых огнях.'},
    {max: 220, text: 'Хэмилтон на старте реагирует примерно за 0.2 с. Ты рядом.'},
    {max: 220, text: 'Гепард реагирует на добычу за ~200 мс — ты на его уровне.'},
    {max: 300, text: 'Как вратарь на пенальти — прыжок начинается через ~250 мс.'},
    {max: 300, text: 'Средняя реакция человека — около 250 мс. Ты в норме.'},
    {max: 300, text: 'Киберспортсмены CS2 — 200–250 мс. Почти догнал.'},
    {max: 400, text: 'Для экзамена на права в Германии хватает 400 мс.'},
    {max: 400, text: 'После кофе реакция улучшается примерно на 10%.'},
    {max: 500, text: 'Водитель на светофоре реагирует за 400–500 мс.'},
    {max: 500, text: 'На старте Гран-при ты бы потерял пару позиций до первого поворота.'},
    {max: 99999, text: 'За {time} мс болид F1 на старте проезжает около {dist} м.'},
    {max: 99999, text: 'Попробуй ещё — первая попытка всегда разминка.'},
];

const ReactionGame = ({onBack}) => {
    const [phase, setPhase] = useState('ready');       // ready | lights | hold | go | done | false
    const [lit, setLit] = useState(0);
    const [rt, setRt] = useState(0);
    const [shown, setShown] = useState(0);
    const [fact, setFact] = useState('');
    const [boardKey, setBoardKey] = useState(0);
    const [ach, setAch] = useState(false);
    const goAt = useRef(0);
    const timers = useRef([]);
    const phaseRef = useRef('ready');
    const setP = (p) => { phaseRef.current = p; setPhase(p); };
    const clear = () => { timers.current.forEach(clearTimeout); timers.current = []; };
    useEffect(() => clear, []);

    const start = () => {
        clear(); setLit(0); setAch(false); setP('lights');
        for (let i = 1; i <= 5; i++) timers.current.push(setTimeout(() => { setLit(i); gHaptic('light'); }, i * 1000));
        // после пятого огня пауза 0.2–3 с — как у настоящей FIA-стартовой процедуры
        timers.current.push(setTimeout(() => setP('hold'), 5000));
        timers.current.push(setTimeout(() => {
            goAt.current = performance.now(); setLit(0); setP('go');
        }, 5000 + 200 + Math.random() * 2800));
    };

    const press = () => {
        const p = phaseRef.current;
        if (p === 'lights' || p === 'hold') { clear(); setP('false'); gHaptic('error'); return; }
        if (p !== 'go') return;
        const t = Math.round(performance.now() - goAt.current);
        setRt(t); setP('done'); gHaptic(t < 250 ? 'success' : 'medium');
        const pool = REACTION_FACTS.filter(f => t <= f.max);
        const f = pool[Math.floor(Math.random() * Math.min(4, pool.length))] || REACTION_FACTS[REACTION_FACTS.length - 1];
        setFact(f.text.replace('{time}', t).replace('{dist}', Math.max(1, Math.round(t * 0.012))));
        gmPostResult({game_type: 'reaction', score: t})
            .then(r => { if (r?.new_achievements?.length) setAch(true); setBoardKey(k => k + 1); });
    };
    // на компьютере: пробел/Enter — и «жми», и старт заново
    useGmKeys(e => {
        if (!gmKeyGo(e)) return;
        const p = phaseRef.current;
        if (p === 'lights' || p === 'hold' || p === 'go') press(); else start();
        return true;
    });

    // счётчик результата «набегает» до итоговых миллисекунд
    useEffect(() => {
        if (phase !== 'done') return;
        let raf; const s = performance.now();
        const tick = (n) => { const k = Math.min(1, (n - s) / 550); setShown(Math.round(rt * (1 - Math.pow(1 - k, 3)))); if (k < 1) raf = requestAnimationFrame(tick); };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [phase, rt]);

    const armed = phase === 'lights' || phase === 'hold' || phase === 'go';
    const pos = (ms) => Math.max(0, Math.min(100, (ms - 100) / 5)) + '%';   // шкала 100–600 мс

    return (
        <div className={'page-container fade-in gm-page rx-page' + (phase === 'go' ? ' rx-go' : '') + (phase === 'false' ? ' rx-false' : '')}
             onPointerDown={armed ? (e => { e.preventDefault(); press(); }) : undefined}>
            <GameTop title="Реакция" onBack={() => { clear(); onBack(); }}/>

            <div className="rx-gantry">
                {[1, 2, 3, 4, 5].map(i => (
                    <div key={i} className="rx-pod">
                        <i/><i/>
                        <i className={phase !== 'go' && phase !== 'done' && i <= lit ? 'on' : ''}/>
                        <i className={phase !== 'go' && phase !== 'done' && i <= lit ? 'on' : ''}/>
                    </div>
                ))}
            </div>

            {phase === 'ready' && (
                <div className="gm-intro">
                    <div className="gm-h">Старт как в F1</div>
                    <div className="gm-p">Пять красных огней загораются по одному. Когда <b>все погаснут</b> — жми в любое место экрана.<br/>Нажмёшь раньше — фальстарт.</div>
                    <div className="gm-btn" onClick={start}>На стартовую решётку</div>
                    <GameBoard type="reaction" fmt={ms => ms + ' мс'} refreshKey={boardKey}/>
                </div>
            )}

            {armed && (
                <div className="rx-arena">
                    <div className="rx-call">{phase === 'go' ? 'ЖМИ!' : 'Жди, пока погаснут огни'}</div>
                    <div className="rx-sub">{phase === 'go' ? 'Lights out and away we go' : 'Палец на экране — не отпускай внимание'}</div>
                </div>
            )}

            {phase === 'false' && (
                <div className="gm-result">
                    <div className="gm-result-big bad">ФАЛЬСТАРТ</div>
                    <div className="gm-result-s">Ты сорвался раньше, чем погасли огни. В гонке за это дают штраф 5 секунд.</div>
                    <div className="gm-row">
                        <div className="gm-btn" onClick={start}>Ещё раз</div>
                        <div className="gm-btn ghost" onClick={onBack}>К играм</div>
                    </div>
                </div>
            )}

            {phase === 'done' && (
                <div className="gm-result">
                    <div className="gm-result-k">Время реакции</div>
                    <div className="gm-result-big">{shown}<span>мс</span></div>
                    <div className="gm-result-t">{rt < 200 ? 'Нечеловеческая реакция' : rt < 260 ? 'Реакция пилота' : rt < 350 ? 'Хороший старт' : 'Проспал старт'}</div>
                    {/* метки без подписей на самой шкале — подписи раньше налезали друг на друга; легенда ниже */}
                    <div className="rx-scale">
                        <div className="rx-scale-bar"/>
                        <div className="rx-mark pro" style={{left: pos(200)}}/>
                        <div className="rx-mark avg" style={{left: pos(270)}}/>
                        <div className="rx-you" style={{left: pos(rt)}}/>
                    </div>
                    <div className="rx-legend">
                        <div className="you"><i/><b>{shown} мс</b><span>Ты</span></div>
                        <div className="pro"><i/><b>~200 мс</b><span>Пилоты F1</span></div>
                        <div className="avg"><i/><b>~270 мс</b><span>Обычный человек</span></div>
                    </div>
                    <div className="gm-fact">{fact}</div>
                    {ach && <div className="gm-ach">🏅 Новое достижение!</div>}
                    <div className="gm-row">
                        <div className="gm-btn" onClick={start}>Ещё раз</div>
                        <div className="gm-btn ghost" onClick={onBack}>К играм</div>
                    </div>
                    <GameBoard type="reaction" fmt={ms => ms + ' мс'} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

// ─────────────────────────── ДУРАК ───────────────────────────
// Колода 36 карт. Сила карты = место в чемпионате:
//   тузы — четыре лучшие команды Кубка конструкторов (логотип),
//   короли…девятки — пилоты по местам (К = 1–4 место, Д = 5–8, …),
//   младшие — остальные пилоты и команды, в конце — машины безопасности.
// Масти идут по кругу ♣ ♥ ♠ ♦ — туз треф у лидера Кубка конструкторов.
// Режимы: против компьютера (всё в браузере) и онлайн с другом (комната на
// сервере, правила проверяет сервер — durak_online.py).
const DK_SUITS = ['♣', '♥', '♠', '♦'];
const DK_RED = {'♥': 1, '♦': 1};
const DK_RANK = {6: '6', 7: '7', 8: '8', 9: '9', 10: '10', 11: 'В', 12: 'Д', 13: 'К', 14: 'Т'};
const DK_EXTRA = [
    {kind: 'sc', name: 'Safety Car', color: '#F5B301'},
    {kind: 'mc', name: 'Medical Car', color: '#2E7D32'},
    {kind: 'vsc', name: 'VSC', color: '#F5B301'},
    {kind: 'flag', name: 'Красный флаг', color: '#E10600'},
];
const DK_BOT = 'F1_egor_bot';

const dkBuildDeck = (drivers, teams) => {
    const teamCard = t => ({kind: 'team', name: t.team, color: t.team_color || '#555', logo: t.logo_url});
    const drvCard = d => ({kind: 'drv', name: d.last_name || d.name, color: d.team_color || '#555', img: d.photo_url || '', num: d.driver_number});
    const aces = teams.slice(0, 4).map(teamCard);
    const pool = [...drivers.map(drvCard), ...teams.slice(4).map(teamCard), ...DK_EXTRA].slice(0, 32);
    const cards = [];
    aces.forEach((c, i) => cards.push({...c, rank: 14, suit: DK_SUITS[i]}));
    [13, 12, 11, 10, 9, 8, 7, 6].forEach((rank, ri) => {
        pool.slice(ri * 4, ri * 4 + 4).forEach((c, i) => cards.push({...c, rank, suit: DK_SUITS[i]}));
    });
    return cards.map((c, i) => ({...c, id: 'c' + i}));
};

const dkShuffle = (a) => { const b = [...a]; for (let i = b.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [b[i], b[j]] = [b[j], b[i]]; } return b; };
const dkBeats = (atk, def, trump) => (def.suit === atk.suit && def.rank > atk.rank) || (def.suit === trump && atk.suit !== trump);
const dkVal = (c, trump) => c.rank + (c.suit === trump ? 20 : 0);
const dkSort = (hand, trump) => [...hand].sort((x, y) => dkVal(x, trump) - dkVal(y, trump) || x.suit.localeCompare(y.suit));
const dkRanksOnTable = (table) => { const s = new Set(); table.forEach(p => { s.add(p.atk.card.rank); if (p.def) s.add(p.def.card.rank); }); return s; };
const dkCanThrow = (g, card) => {
    if (!g.table.length) return true;
    if (g.table.length >= g.limit) return false;
    return dkRanksOnTable(g.table).has(card.rank);
};

// <dk-ai> ─ Мозг компьютера в «Дураке» ─
// Блок без JSX: этот же текст гоняет симуляция (tools/durak_sim.js).
// Честная игра: пока колода не пуста, бот знает только свои карты, бито,
// стол, козырь под колодой и карты, которые соперник взял со стола.
// Колода пуста — карты соперника = все невышедшие, тогда перебор ходов.
const dkAI = (() => {
    const TB = 10;                                   // надбавка козырю
    // настройки подобраны симуляцией (tools/durak_sim.js)
    const P = {atkTrump: 6, twinLo: 2.2, twinHi: 1.2, atkNoBeatLate: 4, atkNoBeat: 1.5, thrBig: 4, thrMid: 6, thrPb: 0.3, thrNoBeat: 3,
        dumpBig: 11, dumpMid: 12, defTrump: 2, defTrumpDeck: 0.2, defSameRank: 1.5, defTwin: 0.8,
        tkBase: 2.2, tkCard: 1.3, tkDef: 1.5, tkLate: 3, tkBig: 0.8, trBase: 3, trRank: 1.1, trDeck: 0.12, hiRank: 1.2, takeOff: 4};
    const val = (c, T) => c.rank - 6 + (c.suit === T ? TB : 0);
    const beats = (a, d, T) => (d.suit === a.suit && d.rank > a.rank) || (d.suit === T && a.suit !== T);
    const clock = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());
    const tableCards = (s) => s.table.flatMap(p => p.def ? [p.atk.card, p.def.card] : [p.atk.card]);
    const ranksOn = (s) => { const r = new Set(); s.table.forEach(p => { r.add(p.atk.card.rank); if (p.def) r.add(p.def.card.rank); }); return r; };

    // Что бот знает о соперничьей руке
    const view = (s, me) => {
        const op = me === 'a' ? 'p' : 'a';
        const tc = tableCards(s);
        const gone = s.gone || [];
        const kn = new Set((s.known && s.known[op]) || []);
        // известные карты соперника: он их взял со стола или вытянул открытый козырь
        const oppKnown = s.hands[op].filter(c => kn.has(c.id));
        const seen = new Set([...s.hands[me], ...tc, ...gone, ...oppKnown].map(c => c.id));
        if (s.deck.length) seen.add(s.trumpCard.id);
        // все 36 карт: перечисляем, но берём только невиданные — это «тёмный» пул
        const all = [...s.hands.p, ...s.hands.a, ...s.deck, ...tc, ...gone];
        const pool = all.filter(c => !seen.has(c.id));
        return {op, oppKnown, pool, oppN: s.hands[op].length, unk: s.hands[op].length - oppKnown.length};
    };

    // Вероятность, что соперник сможет побить карту x
    const pBeat = (x, V, T) => {
        if (V.oppKnown.some(b => beats(x, b, T))) return 1;
        const n = V.pool.length, k = Math.min(V.unk, n);
        const good = V.pool.filter(b => beats(x, b, T)).length;
        if (!good || !k) return 0;
        let miss = 1;
        for (let i = 0; i < k; i++) miss *= Math.max(0, n - good - i) / (n - i);
        return 1 - miss;
    };

    // ─── Перебор в эндшпиле ───
    // карта → код: масть*16 + ранг; руки — отсортированные массивы кодов
    const solve = (s, me, budget) => {
        const T = s.trump;
        const suits = [T];
        const sc = (c) => { let i = suits.indexOf(c.suit); if (i < 0) { suits.push(c.suit); i = suits.length - 1; } return i * 16 + c.rank; };
        const byCode = new Map();
        const enc = (c) => { const k = sc(c); byCode.set(k, c); return k; };
        const V = view(s, me);
        const A = s.hands[me].map(enc).sort((x, y) => x - y);
        const B = [...V.pool, ...V.oppKnown].map(enc).sort((x, y) => x - y);
        const tb = [];
        s.table.forEach(p => { tb.push(enc(p.atk.card), p.def ? enc(p.def.card) : -1); });
        const root = {h: [A, B], att: s.attacker === me ? 0 : 1, tb, lim: s.limit, tk: !!s.taking};

        // козырь — масть 0
        const bt = (a, d) => ((d >> 4) === (a >> 4) && (d & 15) > (a & 15)) || ((d >> 4) === 0 && (a >> 4) !== 0);
        const cv = (c) => (c & 15) + ((c >> 4) === 0 ? TB : 0);
        const rk = (tb) => { let m = 0; for (const c of tb) if (c >= 0) m |= 1 << (c & 15); return m; };
        const ins = (h, c) => { const r = h.slice(); let i = r.length; r.push(c); while (i > 0 && r[i - 1] > c) { r[i] = r[i - 1]; i--; } r[i] = c; return r; };
        const rem = (h, c) => { const i = h.indexOf(c); const r = h.slice(); r.splice(i, 1); return r; };
        const canThrow = (h, tb, lim) => { if (tb.length / 2 >= lim) return false; const m = rk(tb); return h.some(c => m & (1 << (c & 15))); };
        const fin = (st) => {
            const a = st.h[0].length, b = st.h[1].length;
            st.end = !a && !b ? 0 : !a ? 1 : !b ? -1 : null;
            return st;
        };
        const bito = (st) => fin({h: st.h, att: 1 - st.att, tb: [], lim: 6, tk: false});
        const take = (st) => {
            const d = 1 - st.att;
            const h = st.h.slice();
            h[d] = st.h[d].concat(st.tb.filter(c => c >= 0)).sort((x, y) => x - y);
            return fin({h, att: st.att, tb: [], lim: 6, tk: false});
        };
        const moves = (st) => {
            const att = st.att, def = 1 - att, H = st.h, tb = st.tb, n = tb.length / 2;
            if (st.tk) {
                const m = rk(tb), out = [];
                if (n < st.lim) for (const c of H[att]) if (m & (1 << (c & 15))) out.push(c);
                out.push(-1);
                return [att, out];
            }
            let u = -1;
            for (let i = 1; i < tb.length; i += 2) if (tb[i] < 0) { u = i - 1; break; }
            if (u >= 0) {
                const out = H[def].filter(c => bt(tb[u], c));
                out.sort((x, y) => cv(x) - cv(y));
                out.push(-1);
                return [def, out];
            }
            if (!n) return [att, H[att].slice().sort((x, y) => cv(x) - cv(y))];
            const m = rk(tb), out = [];
            if (n < st.lim) for (const c of H[att]) if (m & (1 << (c & 15))) out.push(c);
            out.sort((x, y) => cv(x) - cv(y));
            out.push(-1);
            return [att, out];
        };
        const play = (st, mv) => {
            const att = st.att, def = 1 - att, n = st.tb.length / 2;
            if (st.tk) {
                if (mv < 0) return take(st);
                const h = st.h.slice(); h[att] = rem(h[att], mv);
                const ns = {h, att, tb: st.tb.concat([mv, -1]), lim: st.lim, tk: true};
                if (!h[att].length || !canThrow(h[att], ns.tb, ns.lim)) return take(ns);
                return ns;
            }
            let u = -1;
            for (let i = 1; i < st.tb.length; i += 2) if (st.tb[i] < 0) { u = i - 1; break; }
            if (u >= 0) {
                if (mv < 0) {
                    const ns = {h: st.h, att, tb: st.tb, lim: st.lim, tk: true};
                    if (!st.h[att].length || !canThrow(st.h[att], st.tb, st.lim)) return take(ns);
                    return ns;
                }
                const h = st.h.slice(); h[def] = rem(h[def], mv);
                const tb = st.tb.slice(); tb[u + 1] = mv;
                const ns = {h, att, tb, lim: st.lim, tk: false};
                if (tb.length / 2 >= st.lim || !h[att].length || !h[def].length) return bito(ns);
                return ns;
            }
            if (mv < 0) return bito(st);
            const h = st.h.slice(); h[att] = rem(h[att], mv);
            const lim = n ? st.lim : Math.min(6, st.h[def].length);
            return {h, att, tb: st.tb.concat([mv, -1]), lim, tk: false};
        };
        const heur = (st) => {
            const [a, b] = st.h;
            let sa = 0, sb = 0;
            for (const c of a) sa += cv(c);
            for (const c of b) sb += cv(c);
            const x = (b.length - a.length) * 0.07 + (sa / Math.max(1, a.length) - sb / Math.max(1, b.length)) * 0.025 + (st.att === 0 ? 0.03 : -0.03);
            return Math.max(-0.9, Math.min(0.9, x));
        };
        const key = (st) => st.h[0].join(',') + '|' + st.h[1].join(',') + '|' + st.att + '|' + st.tb.join(',') + '|' + st.lim + '|' + (st.tk ? 1 : 0);

        const deadline = clock() + budget;
        const TT = new Map();
        const ABORT = {};
        let nodes = 0, cuts = 0;
        const node = (st, depth, alpha, beta) => {
            if (st.end !== undefined && st.end !== null) return st.end;
            if ((++nodes & 1023) === 0 && clock() > deadline) throw ABORT;
            if (depth <= 0) { cuts++; return heur(st); }
            const k = key(st);
            const e = TT.get(k);
            if (e && e.d >= depth) {
                if (e.d !== 1e9) cuts++;
                if (e.f === 0) return e.v;
                if (e.f === 1 && e.v >= beta) return e.v;
                if (e.f === 2 && e.v <= alpha) return e.v;
            }
            const a0 = alpha, c0 = cuts;
            const [who, ms] = moves(st);
            let best = who === 0 ? -2 : 2;
            for (const mv of ms) {
                const v = node(play(st, mv), depth - 1, alpha, beta);
                if (who === 0) { if (v > best) best = v; if (best > alpha) alpha = best; }
                else { if (v < best) best = v; if (best < beta) beta = best; }
                if (alpha >= beta) break;
            }
            const f = best <= a0 ? 2 : best >= beta ? 1 : 0;
            TT.set(k, {d: cuts === c0 ? 1e9 : depth, v: best, f});
            return best;
        };
        const [who0, ms0] = moves(root);
        if (who0 !== 0) return null;
        let bestMv = ms0[0], bestV = null, order = ms0.slice();
        try {
            for (let depth = 2; depth <= 80; depth += 2) {
                const c0 = cuts;
                let bv = -2, bm = order[0], alpha = -2;
                for (const mv of order) {
                    const v = node(play(root, mv), depth - 1, alpha, 2);
                    if (v > bv) { bv = v; bm = mv; }
                    if (bv > alpha) alpha = bv;
                    if (bv >= 1) break;
                }
                bestMv = bm; bestV = bv;
                order = [bm, ...order.filter(x => x !== bm)];
                if (cuts === c0 || bv >= 1) break;      // всё просчитано до конца
            }
        } catch (e) { if (e !== ABORT) throw e; }
        return {card: bestMv < 0 ? null : byCode.get(bestMv), v: bestV, nodes};
    };

    // ─── Миттельшпиль: эвристики ───
    const attackCard = (s, me, V) => {
        const T = s.trump, H = s.hands[me], d = s.deck.length;
        let best = null, bc = 1e9;
        const allTrump = H.every(c => c.suit === T);
        for (const c of H) {
            let cost = val(c, T);
            if (c.suit === T && !allTrump) cost += P.atkTrump;
            // пара/тройка одного ранга — можно подкинуть следом, это выгодно
            const twins = H.filter(x => x !== c && x.rank === c.rank && x.suit !== T).length;
            cost -= twins * (c.rank <= 11 ? P.twinLo : P.twinHi);
            // соперник вряд ли побьёт — заставим брать или тратить козырь
            const pb = pBeat(c, V, T);
            cost -= (1 - pb) * (d <= 6 ? P.atkNoBeatLate : P.atkNoBeat);
            if (cost < bc) { bc = cost; best = c; }
        }
        return best;
    };
    const throwCard = (s, me, V) => {
        const T = s.trump, H = s.hands[me], d = s.deck.length;
        if (s.table.length >= s.limit) return null;
        const r = ranksOn(s);
        const thr = d >= 14 ? P.thrBig : d >= 7 ? P.thrMid : 8;    // до какого ранга подкидывать (над шестёркой)
        let best = null, bc = 1e9;
        for (const c of H) {
            if (!r.has(c.rank)) continue;
            const pb = pBeat(c, V, T);
            if (c.suit === T) {
                // козырь подкидываем только в самом конце колоды и если его вряд ли перебьют
                if (d > 2 || pb > 0.35 || c.rank >= 12) continue;
            } else if (c.rank - 6 > thr && pb > P.thrPb) continue;
            const cost = val(c, T) - (1 - pb) * P.thrNoBeat;
            if (cost < bc) { bc = cost; best = c; }
        }
        return best;
    };
    const dumpCards = (s, me) => {
        const T = s.trump, H = s.hands[me], d = s.deck.length;
        const r = ranksOn(s);
        const room = Math.max(0, s.limit - s.table.length);
        const maxRank = d >= 10 ? P.dumpBig : d >= 4 ? P.dumpMid : 14;
        return H.filter(c => r.has(c.rank) && c.suit !== T && c.rank <= maxRank)
            .sort((x, y) => val(x, T) - val(y, T)).slice(0, room);
    };
    const defendMove = (s, me, V) => {
        const T = s.trump, H = s.hands[me], d = s.deck.length;
        const u = s.table.find(p => !p.def);
        const x = u.atk.card;
        const r = ranksOn(s);
        const bs = H.filter(b => beats(x, b, T));
        if (!bs.length) return {kind: 'take'};
        let best = null, bc = 1e9;
        for (const b of bs) {
            let cost = val(b, T) - val(x, T) * 0.3;
            if (b.suit === T && x.suit !== T) cost += P.defTrump + d * P.defTrumpDeck;
            if (r.has(b.rank)) cost -= P.defSameRank;               // не даём новый ранг для подкидывания
            const twins = H.filter(y => y !== b && y.rank === b.rank).length;
            if (twins && b.suit !== T) cost += P.defTwin;       // пару бережём для атаки
            if (cost < bc) { bc = cost; best = b; }
        }
        // брать или биться: оцениваем «цену» карты, которой бьём
        if (d >= P.takeOff) {
            const onTable = tableCards(s);
            const defended = s.table.filter(p => p.def).length;
            const tCost = best.suit === T && x.suit !== T ? P.trBase + (best.rank - 6) * P.trRank + d * P.trDeck : Math.max(0, best.rank - 11) * P.hiRank;
            const takeCost = P.tkBase + onTable.length * P.tkCard + defended * P.tkDef
                + onTable.reduce((a, c) => a + (c.suit === T ? -0.8 : c.rank <= 9 ? 0.6 : 0), 0)
                + (d <= 8 ? P.tkLate : 0) + Math.max(0, H.length + onTable.length - 8) * P.tkBig;
            if (tCost > takeCost) return {kind: 'take'};
        }
        return {kind: 'defend', card: best};
    };

    // ─── Миттельшпиль: оценка хода быстрыми партиями до конца (Монте-Карло) ───
    // Неизвестные карты соперника и порядок колоды каждый раз раскладываются
    // случайно (из того, что бот честно не видел), дальше обе стороны играют
    // простыми правилами. Ход с лучшим средним итогом — наш.
    const xbt = (a, d) => ((d >> 4) === (a >> 4) && (d & 15) > (a & 15)) || ((d >> 4) === 0 && (a >> 4) !== 0);
    const xcv = (c) => (c & 15) + ((c >> 4) === 0 ? TB : 0);
    const xDraw = (st, x) => { const h = st.H[x]; while (h.length < 6 && st.di < st.dk.length) h.push(st.dk[st.di++]); };
    const xEnd = (st) => {
        if (st.di < st.dk.length) return;
        const a = st.H[0].length, b = st.H[1].length;
        if (!a && !b) st.res = 0; else if (!a) st.res = 1; else if (!b) st.res = -1;
    };
    const xBito = (st) => { const at = st.att; st.tb = []; xDraw(st, at); xDraw(st, 1 - at); st.att = 1 - at; st.lim = 6; xEnd(st); };
    const xTake = (st) => {
        const at = st.att, df = 1 - at;
        for (const c of st.tb) if (c >= 0) st.H[df].push(c);
        st.tb = []; st.tk = false; xDraw(st, at); xDraw(st, df); st.lim = 6; xEnd(st);
    };
    const xRm = (h, c) => { h.splice(h.indexOf(c), 1); };
    const xRanks = (tb) => { let m = 0; for (const c of tb) if (c >= 0) m |= 1 << (c & 15); return m; };
    const xAttack = (st, c) => { if (!st.tb.length) st.lim = Math.min(6, st.H[1 - st.att].length); xRm(st.H[st.att], c); st.tb.push(c, -1); };
    const xDefend = (st, c) => {
        const at = st.att, df = 1 - at;
        xRm(st.H[df], c); st.tb[st.tb.indexOf(-1)] = c;
        if (st.tb.indexOf(-1) < 0 && (st.tb.length / 2 >= st.lim || !st.H[at].length || !st.H[df].length)) xBito(st);
    };
    const xDump = (st, cards) => { for (const c of cards) { xRm(st.H[st.att], c); st.tb.push(c, -1); } xTake(st); };
    const xApply = (st, a) => {
        if (a.k === 'take') { st.tk = true; return; }
        if (a.k === 'bito') { xBito(st); return; }
        if (a.k === 'dump') { xDump(st, a.c); return; }
        if (a.k === 'defend') { xDefend(st, a.c); return; }
        xAttack(st, a.c);
    };
    // простые правила для доигрывания
    const xPolicy = (st) => {
        const at = st.att, df = 1 - at, deckLeft = st.dk.length - st.di;
        const tb = st.tb, n = tb.length / 2;
        if (st.tk) {
            const m = xRanks(tb), out = [];
            let room = st.lim - n;
            const h = st.H[at].slice().sort((x, y) => xcv(x) - xcv(y));
            for (const c of h) if (room > 0 && (m & (1 << (c & 15))) && ((c >> 4) !== 0 || !deckLeft) && (!deckLeft || (c & 15) <= 12)) { out.push(c); room--; }
            xDump(st, out); return;
        }
        const ui = tb.indexOf(-1);
        if (ui >= 0) {
            const x = tb[ui - 1];
            let best = -1;
            for (const c of st.H[df]) if (xbt(x, c) && (best < 0 || xcv(c) < xcv(best))) best = c;
            if (best >= 0 && (best >> 4) === 0 && (x >> 4) !== 0 && deckLeft >= 8 && (best & 15) >= 13 && (x & 15) <= 10) best = -1;
            if (best < 0) st.tk = true; else xDefend(st, best);
            return;
        }
        const h = st.H[at];
        if (!n) {
            let best = h[0];
            for (const c of h) if (xcv(c) < xcv(best)) best = c;
            xAttack(st, best); return;
        }
        if (n < st.lim) {
            const m = xRanks(tb);
            let best = -1;
            for (const c of h) if ((m & (1 << (c & 15))) && (!deckLeft || ((c >> 4) !== 0 && (c & 15) <= 11)) && (best < 0 || xcv(c) < xcv(best))) best = c;
            if (best >= 0) { xAttack(st, best); return; }
        }
        xBito(st);
    };
    const mc = (s, me, V, cands, budget, prior) => {
        const T = s.trump, suits = [T];
        const sc = (c) => { let i = suits.indexOf(c.suit); if (i < 0) { suits.push(c.suit); i = suits.length - 1; } return i * 16 + c.rank; };
        const A = s.hands[me].map(sc);
        const known = V.oppKnown.map(sc);
        const pool = V.pool.map(sc);
        const trumpC = sc(s.trumpCard);
        const tb = [];
        s.table.forEach(p => { tb.push(sc(p.atk.card), p.def ? sc(p.def.card) : -1); });
        const acts = cands.map(a => ({k: a.kind, c: a.cards ? a.cards.map(sc) : a.card ? sc(a.card) : null}));
        const sum = acts.map(() => 0), cnt = acts.map(() => 0);
        const deadline = clock() + budget;
        const deckN = s.deck.length;
        let it = 0;
        while (true) {
            // расклад неизвестного
            const p = pool.slice();
            for (let i = p.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); const t = p[i]; p[i] = p[j]; p[j] = t; }
            const B = known.concat(p.slice(0, V.unk));
            const dk = p.slice(V.unk, V.unk + Math.max(0, deckN - 1));
            if (deckN) dk.push(trumpC);
            for (let i = 0; i < acts.length; i++) {
                const st = {H: [A.slice(), B.slice()], dk, di: 0, att: s.attacker === me ? 0 : 1, tb: tb.slice(), lim: s.limit, tk: !!s.taking, res: null};
                xApply(st, acts[i]);
                for (let g = 0; g < 600 && st.res === null; g++) xPolicy(st);
                sum[i] += st.res || 0; cnt[i]++;
            }
            if ((++it & 3) === 0 && clock() > deadline) break;
        }
        let bi = prior, bv = -9;
        for (let i = 0; i < acts.length; i++) {
            const v = sum[i] / cnt[i] + (i === prior ? 0.02 : 0);
            if (v > bv) { bv = v; bi = i; }
        }
        return {i: bi, it};
    };

    // эвристика даёт «предпочтительный» ход, Монте-Карло проверяет все варианты
    const same = (a, b) => a.kind === b.kind && (a.card ? b.card && a.card.id === b.card.id : true)
        && (a.cards ? b.cards && a.cards.length === b.cards.length && a.cards.every((c, i) => c.id === b.cards[i].id) : true);
    const pick = (s, me, V, cands, h, budget) => {
        let prior = cands.findIndex(c => same(c, h));
        if (prior < 0) { cands = [h, ...cands]; prior = 0; }
        if (cands.length < 2 || !budget || P.noMC) return h;
        return cands[mc(s, me, V, cands, budget, prior).i];
    };

    // Главная функция: что делать боту me ('a' или 'p') в состоянии s.
    // Ответ: {kind:'defend',card} | {kind:'take'} | {kind:'attack',card} | {kind:'bito'} | {kind:'dump',cards} | {kind:'wait'}
    const decide = (s, me, budget = 70) => {
        const op = me === 'a' ? 'p' : 'a';
        const u = s.table.find(p => !p.def);
        const V = view(s, me);
        const endgame = !s.deck.length;
        if (s.attacker === op) {
            if (!u || s.taking) return {kind: 'wait'};
            if (endgame) {
                const r = solve(s, me, budget);
                if (r) return r.card ? {kind: 'defend', card: r.card} : {kind: 'take'};
            }
            const h = defendMove(s, me, V);
            const T = s.trump, x = u.atk.card;
            const cands = [...s.hands[me].filter(b => beats(x, b, T)).map(card => ({kind: 'defend', card})), {kind: 'take'}];
            return pick(s, me, V, cands, h, budget);
        }
        if (s.taking === op) {
            if (endgame) {
                // подкидываем по одной, каждый раз пересчитывая
                const cards = [];
                let cur = s;
                for (let i = 0; i < 6; i++) {
                    if (cur.table.length >= cur.limit) break;
                    const r = solve(cur, me, Math.max(15, budget / 2));
                    if (!r || !r.card) break;
                    cards.push(r.card);
                    cur = {...cur, hands: {...cur.hands, [me]: cur.hands[me].filter(c => c.id !== r.card.id)},
                        table: [...cur.table, {atk: {card: r.card, by: me}, def: null}]};
                    if (!cur.hands[me].length) break;
                }
                return {kind: 'dump', cards};
            }
            const h = {kind: 'dump', cards: dumpCards(s, me)};
            const r = ranksOn(s), room = Math.max(0, s.limit - s.table.length);
            const all = s.hands[me].filter(c => r.has(c.rank)).sort((x, y) => val(x, s.trump) - val(y, s.trump));
            const cands = [];
            for (let k = 0; k <= Math.min(room, all.length); k++) cands.push({kind: 'dump', cards: all.slice(0, k)});
            return pick(s, me, V, cands, h, budget);
        }
        if (u) return {kind: 'wait'};
        if (endgame && s.hands[me].length) {
            const r = solve(s, me, budget);
            if (r) {
                if (r.card) return {kind: 'attack', card: r.card};
                return s.table.length ? {kind: 'bito'} : {kind: 'attack', card: attackCard(s, me, V)};
            }
        }
        if (!s.table.length) {
            const h = {kind: 'attack', card: attackCard(s, me, V)};
            return pick(s, me, V, s.hands[me].map(card => ({kind: 'attack', card})), h, budget);
        }
        const c = throwCard(s, me, V);
        const h = c ? {kind: 'attack', card: c} : {kind: 'bito'};
        const r = ranksOn(s);
        const thr = s.table.length < s.limit ? s.hands[me].filter(x => r.has(x.rank)) : [];
        return pick(s, me, V, [...thr.map(card => ({kind: 'attack', card})), {kind: 'bito'}], h, budget);
    };

    return {decide, solve, pBeat, view, P};
})();
// </dk-ai>

// Фото пилота — квадрат «голова и плечи» целиком, без обрезки (правка 24.09:
// вытянутый кадр вылезал за рамку и резал голову)
const dkDriverImg = (url) => (url || '').replace(/ar_\d+:\d+,w_\d+/, 'ar_1:1,w_300');
const dkPreload = (cards) => cards.forEach(c => {
    const u = c.kind === 'drv' ? dkDriverImg(c.img) : c.logo;
    if (u) { const im = new Image(); im.src = u; }
});

const DkCard = ({c, size = 'm', back, dim, sel, anim, style, ...rest}) => {
    if (back) return <div className={'dk-card back ' + size + (anim ? ' ' + anim : '')} style={style}><div className="dk-back-in"><b>F1</b><span>HUB</span></div></div>;
    const red = DK_RED[c.suit];
    return (
        <div className={'dk-card ' + size + (dim ? ' dim' : '') + (sel ? ' sel' : '') + (anim ? ' ' + anim : '')} style={style} {...rest}>
            <div className={'dk-idx' + (red ? ' red' : '')}><b>{DK_RANK[c.rank]}</b><i>{c.suit}</i></div>
            <div className="dk-face">
                {c.kind === 'drv' && c.img && <img className="dk-driver" src={dkDriverImg(c.img)} alt="" draggable="false" onError={e => { e.target.style.display = 'none'; }}/>}
                {c.kind === 'team' && c.logo && <img className="dk-logo" src={c.logo} alt="" draggable="false" onError={e => { e.target.style.display = 'none'; }}/>}
                {(c.kind === 'sc' || c.kind === 'vsc') && <div className="dk-emoji">🚨</div>}
                {c.kind === 'mc' && <div className="dk-emoji">🚑</div>}
                {c.kind === 'flag' && <div className="dk-emoji">🚩</div>}
            </div>
            <div className="dk-label" style={{'--tc': c.color}}><span>{c.name}</span></div>
        </div>
    );
};

// Запросы к комнатам: нужен текст ошибки сервера, а api.post его глотает.
const dkReq = async (method, url, body) => {
    try {
        const res = await fetch(url, {method, headers: {'Content-Type': 'application/json', ..._getAuthHeaders()},
            body: body ? JSON.stringify(body) : undefined});
        const data = await res.json().catch(() => ({}));
        return res.ok ? {ok: true, data: _f1media(data)} : {ok: false, error: data?.detail || ('Ошибка ' + res.status), status: res.status};
    } catch (e) { return {ok: false, error: 'Нет связи с сервером'}; }
};

// Код комнаты из приглашения: ?durak=КОД (кнопка бота) или start_param durak_КОД
const DURAK_INVITE = (() => {
    try {
        const q = new URLSearchParams(location.search).get('durak');
        const sp = window.Telegram?.WebApp?.initDataUnsafe?.start_param || '';
        const c = q || (sp.startsWith('durak_') ? sp.slice(6) : '');
        return c ? c.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6) : null;
    } catch (e) { return null; }
})();
let _dkInviteUsed = false;

const dkInviteLink = (code) => gmHost().inviteLink ? gmHost().inviteLink(code) : 'https://t.me/' + DK_BOT + '?start=durak_' + code;
const dkNeedLogin = () => !!(gmHost().needLogin && gmHost().needLogin());
const dkShare = async (code) => {
    const link = dkInviteLink(code);
    const text = 'Го в дурака на картах F1! Комната ' + code;
    const tgw = window.Telegram?.WebApp;
    if (tgw?.openTelegramLink && tgw.initData) {
        tgw.openTelegramLink('https://t.me/share/url?url=' + encodeURIComponent(link) + '&text=' + encodeURIComponent(text));
        return 'shared';
    }
    try { if (navigator.share) { await navigator.share({text: text + '\n' + link}); return 'shared'; } } catch (e) {}
    try { await navigator.clipboard.writeText(text + '\n' + link); return 'copied'; } catch (e) { return 'fail'; }
};

// ─ Стикеры-реакции: 22 пилота, у каждого своя фраза ─
// Картинки — Pixar-чибики в /static/stickers/<k>.webp; пока их нет, стикер
// рисуется из фото пилота. Когда арт готов — добавить ключ в DK_STK_ART.
const DK_STK = [
    {k: 'verstappen', t: 'Ту-ту-ту-ту!'}, {k: 'hamilton', t: 'Боно, шины всё'}, {k: 'leclerc', t: 'Я тупой, я тупой'},
    {k: 'norris', t: 'Ха-ха-ха'}, {k: 'piastri', t: 'Спокойно'}, {k: 'russell', t: 'Молодцы, ребята'},
    {k: 'antonelli', t: 'Мне всего 19!'}, {k: 'alonso', t: 'Мотор как в GP2!'}, {k: 'stroll', t: 'Всё под контролем'},
    {k: 'sainz', t: 'Smooth operator'}, {k: 'albon', t: 'Мяу'}, {k: 'gasly', t: 'ПЬЕР ГАСЛИИИ!'},
    {k: 'ocon', t: 'ЭСТЕБАН ОКОН!'}, {k: 'hulkenberg', t: 'Наконец-то подиум!'}, {k: 'bottas', t: 'Валттери, это Джеймс'},
    {k: 'perez', t: 'Министр обороны'}, {k: 'hadjar', t: 'Не плачу я!'}, {k: 'colapinto', t: '¡Vamos!'},
    {k: 'bortoleto', t: 'Бора!'}, {k: 'lawson', t: 'Подвинься!'}, {k: 'bearman', t: 'Олли в деле'}, {k: 'lindblad', t: 'Я новенький'},
];
const DK_STK_ART = DK_STK.map(s => s.k);   // все 22 нарисованы (24.09)
const DK_STK_ART_V = 3;
// для бота: над чем он смеётся и из-за чего расстраивается
const DK_STK_MOCK = ['norris', 'verstappen', 'albon', 'gasly', 'lawson'];
const DK_STK_SAD = ['hamilton', 'alonso', 'leclerc', 'hadjar', 'bottas'];
const DK_STK_WIN = ['ocon', 'gasly', 'colapinto', 'hulkenberg', 'verstappen'];
const dkStkKey = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z]/g, '');
const dkStkRecent = () => gmLS.get('dk_stk_recent', []);

const useDkStickers = () => {
    const [grid] = useGm([gmGrid]);
    return useMemo(() => {
        const photo = {};
        (grid?.[0]?.drivers || []).forEach(d => { photo[dkStkKey(d.last_name)] = {src: d.photo_url, color: d.team_color, name: d.last_name}; });
        return DK_STK.map(s => ({...s, ...(photo[s.k] || {name: s.k}), art: DK_STK_ART.includes(s.k) ? '/static/stickers/' + s.k + '.webp?v=' + DK_STK_ART_V : null}));
    }, [grid]);
};

const DkStkImg = ({s}) => s.art
    ? <img className="art" src={s.art} alt={s.name}/>
    : <div className="ph" style={{'--tc': s.color || '#555'}}>{s.src ? <img src={s.src} alt={s.name}/> : <b>{(s.name || '?')[0]}</b>}</div>;

// всплывает у того, кто отправил, не закрывает стол и исчезает через 2 с
const DkEmote = ({e, list}) => {
    const s = list.find(x => x.k === e.k);
    if (!s) return null;
    return (
        <div className={'dk-emote ' + e.by}>
            <DkStkImg s={s}/>
            <span>{s.t}</span>
        </div>
    );
};

const DkStkTray = ({list, onPick, onClose}) => {
    const recent = dkStkRecent();
    const sorted = [...list].sort((a, b) => {
        const ia = recent.indexOf(a.k), ib = recent.indexOf(b.k);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    return (
        <>
            <div className="dk-tray-bg" onClick={onClose}/>
            <div className="dk-tray">
                {sorted.map(s => (
                    <div key={s.k} className="dk-tray-i" onClick={() => {
                        gmLS.set('dk_stk_recent', [s.k, ...recent.filter(x => x !== s.k)].slice(0, 8));
                        onPick(s.k);
                    }}>
                        <DkStkImg s={s}/>
                        <span>{s.t}</span>
                    </div>
                ))}
            </div>
        </>
    );
};

// Таймер хода в онлайне: 15 с считает сервер, здесь только полоска
const DkTimer = ({t}) => {
    const [left, setLeft] = useState(t.total);
    const warned = useRef(false);
    useEffect(() => {
        warned.current = false;
        let raf;
        const tick = () => {
            const l = Math.max(0, (t.deadline - performance.now()) / 1000);
            setLeft(l);
            if (t.by === 'p' && l < 5 && !warned.current) { warned.current = true; gHaptic('warning'); }
            if (l > 0) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [t.deadline, t.by]);
    const hot = left < 5;
    return (
        <div className={'dk-timer ' + t.by + (hot ? ' hot' : '')}>
            <i style={{transform: 'scaleX(' + (left / t.total) + ')'}}/>
            <span>{t.by === 'p' ? 'Твой ход' : 'Ход соперника'} · {Math.ceil(left)} с</span>
        </div>
    );
};

// ─ Игровой стол: общий для игры с компьютером и онлайн ─
// g: {phase, trump, trumpCard, deckCount, discard, hand, oppCount, table,
//     attacker 'p'|'a', taking 'p'|'a'|null, limit, result}
const DurakBoard = ({g, anim, say, locked, onPlay, onBito, onTake, onDone, onBack, oppName, oppOnline, waitText, over, toast, emote, onEmote, timer}) => {
    const [selId, setSelId] = useState(null);
    const [tray, setTray] = useState(false);
    const stk = useDkStickers();
    const stkAt = useRef(0);
    const sendStk = (k) => {
        setTray(false);
        if (Date.now() - stkAt.current < 2000) { gHaptic('warning'); return; }
        stkAt.current = Date.now(); gHaptic('light'); onEmote(k);
    };
    const drag = useRef(null);

    const undefended = g.table.find(p => !p.def);
    const pTurnAtk = g.attacker === 'p' && (!undefended || g.taking === 'a');
    const pTurnDef = g.attacker === 'a' && !!undefended && !g.taking;
    const playable = (c) => {
        if (g.phase !== 'play' || anim || locked) return false;
        if (pTurnAtk) return dkCanThrow(g, c);
        if (pTurnDef) return dkBeats(undefended.atk.card, c, g.trump);
        return false;
    };
    const hand = dkSort(g.hand, g.trump);
    const handW = Math.min(window.innerWidth, 480) - 64;
    const cw = 84;
    const step = hand.length > 1 ? Math.min(cw * 0.78, (handW - cw) / (hand.length - 1)) : 0;
    const handTotal = cw + step * Math.max(0, hand.length - 1);
    const mid = (hand.length - 1) / 2;
    const selCard = hand.find(c => c.id === selId && playable(c));

    const play = (c) => { setSelId(null); onPlay(c); };
    // тап — поднять карту, второй тап или тап по столу — сходить; можно смахнуть вверх
    const onCardDown = (c, e) => {
        if (!playable(c)) { gHaptic('warning'); return; }
        drag.current = {id: c.id, x0: e.clientX, y0: e.clientY, el: e.currentTarget, moved: false, dx: 0, dy: 0};
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_) {}
    };
    const onCardMove = (e) => {
        const d = drag.current; if (!d) return;
        d.dx = e.clientX - d.x0; d.dy = e.clientY - d.y0;
        if (!d.moved && Math.hypot(d.dx, d.dy) > 8) d.moved = true;
        if (d.moved) { d.el.style.transition = 'none'; d.el.style.transform = 'translate(' + d.dx + 'px,' + d.dy + 'px) scale(1.1)'; d.el.style.zIndex = 99; }
    };
    const onCardUp = (c) => {
        const d = drag.current; drag.current = null;
        if (!d) return;
        d.el.style.transition = ''; d.el.style.transform = ''; d.el.style.zIndex = '';
        // тап — карта сразу ложится на стол (так быстрее, правка Егора 24.09);
        // смахивание вверх тоже работает
        if (d.moved) { if (d.dy < -60) play(c); return; }
        play(c);
    };

    let msg = '';
    if (g.phase !== 'play') msg = '';
    else if (g.taking === 'a') msg = 'Соперник берёт — можешь подкинуть';
    else if (g.taking === 'p') msg = 'Забираешь карты…';
    else if (pTurnAtk) msg = g.table.length ? 'Подкинь карту или скажи «Бито»' : 'Твой ход — нажми на карту';
    else if (pTurnDef) msg = 'Отбейся старшей картой той же масти или козырем';
    else msg = waitText || 'Соперник думает…';

    return (
        <div className="page-container flex-layout gm-page dk-page dk-table">
            <GameTop title="Дурак" onBack={onBack} right={<span className="dk-trump-chip">Козырь <b className={DK_RED[g.trump] ? 'red' : ''}>{g.trump}</b></span>}/>

            <div className="dk-opp">
                <div className="dk-opp-hand">
                    {Array.from({length: Math.min(12, g.oppCount)}).map((_, i) => <DkCard key={i} back size="s" style={{marginLeft: i ? -30 : 0, '--r': ((i - g.oppCount / 2) * 3) + 'deg'}}/>)}
                </div>
                <div className="dk-opp-cap">
                    {oppOnline !== undefined && <i className={'dk-dot' + (oppOnline ? ' on' : '')}/>}
                    {oppName || 'Соперник'} · {g.oppCount}
                </div>
                {say && <div key={say.k} className="dk-say">{say.text}</div>}
            </div>

            <div className="dk-mid">
                <div className="dk-deck">
                    {g.deckCount > 0 ? <>
                        {/* козырь лежит поперёк под колодой, как в настоящей игре;
                            повёрнут так, что угол с достоинством и мастью смотрит наружу */}
                        <DkCard c={g.trumpCard} size="t" style={{position: 'absolute', left: 14, top: 30, '--r': '90deg'}}/>
                        {g.deckCount > 1 && <DkCard back size="s" style={{position: 'absolute', left: 26, top: 0}}/>}
                        <div className="dk-deck-n">{g.deckCount}</div>
                    </> : <div className={'dk-deck-empty' + (DK_RED[g.trump] ? ' red' : '')}>{g.trump}</div>}
                    {g.discard > 0 && <div className="dk-bito">бито {g.discard}</div>}
                </div>
                <div className={'dk-field' + (anim ? ' ' + anim : '') + (selCard ? ' drop' : '')} onClick={() => { if (selCard) play(selCard); }}>
                    {g.table.map((p, i) => (
                        <div key={p.atk.card.id} className="dk-pair">
                            <DkCard c={p.atk.card} size="t" anim={p.atk.by === 'p' ? 'in-up' : 'in-down'} style={{'--r': ((i % 3) - 1) * 4 + 'deg'}}/>
                            {p.def && <DkCard c={p.def.card} size="t" anim={'def ' + (p.def.by === 'p' ? 'in-up' : 'in-down')} style={{'--r': '14deg'}}/>}
                        </div>
                    ))}
                    {!g.table.length && g.phase === 'play' && <div className="dk-field-empty">{g.attacker === 'p' ? 'Твой ход' : 'Ход соперника'}</div>}
                </div>
            </div>

            {timer && g.phase === 'play' && <DkTimer t={timer}/>}
            <div className="dk-bar">
                {onEmote && <div className="dk-emo-btn" onClick={() => setTray(t => !t)} aria-label="Стикеры">💬</div>}
                <div className="dk-msg">{msg}</div>
                <div className="dk-actions">
                    {!locked && pTurnAtk && !g.taking && g.table.length > 0 && !undefended && <div className="gm-btn sm" onClick={onBito}>Бито</div>}
                    {!locked && pTurnDef && <div className="gm-btn sm ghost" onClick={onTake}>Беру</div>}
                    {!locked && g.taking === 'a' && <div className="gm-btn sm" onClick={onDone}>Забирай</div>}
                </div>
            </div>

            <div className="dk-hand" style={{width: handTotal}}>
                {hand.map((c, i) => {
                    const ok = playable(c);
                    const off = i - mid;
                    return <DkCard key={c.id} c={c} size="m" anim="deal"
                                   dim={!ok && g.phase === 'play' && (pTurnAtk || pTurnDef)}
                                   sel={ok && selId === c.id}
                                   onPointerDown={e => onCardDown(c, e)} onPointerMove={onCardMove}
                                   onPointerUp={() => onCardUp(c)} onPointerCancel={() => onCardUp(c)}
                                   style={{left: i * step, zIndex: i, '--r': (off * Math.min(4, 28 / hand.length)) + 'deg', '--y': (off * off * 1.6) + 'px'}}/>;
                })}
            </div>

            {emote && <DkEmote key={emote.key} e={emote} list={stk}/>}
            {tray && <DkStkTray list={stk} onPick={sendStk} onClose={() => setTray(false)}/>}
            {toast && <div key={toast.k} className="dk-toast">{toast.text}</div>}

            {over && (
                <div className="dk-over">
                    <div className="dk-over-card">
                        <div className="dk-over-emoji">{over.emoji}</div>
                        <div className="gm-result-big small">{over.title}</div>
                        <div className="gm-result-s">{over.text}</div>
                        <div className="gm-row">
                            {over.primary && <div className={'gm-btn' + (over.primary.off ? ' off' : '')} onClick={over.primary.on}>{over.primary.label}</div>}
                            <div className="gm-btn ghost" onClick={over.secondary.on}>{over.secondary.label}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const dkOverText = (result, opts = {}) => ({
    emoji: result === 'win' ? '🏆' : result === 'draw' ? '🤝' : '🃏',
    title: result === 'win' ? 'ПОБЕДА' : result === 'draw' ? 'НИЧЬЯ' : 'ТЫ — ДУРАК',
    text: opts.timeout === 'a' ? 'Соперник трижды не успел походить — победа твоя.'
        : opts.timeout === 'p' ? 'Три хода подряд без ответа — засчитано поражение.'
        : opts.left ? 'Соперник вышел из партии — победа засчитана тебе.'
        : result === 'win' ? 'Скинул все карты первым. Чистый выезд с поула.'
        : result === 'draw' ? 'Оба вышли одновременно — фото-финиш.' : 'Соперник вышел раньше. Реванш?',
});

// ─ Против компьютера ─
const DK_AI_MS = 60;   // сколько бот думает над ходом, мс (на слабом телефоне — столько же, просто считает меньше вариантов)
const dkDraw = (s, who) => {
    const hands = {...s.hands};
    const deck = [...s.deck];
    const h = [...hands[who]];
    let known = s.known;
    while (h.length < 6 && deck.length) {
        const c = deck.shift();
        // открытый козырь под колодой: все видели, кому он достался
        if (known && s.trumpCard && c.id === s.trumpCard.id) known = {...known, [who]: [...known[who], c.id]};
        h.push(c);
    }
    hands[who] = h;
    return {...s, hands, deck, known};
};
const dkOver = (s) => {
    if (s.deck.length) return s;
    const pe = !s.hands.p.length, ae = !s.hands.a.length;
    if (pe && ae) return {...s, phase: 'over', result: 'draw'};
    if (pe) return {...s, phase: 'over', result: 'win'};
    if (ae) return {...s, phase: 'over', result: 'lose'};
    return s;
};

const DurakLocal = ({deckSrc, onExit}) => {
    const [g, setG] = useState(null);
    const [anim, setAnim] = useState(null);
    const [say, setSay] = useState(null);
    const [emote, setEmote] = useState(null);
    const [sent, setSent] = useState(false);
    const gRef = useRef(null);
    const busy = useRef(false);
    const commit = (s) => { gRef.current = s; setG(s); };
    const speak = (text) => setSay({text, k: Date.now()});
    // бот иногда отвечает стикером — чтобы реакции было видно и без друга
    const botStk = (pool, chance = 0.35, delay = 500) => {
        if (Math.random() > chance) return;
        setTimeout(() => setEmote({k: pool[gmRand(pool.length)], by: 'a', key: Date.now()}), delay);
    };
    const myEmote = (k) => {
        setEmote({k, by: 'p', key: Date.now()});
        botStk(DK_STK.map(x => x.k), 0.4, 1600);
    };

    const deal = () => {
        const deck = dkShuffle(deckSrc);
        const hp = deck.splice(0, 6), ha = deck.splice(0, 6);
        const trumpCard = deck[deck.length - 1];
        const trump = trumpCard.suit;
        const low = h => Math.min(...h.filter(c => c.suit === trump).map(c => c.rank), 99);
        const attacker = low(hp) <= low(ha) ? 'p' : 'a';
        setSent(false); setAnim(null); setSay(null); busy.current = false;
        commit({deck, trump, trumpCard, hands: {p: hp, a: ha}, table: [], attacker, phase: 'play', limit: 6, taking: null, discard: 0, result: null,
            gone: [], known: {p: [], a: []}});
        gHaptic('medium');
    };
    useEffect(deal, []);

    const endBout = (kind) => {
        const s = gRef.current;
        if (!s || busy.current) return;
        busy.current = true;
        const defender = s.attacker === 'p' ? 'a' : 'p';
        setAnim(kind === 'bito' ? 'bito' : ('take-' + defender));
        setTimeout(() => {
            let ns = {...gRef.current};
            const cards = ns.table.flatMap(p => p.def ? [p.atk.card, p.def.card] : [p.atk.card]);
            if (kind === 'bito') {
                ns = {...ns, discard: ns.discard + cards.length, gone: [...(ns.gone || []), ...cards], table: []};
                ns = dkDraw(ns, ns.attacker); ns = dkDraw(ns, defender);
                ns.attacker = defender;
            } else {
                const kn = ns.known || {p: [], a: []};
                ns = {...ns, hands: {...ns.hands, [defender]: [...ns.hands[defender], ...cards]}, table: [],
                    known: {...kn, [defender]: [...kn[defender], ...cards.map(c => c.id)]}};
                ns = dkDraw(ns, ns.attacker); ns = dkDraw(ns, defender);
            }
            ns.taking = null; ns.dumped = false; ns.limit = 6;
            ns = dkOver(ns);
            setAnim(null); busy.current = false;
            commit(ns);
        }, 420);
    };

    const afterDefend = (s) => {
        const defender = s.attacker === 'p' ? 'a' : 'p';
        const allDef = s.table.every(p => p.def);
        const cap = s.table.length >= s.limit;
        const noMoreCards = !s.hands[s.attacker].length || !s.hands[defender].length;
        if (allDef && (cap || noMoreCards)) setTimeout(() => endBout('bito'), 450);
    };

    const playerTap = (card) => {
        const s = gRef.current;
        if (!s || s.phase !== 'play' || busy.current || anim) return;
        const undefended = s.table.find(p => !p.def);
        if (s.attacker === 'p') {
            if (undefended && !s.taking) return;
            if (!dkCanThrow(s, card)) { gHaptic('warning'); return; }
            const limit = s.table.length ? s.limit : Math.min(6, s.hands.a.length);
            const ns = {...s, limit, hands: {...s.hands, p: s.hands.p.filter(c => c.id !== card.id)},
                table: [...s.table, {atk: {card, by: 'p'}, def: null}]};
            commit(ns); gHaptic('light');
            if (ns.taking === 'a' && (ns.table.length >= ns.limit || !ns.hands.p.length)) setTimeout(() => endBout('take'), 500);
        } else {
            if (!undefended) return;
            if (!dkBeats(undefended.atk.card, card, s.trump)) { gHaptic('warning'); return; }
            const table = s.table.map(p => p === undefended ? {...p, def: {card, by: 'p'}} : p);
            const ns = {...s, table, hands: {...s.hands, p: s.hands.p.filter(c => c.id !== card.id)}};
            commit(ns); gHaptic('light');
            afterDefend(ns);
        }
    };
    const playerBito = () => { const s = gRef.current; if (s && s.attacker === 'p' && s.table.length && s.table.every(p => p.def)) endBout('bito'); };
    const playerTake = () => {
        const s = gRef.current;
        if (!s || s.attacker !== 'a' || !s.table.some(p => !p.def) || s.taking) return;
        commit({...s, taking: 'p'}); speak('Подкидываю'); gHaptic('medium'); botStk(DK_STK_MOCK, 0.3, 900);
    };
    const playerGiveUp = () => { const s = gRef.current; if (s && s.taking === 'a') endBout('take'); };

    // ход компьютера
    useEffect(() => {
        const s = g;
        if (!s || s.phase !== 'play' || busy.current || anim) return;
        const undefended = s.table.find(p => !p.def);
        let job = null;
        if (s.attacker === 'p' && undefended && !s.taking) {
            job = setTimeout(() => {
                const cur = gRef.current; if (cur !== s || busy.current) return;
                const mv = dkAI.decide(s, 'a', DK_AI_MS);
                const pick = mv.kind === 'defend' ? mv.card : null;
                if (!pick) { commit({...s, taking: 'a'}); speak('Беру'); gHaptic('medium'); botStk(DK_STK_SAD, 0.3, 900); return; }
                const table = s.table.map(p => p === undefended ? {...p, def: {card: pick, by: 'a'}} : p);
                const ns = {...s, table, hands: {...s.hands, a: s.hands.a.filter(c => c.id !== pick.id)}};
                commit(ns); afterDefend(ns);
            }, 750);
        } else if (s.attacker === 'a' && !undefended && s.taking !== 'a') {
            job = setTimeout(() => {
                const cur = gRef.current; if (cur !== s || busy.current) return;
                const mv = dkAI.decide(s, 'a', DK_AI_MS);
                const pick = mv.kind === 'attack' ? mv.card : null;
                if (!pick) { if (s.table.length) { speak('Бито'); endBout('bito'); } return; }
                const limit = s.table.length ? s.limit : Math.min(6, s.hands.p.length);
                commit({...s, limit, hands: {...s.hands, a: s.hands.a.filter(c => c.id !== pick.id)},
                    table: [...s.table, {atk: {card: pick, by: 'a'}, def: null}]});
            }, s.table.length ? 650 : 900);
        } else if (s.attacker === 'a' && s.taking === 'p') {
            job = setTimeout(() => {
                const cur = gRef.current; if (cur !== s || busy.current) return;
                if (s.dumped) { endBout('take'); return; }
                const mv = dkAI.decide(s, 'a', DK_AI_MS);
                const extra = (mv.cards || []).slice(0, Math.max(0, s.limit - s.table.length));
                if (!extra.length) { endBout('take'); return; }
                const ids = new Set(extra.map(c => c.id));
                commit({...s, dumped: true, hands: {...s.hands, a: s.hands.a.filter(c => !ids.has(c.id))},
                    table: [...s.table, ...extra.map(card => ({atk: {card, by: 'a'}, def: null}))]});
            }, s.dumped ? 650 : 700);
        }
        return () => job && clearTimeout(job);
    }, [g, anim]);

    useEffect(() => {
        if (g?.phase === 'over' && !sent) {
            setSent(true);
            gHaptic(g.result === 'win' ? 'success' : 'error');
            gmPostResult({game_type: 'durak', score: g.result === 'win' ? 1 : 0, details: g.result});
            botStk(g.result === 'win' ? DK_STK_SAD : DK_STK_WIN, 0.8, 300);
        }
    }, [g, sent]);
    useEffect(() => { if (!say) return; const t = setTimeout(() => setSay(null), 1400); return () => clearTimeout(t); }, [say]);
    useEffect(() => { if (!emote) return; const t = setTimeout(() => setEmote(null), 2000); return () => clearTimeout(t); }, [emote]);

    if (!g) return null;
    const board = {phase: g.phase, trump: g.trump, trumpCard: g.trumpCard, deckCount: g.deck.length, discard: g.discard,
        hand: g.hands.p, oppCount: g.hands.a.length, table: g.table, attacker: g.attacker, taking: g.taking, limit: g.limit, result: g.result};
    const over = g.phase === 'over' ? {...dkOverText(g.result),
        primary: {label: 'Ещё партию', on: deal}, secondary: {label: 'Выйти', on: onExit}} : null;
    return <DurakBoard g={board} anim={anim} say={say} onPlay={playerTap} onBito={playerBito} onTake={playerTake}
                       onDone={playerGiveUp} onBack={onExit} oppName="F1 Hub" waitText="F1 Hub думает…" over={over}
                       emote={emote} onEmote={myEmote}/>;
};

// ─ Онлайн: комната на сервере ─
const DurakOnline = ({initial, onExit}) => {
    const [v, setV] = useState(initial);
    const [anim, setAnim] = useState(null);
    const [say, setSay] = useState(null);
    const [toast, setToast] = useState(null);
    const [emote, setEmote] = useState(null);
    const [timer, setTimer] = useState(null);
    const [locked, setLocked] = useState(false);
    const [shareMsg, setShareMsg] = useState('');
    const vRef = useRef(initial);
    const alive = useRef(true);
    const code = initial.code;
    const note = (text) => setToast({text, k: Date.now()});

    // новое состояние с сервера: если стол опустел — сначала анимация улёта карт
    const apply = (nv) => {
        const prev = vRef.current;
        if (!nv || (prev && nv.v <= prev.v && nv.phase === prev.phase)) return;
        vRef.current = nv;
        if (nv.turn) setTimer({by: nv.turn.by, total: nv.turn.total, deadline: performance.now() + nv.turn.left * 1000});
        else setTimer(null);
        if (prev && nv.auto && nv.v !== prev.v) note(nv.auto === 'p' ? 'Время вышло — сходили за тебя' : 'Соперник не успел — ход сделан за него');
        // свой стикер уже показан сразу по нажатию — тут только стикеры соперника
        if (prev && nv.emote && nv.emote.by === 'a' && nv.emote.n !== prev.emote?.n) { setEmote({...nv.emote, key: Date.now()}); gHaptic('light'); }
        if (nv.last?.by === 'a') {
            if (nv.last.kind === 'taking') setSay({text: 'Беру', k: Date.now()});
            if (nv.last.kind === 'bito') setSay({text: 'Бито', k: Date.now()});
        }
        if (prev?.phase === 'waiting' && nv.phase === 'play') gHaptic('success');
        if (prev?.table?.length && nv.table && !nv.table.length && (nv.last?.kind === 'bito' || nv.last?.kind === 'take')) {
            setAnim(nv.last.kind === 'bito' ? 'bito' : ('take-' + nv.last.by));
            setTimeout(() => { setAnim(null); setV(vRef.current); }, 420);
        } else {
            setV(nv);
        }
        if (nv.phase === 'play' && prev?.phase === 'play' && nv.attacker !== prev.attacker && nv.attacker === 'p') gHaptic('light');
    };

    // long-poll: сервер держит запрос до 20 с, пока не случится ход
    useEffect(() => {
        alive.current = true;
        (async () => {
            while (alive.current) {
                const cur = vRef.current;
                const r = await dkReq('GET', '/api/durak/rooms/' + code + '?v=' + (cur?.v || 0));
                if (!alive.current) break;
                if (r.ok) apply(r.data);
                else if (r.status === 404) { note('Комната закрыта'); await new Promise(z => setTimeout(z, 3000)); }
                else await new Promise(z => setTimeout(z, 1500));
            }
        })();
        return () => { alive.current = false; };
    }, [code]);

    useEffect(() => { if (!say) return; const t = setTimeout(() => setSay(null), 1400); return () => clearTimeout(t); }, [say]);
    useEffect(() => { if (!toast) return; const t = setTimeout(() => setToast(null), 2200); return () => clearTimeout(t); }, [toast]);
    useEffect(() => { if (!emote) return; const t = setTimeout(() => setEmote(null), 2000); return () => clearTimeout(t); }, [emote]);
    // стикер не блокирует ходы: отдельный запрос без locked
    const sendEmote = async (k) => {
        setEmote({k, by: 'p', key: Date.now()});
        const r = await dkReq('POST', '/api/durak/rooms/' + code + '/action', {type: 'emote', card: k});
        if (r.ok) apply(r.data);
    };
    useEffect(() => { if (v.phase === 'over' && v.result) gHaptic(v.result === 'win' ? 'success' : 'error'); }, [v.phase]);

    const send = async (type, card) => {
        if (locked) return;
        setLocked(true);
        const r = await dkReq('POST', '/api/durak/rooms/' + code + '/action', {type, card: card?.id});
        setLocked(false);
        if (r.ok) { apply(r.data); if (type === 'play') gHaptic('light'); }
        else { note(r.error); gHaptic('warning'); }
    };

    const leave = async () => {
        if (v.phase === 'play') {
            const ok = window.confirm('Выйти из партии? Соперник получит победу.');
            if (!ok) return;
        }
        alive.current = false;
        dkReq('POST', '/api/durak/rooms/' + code + '/action', {type: 'leave'});
        onExit();
    };

    const share = async () => {
        const r = await dkShare(code);
        setShareMsg(r === 'copied' ? 'Ссылка скопирована — отправь другу' : r === 'fail' ? 'Отправь другу код комнаты' : '');
    };

    if (v.phase === 'waiting' || v.phase === 'closed') return (
        <div className="page-container fade-in gm-page dk-page">
            <GameTop title="Дурак онлайн" onBack={leave}/>
            <div className="gm-intro">
                <div className="gm-h">Комната создана</div>
                <div className="gm-p">Отправь другу приглашение — он откроет его в Telegram и сразу окажется за столом. Или пусть введёт код в игре.</div>
                <div className="dk-code">{code.split('').map((ch, i) => <span key={i}>{ch}</span>)}</div>
                <div className="gm-row">
                    <div className="gm-btn" onClick={share}>Пригласить друга</div>
                </div>
                {shareMsg && <div className="gm-hint">{shareMsg}</div>}
                <div className="dk-wait"><i/><i/><i/> Ждём соперника</div>
            </div>
            {toast && <div key={toast.k} className="dk-toast">{toast.text}</div>}
        </div>
    );

    const board = {phase: v.phase, trump: v.trump, trumpCard: v.trump_card, deckCount: v.deck_count, discard: v.discard,
        hand: v.hand || [], oppCount: v.opp_count || 0, table: v.table || [], attacker: v.attacker, taking: v.taking,
        limit: v.limit, result: v.result};
    const over = v.phase === 'over' ? {...dkOverText(v.result, {left: v.left, timeout: v.timeout}),
        primary: v.left ? null : {label: v.rematch_me ? (v.rematch_opp ? 'Раздаём…' : 'Ждём соперника…') : (v.rematch_opp ? 'Принять реванш' : 'Реванш'),
            off: v.rematch_me, on: () => send('rematch')},
        secondary: {label: 'Выйти', on: () => { alive.current = false; onExit(); }}} : null;
    return <DurakBoard g={board} anim={anim} say={say} locked={locked} toast={toast}
                       onPlay={c => send('play', c)} onBito={() => send('bito')} onTake={() => send('take')} onDone={() => send('done')}
                       onBack={leave} oppName={v.opp_name || 'Соперник'} oppOnline={v.opp_online}
                       waitText={v.opp_online ? 'Ход соперника…' : 'Соперник не в сети — ждём'} over={over}
                       emote={emote} onEmote={sendEmote} timer={timer}/>;
};

// ─ Меню: с компьютером / с другом / по коду ─
const DurakGame = ({onBack}) => {
    const [deckSrc, setDeckSrc] = useState(null);
    const [err, setErr] = useState(false);
    const [mode, setMode] = useState(null);          // null | 'local' | 'online'
    const [room, setRoom] = useState(null);
    const [joinCode, setJoinCode] = useState('');
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState('');

    const load = () => {
        setErr(false);
        Promise.all([api.get('/api/standings/drivers?season=2026'), api.get('/api/standings/constructors?season=2026')])
            .then(([d, t]) => {
                const drivers = (d?.standings || d || []).slice().sort((a, b) => (+a.position || 99) - (+b.position || 99));
                const teams = (t?.standings || t || []).slice().sort((a, b) => (+a.position || 99) - (+b.position || 99));
                if (drivers.length < 10 || teams.length < 4) { setErr(true); return; }
                const deck = dkBuildDeck(drivers, teams);
                dkPreload(deck);          // фото — заранее, пока человек читает меню
                setDeckSrc(deck);
            });
    };
    useEffect(load, []);

    const create = async () => {
        if (dkNeedLogin()) { setMsg('Игра с другом — после входа'); return; }
        setBusy(true); setMsg('');
        const r = await dkReq('POST', '/api/durak/rooms');
        setBusy(false);
        if (r.ok) { setRoom(r.data); setMode('online'); } else setMsg(r.error);
    };
    const join = async (codeIn) => {
        const c = String(codeIn || joinCode).toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (c.length !== 6) { setMsg('Код комнаты — 6 символов'); return; }
        if (dkNeedLogin()) { setMsg('Чтобы сесть за стол с другом, войдите'); return; }
        setBusy(true); setMsg('');
        const r = await dkReq('POST', '/api/durak/rooms/' + c + '/join');
        setBusy(false);
        if (r.ok) { if (r.data.hand) dkPreload(r.data.hand); setRoom(r.data); setMode('online'); } else setMsg(r.error);
    };
    // пришли по приглашению — сразу садимся за стол
    useEffect(() => { if (DURAK_INVITE && !_dkInviteUsed) { _dkInviteUsed = true; join(DURAK_INVITE); } }, []);

    const exit = () => { setMode(null); setRoom(null); };
    if (mode === 'local' && deckSrc) return <DurakLocal deckSrc={deckSrc} onExit={exit}/>;
    if (mode === 'online' && room) return <DurakOnline initial={room} onExit={exit}/>;

    return (
        <div className="page-container fade-in gm-page dk-page">
            <GameTop title="Дурак" onBack={onBack}/>
            <div className="gm-intro">
                <div className="dk-hero">
                    {deckSrc ? [deckSrc[0], deckSrc[4], deckSrc[8]].map((c, i) => <DkCard key={c.id} c={c} size="l" style={{'--r': (i - 1) * 10 + 'deg', '--x': (i - 1) * 74 + 'px', '--hy': (i === 1 ? 0 : 14) + 'px'}}/>)
                        : <div className="dk-hero-empty">{err ? 'Не удалось загрузить карты' : 'Раздаём…'}</div>}
                </div>
                <div className="gm-h">Подкидной дурак</div>
                <div className="gm-p">36 карт, сила карты — место в чемпионате: <b>тузы</b> — лучшие команды, <b>короли</b> — лидеры личного зачёта, дальше по местам.</div>
                {err ? <div className="gm-btn" onClick={load}>Попробовать ещё раз</div> : (
                    <div className="dk-menu">
                        <div className={'gm-btn' + (deckSrc ? '' : ' off')} onClick={() => setMode('local')}>Играть с компьютером</div>
                        {dkNeedLogin() ? (
                            <div className="dk-login">Игра с другом по коду комнаты — после входа.
                                <a className="gm-btn sm ghost" href={gmHost().loginUrl || '/login'}>Войти</a></div>
                        ) : <>
                        <div className={'gm-btn dk-friend' + (busy ? ' off' : '')} onClick={create}>Играть с другом</div>
                        <div className="dk-join">
                            <input value={joinCode} maxLength={6} placeholder="КОД КОМНАТЫ" autoCapitalize="characters"
                                   onChange={e => setJoinCode(e.target.value.toUpperCase().replace(/[^A-Za-z0-9]/g, ''))}
                                   onKeyDown={e => { if (e.key === 'Enter') join(); }}/>
                            <div className={'gm-btn sm ghost' + (busy ? ' off' : '')} onClick={() => join()}>Войти</div>
                        </div>
                        </>}
                        {msg && <div className="dk-err">{msg}</div>}
                    </div>
                )}
            </div>
        </div>
    );
};


// ═══════════════════ ИГРЫ-УГАДАЙКИ И СТРАТЕГИЯ (24.09.2026) ═══════════════════
// Пилот дня, карьера, трасса, больше/меньше, пит-уолл, менеджер, квиз.
// История сезонов 1980–2025 — static/games/f1hist.json (build_f1hist.py,
// источник Jolpica); текущий сезон — живой API.

// склонение: plural(3, 'круг', 'круга', 'кругов')
const plural = (n, one, few, many) => { const a = Math.abs(n) % 100, b = a % 10; return a > 10 && a < 20 ? many : b > 1 && b < 5 ? few : b === 1 ? one : many; };

const GM_HIST_URL = '/static/games/f1hist.json?v=20260924';
let _gmHist = null, _gmGrid = null, _gmSched = null;
const gmHist = () => _gmHist || (_gmHist = fetch(GM_HIST_URL).then(r => r.ok ? r.json() : null).catch(() => null)
    .then(x => { if (!x) _gmHist = null; return x; }));
const gmByPos = (a, b) => (+a.position || 99) - (+b.position || 99);
const gmGrid = () => _gmGrid || (_gmGrid = Promise.all([api.get('/api/standings/drivers?season=2026'), api.get('/api/standings/constructors?season=2026')])
    .then(([d, t]) => {
        const drivers = (d?.standings || []).slice().sort(gmByPos);
        const teams = (t?.standings || t || []).slice().sort(gmByPos);
        if (drivers.length < 10) { _gmGrid = null; return null; }
        return {drivers, teams};
    }));
const gmSched = () => _gmSched || (_gmSched = api.get('/api/schedule').then(d => { const r = (d?.races || []).filter(x => x.round); if (!r.length) _gmSched = null; return r.length ? r : null; }));

// загрузка данных игры: undefined — грузится, null — ошибка
const useGm = (loaders) => {
    const [v, setV] = useState(undefined);
    const [k, setK] = useState(0);
    useEffect(() => {
        let alive = true;
        setV(undefined);
        Promise.all(loaders.map(f => f())).then(r => { if (alive) setV(r.some(x => !x) ? null : r); });
        return () => { alive = false; };
    }, [k]);
    return [v, () => setK(x => x + 1)];
};

const GmLoading = ({title, onBack, data, retry}) => (
    <div className="page-container fade-in gm-page">
        <GameTop title={title} onBack={onBack}/>
        <div className="gm-intro">
            {data === null
                ? <><div className="gm-p">Не удалось загрузить данные для игры.</div><div className="gm-btn" onClick={retry}>Попробовать ещё раз</div></>
                : <div className="gm-loading"><i/><i/><i/></div>}
        </div>
    </div>
);

const GM_NAT = {British: 'Великобритания', German: 'Германия', Spanish: 'Испания', French: 'Франция', Italian: 'Италия', Dutch: 'Нидерланды',
    Finnish: 'Финляндия', Brazilian: 'Бразилия', Australian: 'Австралия', Mexican: 'Мексика', Canadian: 'Канада', Monegasque: 'Монако',
    Thai: 'Таиланд', Japanese: 'Япония', Danish: 'Дания', 'New Zealander': 'Новая Зеландия', American: 'США', Argentine: 'Аргентина',
    Austrian: 'Австрия', Belgian: 'Бельгия', Swiss: 'Швейцария', Swedish: 'Швеция', Polish: 'Польша', Russian: 'Россия', Chinese: 'Китай',
    Colombian: 'Колумбия', Venezuelan: 'Венесуэла', Indonesian: 'Индонезия', Indian: 'Индия', Portuguese: 'Португалия', Irish: 'Ирландия',
    Hungarian: 'Венгрия', Czech: 'Чехия', 'South African': 'ЮАР', Chilean: 'Чили', Malaysian: 'Малайзия', Estonian: 'Эстония'};
const gmNat = (n) => GM_NAT[n] || n || '—';
// в узкой клетке длинные названия переносились по буквам
const GM_NAT_SHORT = {British: 'Британия', 'New Zealander': 'Н. Зеландия', Dutch: 'Нидерл.', Venezuelan: 'Венесуэла', Indonesian: 'Индонезия', 'South African': 'ЮАР', American: 'США'};
const gmNatShort = (n) => GM_NAT_SHORT[n] || gmNat(n);
const gmTeam = (n) => String(n || '').replace(/ F1 Team$/, '').replace(/^Scuderia /, '').replace(/ Racing$/, '').trim();
const GM_CITY = {albert_park: 'Мельбурн', shanghai: 'Шанхай', suzuka: 'Судзука', miami: 'Майами', villeneuve: 'Монреаль', monaco: 'Монако',
    catalunya: 'Барселона', red_bull_ring: 'Шпильберг', silverstone: 'Сильверстоун', spa: 'Спа', hungaroring: 'Будапешт', zandvoort: 'Зандвоорт',
    monza: 'Монца', madring: 'Мадрид', baku: 'Баку', sepang: 'Куала-Лумпур', marina_bay: 'Сингапур', americas: 'Остин', rodriguez: 'Мехико',
    interlagos: 'Сан-Паулу', vegas: 'Лас-Вегас', losail: 'Лусаил', yas_marina: 'Абу-Даби', bahrain: 'Сахир', jeddah: 'Джидда', imola: 'Имола'};
const gmRand = (n) => Math.floor(Math.random() * n);
const gmShuffle = (a) => { const b = [...a]; for (let i = b.length - 1; i > 0; i--) { const j = gmRand(i + 1); [b[i], b[j]] = [b[j], b[i]]; } return b; };
const gmPickN = (a, n, not = []) => gmShuffle(a.filter(x => !not.includes(x))).slice(0, n);
// номер дня по Москве — одна загадка на всех
const gmDay = () => Math.floor((Date.now() + 3 * 3600e3) / 864e5);
const gmUntilTomorrow = () => { const ms = 864e5 - ((Date.now() + 3 * 3600e3) % 864e5); const h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4); return h + ' ч ' + m + ' мин'; };
const gmLS = {
    get: (k, d) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
};

// ─ Пилоты: история 1980–2025 + текущий сезон ─
const gmDrivers = (hist, grid) => {
    const by = {};
    Object.entries(hist.seasons).forEach(([y, s]) => s.drivers.forEach(r => {
        const b = hist.drivers[r.id] || {};
        const d = by[r.id] || (by[r.id] = {id: r.id, first: b.first, last: b.last, nat: b.nat, seasons: [], wins: 0, best: 99});
        d.seasons.push({y: +y, teams: r.teams.map(gmTeam)});
        d.wins += r.wins || 0;
        if (r.pos && r.pos < d.best) d.best = r.pos;
        if (r.pos === 1) d.titles = (d.titles || 0) + 1;
    }));
    (grid?.drivers || []).forEach(g => {
        const id = g.ergast_id || ('g' + g.driver_number);
        const d = by[id] || (by[id] = {id, first: g.first_name, last: g.last_name, nat: g.nationality, seasons: [], wins: 0, best: 99});
        d.seasons.push({y: 2026, teams: [gmTeam(g.team)]});
        d.wins += +g.wins || 0;
        d.onGrid = true; d.photo = g.photo_url; d.color = g.team_color; d.num = g.driver_number;
    });
    Object.values(by).forEach(d => {
        d.seasons.sort((a, b) => a.y - b.y);
        d.debut = d.seasons[0]?.y;
        const last = d.seasons[d.seasons.length - 1];
        d.team = last ? last.teams[last.teams.length - 1] : '';
        d.teamsAll = [...new Set(d.seasons.flatMap(s => s.teams))];
        d.name = ((d.first || '') + ' ' + (d.last || '')).trim();
    });
    return by;
};

// Поиск пилота: латиница или кириллица («хэмилтон» найдёт Hamilton)
const GM_TR = {а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p',
    р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya'};
const gmSkel = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .split('').map(ch => GM_TR[ch] ?? ch).join('')
    .replace(/[^a-z]/g, '').replace(/[aeiouy]/g, '').replace(/v/g, 'f').replace(/[cq]/g, 'k').replace(/z/g, 's').replace(/(.)\1+/g, '$1');
const gmMatch = (d, q) => {
    const low = q.trim().toLowerCase();
    if (!low) return false;
    if (d.name.toLowerCase().includes(low)) return true;
    const sq = gmSkel(low);
    return sq.length >= 2 && (gmSkel(d.last).startsWith(sq) || gmSkel(d.name).includes(sq));
};

const gmStats = (key, day, win, tries) => {
    const s = gmLS.get(key, {played: 0, won: 0, streak: 0, best: 0, last: null, dist: {}});
    if (s.last === day) return s;
    s.played += 1;
    if (win) { s.won += 1; s.streak = s.last === day - 1 ? s.streak + 1 : 1; s.best = Math.max(s.best, s.streak); s.dist[tries] = (s.dist[tries] || 0) + 1; }
    else s.streak = 0;
    s.last = day;
    gmLS.set(key, s);
    return s;
};
const GmStatsView = ({s}) => (
    <div className="gm-stats">
        <div><b>{s.played}</b><span>сыграно</span></div>
        <div><b>{s.played ? Math.round(s.won / s.played * 100) : 0}%</b><span>побед</span></div>
        <div><b>{s.streak}</b><span>серия</span></div>
        <div><b>{s.best}</b><span>лучшая</span></div>
    </div>
);

// Поле поиска стоит НАВЕРХУ экрана, подсказки выпадают поверх контента прямо
// под ним — раньше список рос вниз и уезжал под клавиатуру (жалоба Егора 24.09).
const DriverPicker = ({pool, exclude = [], onPick, placeholder = 'Начни вводить фамилию'}) => {
    const [q, setQ] = useState('');
    const list = q.trim().length >= 2 ? pool.filter(d => !exclude.includes(d.id) && gmMatch(d, q))
        .sort((a, b) => (b.onGrid ? 1 : 0) - (a.onGrid ? 1 : 0) || (b.debut || 0) - (a.debut || 0)).slice(0, 7) : [];
    return (
        <div className="gm-pick">
            <input value={q} onChange={e => setQ(e.target.value)} placeholder={placeholder} autoComplete="off" spellCheck="false"
                   onFocus={e => { const sc = e.target.closest('.page-container'); if (sc) sc.scrollTo({top: 0, behavior: 'smooth'}); }}/>
            {q && <div className="gm-pick-x" onClick={() => setQ('')}>✕</div>}
            {list.length > 0 && (
                <div className="gm-pick-list">
                    {list.map(d => (
                        <div key={d.id} className="gm-pick-row" onClick={() => { setQ(''); onPick(d); }}>
                            {d.photo ? <img src={d.photo} alt=""/> : <i style={{background: d.color || '#2a2a36'}}>{(d.last || '?')[0]}</i>}
                            <div><b>{d.name}</b><span>{d.team} · {d.debut}{d.seasons.length > 1 ? '–' + d.seasons[d.seasons.length - 1].y : ''}</span></div>
                        </div>
                    ))}
                </div>
            )}
            {q.trim().length >= 2 && !list.length && <div className="gm-pick-list empty">Не нашли — попробуй латиницей</div>}
        </div>
    );
};

// Переключатель «Загадка дня / Бесконечно»
const GmModes = ({mode, setMode}) => (
    <div className="gm-modes">
        <div className={mode === 'daily' ? 'on' : ''} onClick={() => setMode('daily')}>Загадка дня</div>
        <div className={mode === 'endless' ? 'on' : ''} onClick={() => setMode('endless')}>Бесконечно</div>
    </div>
);

// Случайный ответ без повторов последних 25
const gmNextRandom = (list, key) => {
    const recent = gmLS.get(key, []);
    const fresh = list.filter(d => !recent.includes(d.id));
    const pick = (fresh.length ? fresh : list)[gmRand((fresh.length ? fresh : list).length)];
    gmLS.set(key, [...recent, pick.id].slice(-25));
    return pick.id;
};

// Общая логика «угадай пилота»: день + бесконечный режим
const useGuessGame = ({answers, keyDay, keyStats, keyRecent, salt, gameType}) => {
    const day = gmDay();
    const [mode, setModeRaw] = useState('daily');
    const [endlessId, setEndlessId] = useState(null);
    const [guesses, setGuesses] = useState([]);
    const [stats, setStats] = useState(null);
    const [endless, setEndless] = useState(() => gmLS.get(keyStats + '_endless', {streak: 0, best: 0, played: 0, won: 0}));
    const dailyAnswer = answers.length ? answers[(day * 9301 + salt) % answers.length] : null;
    const answer = mode === 'daily' ? dailyAnswer : answers.find(a => a.id === endlessId);
    useEffect(() => { if (answers.length && mode === 'daily') setGuesses(gmLS.get(keyDay + day, [])); }, [answers.length]);

    const setMode = (m) => {
        setModeRaw(m);
        if (m === 'daily') setGuesses(gmLS.get(keyDay + day, []));
        else { if (!endlessId || guesses.includes(endlessId)) setEndlessId(gmNextRandom(answers, keyRecent)); setGuesses([]); }
    };
    const nextEndless = () => { setEndlessId(gmNextRandom(answers, keyRecent)); setGuesses([]); setModeRaw('endless'); };
    const solved = !!answer && guesses.includes(answer.id);
    const over = solved || guesses.length >= 6;
    const guess = (d) => {
        if (over || !answer) return;
        const g = [...guesses, d.id];
        setGuesses(g);
        const win = d.id === answer.id;
        gHaptic(win ? 'success' : 'light');
        const done = win || g.length >= 6;
        if (mode === 'daily') {
            gmLS.set(keyDay + day, g);
            if (done) {
                setStats(gmStats(keyStats, day, win, g.length));
                if (!gmLS.get(keyDay + day + '_sent', false)) { gmLS.set(keyDay + day + '_sent', true); gmPostResult({game_type: gameType, score: win ? g.length : 7}); }
            }
        } else if (done) {
            const e = {...endless, played: endless.played + 1, won: endless.won + (win ? 1 : 0), streak: win ? endless.streak + 1 : 0};
            e.best = Math.max(e.best, e.streak);
            setEndless(e); gmLS.set(keyStats + '_endless', e);
        }
    };
    const st = stats || gmLS.get(keyStats, null);
    return {mode, setMode, answer, guesses, guess, solved, over, st, endless, nextEndless};
};

// ─────────────── 1. ПИЛОТ ДНЯ ───────────────
const DLE_COLS = [
    {k: 'nat', label: 'Страна'}, {k: 'team', label: 'Команда'}, {k: 'debut', label: 'Дебют'},
    {k: 'wins', label: 'Победы'}, {k: 'best', label: 'Лучшее место'},
];
const dleCell = (g, a, k) => {
    if (k === 'nat') return {t: gmNatShort(g.nat), c: g.nat === a.nat ? 'ok' : ''};
    if (k === 'team') return {t: g.team, c: g.team === a.team ? 'ok' : (a.teamsAll.includes(g.team) ? 'near' : '')};
    const gv = k === 'best' ? (g.best === 99 ? null : g.best) : g[k];
    const av = k === 'best' ? (a.best === 99 ? null : a.best) : a[k];
    if (gv == null || av == null) return {t: gv == null ? '—' : String(gv), c: gv === av ? 'ok' : ''};
    if (gv === av) return {t: String(gv), c: 'ok'};
    const near = k === 'debut' ? Math.abs(gv - av) <= 2 : k === 'wins' ? Math.abs(gv - av) <= 3 : Math.abs(gv - av) <= 2;
    // у «лучшего места» стрелка про таблицу: ↑ — загаданный был выше (число меньше)
    const up = k === 'best' ? av < gv : av > gv;
    return {t: gv + (up ? ' ↑' : ' ↓'), c: near ? 'near' : ''};
};

const GuessResult = ({solved, guesses, answer, mode, st, endless, onNext, onBack, sub, word}) => (
    <div className="gm-result gm-result-top">
        <div className="gm-result-k">{solved ? 'Угадал с ' + guesses.length + '-й попытки' : 'Загадан был'}</div>
        <div className="dle-answer">
            {answer.photo ? <img src={answer.photo} alt=""/> : <i className="dle-ph">{(answer.last || '?')[0]}</i>}
            <div><b>{answer.name}</b><span>{sub}</span></div>
        </div>
        {mode === 'daily' && st && <GmStatsView s={st}/>}
        {mode === 'endless' && <div className="gm-stats three"><div><b>{endless.streak}</b><span>серия</span></div><div><b>{endless.best}</b><span>лучшая</span></div><div><b>{endless.won}</b><span>угадано</span></div></div>}
        {mode === 'daily' && <div className="gm-hint">Новая загадка дня через {gmUntilTomorrow()}</div>}
        <div className="gm-row">
            <div className="gm-btn" onClick={onNext}>{mode === 'daily' ? 'Играть бесконечно' : 'Следующий ' + word}</div>
            <div className="gm-btn ghost" onClick={onBack}>К играм</div>
        </div>
    </div>
);

const DriverDle = ({onBack}) => {
    const [data, retry] = useGm([gmHist, gmGrid]);
    const db = useMemo(() => data ? gmDrivers(data[0], data[1]) : null, [data]);
    const pool = useMemo(() => db ? Object.values(db).filter(d => d.debut >= 1995 || d.onGrid) : [], [db]);
    const answers = useMemo(() => db ? Object.values(db).filter(d => d.onGrid || d.seasons.some(s => s.y >= 2016)).sort((a, b) => a.id.localeCompare(b.id)) : [], [db]);
    const G = useGuessGame({answers, keyDay: 'gm_dle_', keyStats: 'gm_dle_stats', keyRecent: 'gm_dle_recent', salt: 17, gameType: 'f1dle'});
    if (!db || !G.answer) return <GmLoading title="Пилот дня" onBack={onBack} data={data} retry={retry}/>;
    const a = G.answer;
    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Пилот дня" onBack={onBack} right={<span className="gm-chip">{G.guesses.length} / 6</span>}/>
            <GmModes mode={G.mode} setMode={G.setMode}/>
            {!G.over && <DriverPicker pool={pool} exclude={G.guesses} onPick={G.guess}/>}
            {G.over && <GuessResult {...G} onNext={G.nextEndless} onBack={onBack} word="пилот" sub={a.team + ' · ' + gmNat(a.nat) + ' · побед: ' + a.wins}/>}
            {!G.guesses.length && !G.over && <div className="gm-p left dle-help"><b className="ok-t">Зелёный</b> — совпало, <b className="near-t">жёлтый</b> — близко или пилот ездил за эту команду, стрелка — у загаданного больше или меньше (в «лучшем месте» ↑ — он был выше в таблице).</div>}
            {G.guesses.length > 0 && (
                <div className="dle-grid">
                    <div className="dle-row head">{DLE_COLS.map(c => <div key={c.k}>{c.label}</div>)}</div>
                    {[...G.guesses].reverse().map((id) => { const g = pool.find(x => x.id === id) || db[id]; return (
                        <div key={id} className={'dle-guess' + (id === a.id ? ' win' : '')}>
                            <div className="dle-name">{g.name}</div>
                            <div className="dle-row">
                                {DLE_COLS.map((c, i) => { const cell = dleCell(g, a, c.k); return (
                                    <div key={c.k} className={'dle-cell ' + cell.c} style={{animationDelay: (i * 0.08) + 's'}}>{cell.t}</div>
                                ); })}
                            </div>
                        </div>
                    ); })}
                </div>
            )}
        </div>
    );
};

// ─────────────── 2. КАРЬЕРА ───────────────
const gmStints = (d) => {
    const out = [];
    d.seasons.forEach(s => s.teams.forEach(t => {
        const last = out[out.length - 1];
        if (last && last.team === t && s.y - last.to <= 1) last.to = s.y; else out.push({team: t, from: s.y, to: s.y});
    }));
    return out;
};

const CareerGuess = ({onBack}) => {
    const [data, retry] = useGm([gmHist, gmGrid]);
    const db = useMemo(() => data ? gmDrivers(data[0], data[1]) : null, [data]);
    const pool = useMemo(() => db ? Object.values(db) : [], [db]);
    // загадываем узнаваемых: 5+ сезонов, 2+ команды и победа или место в первой восьмёрке
    const answers = useMemo(() => db ? Object.values(db).filter(d => d.debut >= 1990 && d.seasons.length >= 5 && (d.wins > 0 || d.best <= 8) && new Set(gmStints(d).map(s => s.team)).size >= 2)
        .sort((a, b) => a.id.localeCompare(b.id)) : [], [db]);
    const G = useGuessGame({answers, keyDay: 'gm_car_', keyStats: 'gm_car_stats', keyRecent: 'gm_car_recent', salt: 101, gameType: 'journeyman'});
    if (!db || !G.answer) return <GmLoading title="Карьера" onBack={onBack} data={data} retry={retry}/>;
    const a = G.answer;
    const stints = gmStints(a);
    const shown = G.over ? stints.length : Math.min(stints.length, 1 + G.guesses.length);
    const extra = G.over ? 2 : Math.max(0, 1 + G.guesses.length - stints.length);
    const wrong = G.guesses.filter(id => id !== a.id);
    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Карьера" onBack={onBack} right={<span className="gm-chip">{G.guesses.length} / 6</span>}/>
            <GmModes mode={G.mode} setMode={G.setMode}/>
            {!G.over && <DriverPicker pool={pool} exclude={G.guesses} onPick={G.guess} placeholder="Чья это карьера? Введи фамилию"/>}
            {G.over && <GuessResult {...G} onNext={G.nextEndless} onBack={onBack} word="пилот" sub={gmNat(a.nat) + ' · ' + a.seasons.length + ' ' + plural(a.seasons.length, 'сезон', 'сезона', 'сезонов') + ' · побед: ' + a.wins}/>}
            {wrong.length > 0 && <div className="car-wrong">{wrong.map(id => <span key={id}>{db[id]?.last}</span>)}</div>}
            <div className="car-list">
                {stints.map((s, i) => (
                    <div key={a.id + i} className={'car-stint' + (i < shown ? ' on' : '')}>
                        <span className="car-y">{i < shown ? (s.from === s.to ? s.from : s.from + '–' + s.to) : '????'}</span>
                        <span className="car-t">{i < shown ? s.team : '• • •'}</span>
                    </div>
                ))}
                {extra >= 1 && <div className="car-hint">Страна: <b>{gmNat(a.nat)}</b></div>}
                {extra >= 2 && !G.over && <div className="car-hint">Фамилия начинается на <b>{(a.last || '?')[0]}</b></div>}
            </div>
            {!G.guesses.length && !G.over && <div className="gm-p left">Каждая ошибка открывает следующую команду в карьере.</div>}
        </div>
    );
};

// ─────────────── 3. УГАДАЙ ТРАССУ ───────────────
const gmTrackPath = (pts) => {
    const xs = pts.map(p => p.x), ys = pts.map(p => p.y);
    const x0 = Math.min(...xs), x1 = Math.max(...xs), y0 = Math.min(...ys), y1 = Math.max(...ys);
    const pad = Math.max(x1 - x0, y1 - y0) * 0.07;
    return {vb: (x0 - pad) + ' ' + (y0 - pad) + ' ' + (x1 - x0 + pad * 2) + ' ' + (y1 - y0 + pad * 2),
        d: pts.map((p, i) => (i ? 'L' : 'M') + p.x.toFixed(1) + ' ' + p.y.toFixed(1)).join(' ') + ' Z',
        w: (Math.max(x1 - x0, y1 - y0) / 34).toFixed(1)};
};
const CIRCUIT_ROUNDS = 10, CIRCUIT_TIME = 10;

const CircuitGuess = ({onBack}) => {
    const [sched, retry] = useGm([gmSched]);
    const [tracks, setTracks] = useState(null);
    const [phase, setPhase] = useState('intro');
    const [qs, setQs] = useState([]);
    const [i, setI] = useState(0);
    const [pick, setPick] = useState(null);
    const [score, setScore] = useState(0);
    const [right, setRight] = useState(0);
    const [left, setLeft] = useState(CIRCUIT_TIME);
    const [boardKey, setBoardKey] = useState(0);
    const t0 = useRef(0);
    const lock = useRef(false);

    useEffect(() => {
        if (!sched) return;
        const races = sched[0].filter(r => GM_CITY[r.circuit_id]);
        Promise.all(races.map(r => api.get('/api/circuit/' + r.circuit_id + '/track').then(t => (t?.points?.length > 10 ? {id: r.circuit_id, city: GM_CITY[r.circuit_id], gp: r.name, path: gmTrackPath(t.points)} : null))))
            .then(l => setTracks(l.filter(Boolean)));
    }, [sched]);

    const next = (sc, rt, idx) => {
        if (idx + 1 >= qs.length) {
            setPhase('done');
            gmPostResult({game_type: 'circuit', score: sc}).then(() => setBoardKey(k => k + 1));
            return;
        }
        setI(idx + 1); setPick(null); lock.current = false; t0.current = performance.now(); setLeft(CIRCUIT_TIME);
    };
    const answer = (opt) => {
        if (lock.current || phase !== 'play') return;
        lock.current = true;
        const q = qs[i];
        const ok = opt === q.t.city;
        const secs = Math.max(0, CIRCUIT_TIME - (performance.now() - t0.current) / 1000);
        const sc = score + (ok ? 100 + Math.round(secs * 10) : 0);
        setPick(opt || '—'); setScore(sc); if (ok) setRight(r => r + 1);
        gHaptic(ok ? 'success' : 'error');
        setTimeout(() => next(sc, right + (ok ? 1 : 0), i), 950);
    };
    // таймер вопроса
    useEffect(() => {
        if (phase !== 'play') return;
        let raf;
        const tick = () => {
            const l = CIRCUIT_TIME - (performance.now() - t0.current) / 1000;
            setLeft(Math.max(0, l));
            if (l <= 0 && !lock.current) { answer(null); return; }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [phase, i]);

    const start = () => {
        const pool = gmShuffle(tracks).slice(0, Math.min(CIRCUIT_ROUNDS, tracks.length));
        const cities = tracks.map(t => t.city);
        setQs(pool.map(t => ({t, opts: gmShuffle([t.city, ...gmPickN(cities, 3, [t.city])])})));
        setI(0); setPick(null); setScore(0); setRight(0); lock.current = false;
        t0.current = performance.now(); setLeft(CIRCUIT_TIME); setPhase('play');
    };

    if (!sched || !tracks) return <GmLoading title="Угадай трассу" onBack={onBack} data={sched === null ? null : undefined} retry={retry}/>;
    const q = qs[i];
    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Угадай трассу" onBack={onBack} right={phase === 'play' ? <span className="gm-chip">{i + 1} / {qs.length}</span> : null}/>
            {phase === 'intro' && (
                <div className="gm-intro">
                    <div className="trk-hero"><svg viewBox={tracks[0].path.vb}><path d={tracks[0].path.d} strokeWidth={tracks[0].path.w} className="trk-line draw" pathLength="1"/></svg></div>
                    <div className="gm-h">Узнай по силуэту</div>
                    <div className="gm-p">{CIRCUIT_ROUNDS} трасс календаря, на каждую — {CIRCUIT_TIME} секунд. Чем быстрее ответ, тем больше очков.</div>
                    <div className="gm-btn" onClick={start}>Старт</div>
                    <GameBoard type="circuit" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}
            {phase === 'play' && q && (
                <div className="trk-play">
                    <div className="trk-timer"><i style={{transform: 'scaleX(' + (left / CIRCUIT_TIME) + ')'}} className={left < 3 ? 'hot' : ''}/></div>
                    <div className="trk-score">{score}<span>очков</span></div>
                    <div className="trk-box" key={i}><svg viewBox={q.t.path.vb}><path d={q.t.path.d} strokeWidth={q.t.path.w} className="trk-line draw" pathLength="1"/></svg></div>
                    <div className="trk-opts">
                        {q.opts.map(o => (
                            <div key={o} className={'trk-opt' + (pick ? (o === q.t.city ? ' ok' : o === pick ? ' bad' : ' dim') : '')} onClick={() => answer(o)}>{o}</div>
                        ))}
                    </div>
                    {pick && <div className="gm-hint">{q.t.gp}</div>}
                </div>
            )}
            {phase === 'done' && (
                <div className="gm-result">
                    <div className="gm-result-k">Угадано {right} из {qs.length}</div>
                    <div className="gm-result-big">{score}<span>очков</span></div>
                    <div className="gm-result-t">{right >= 9 ? 'Ходячий атлас F1' : right >= 6 ? 'Знаешь календарь' : right >= 3 ? 'Неплохо для начала' : 'Пора пересмотреть гонки'}</div>
                    <div className="gm-row"><div className="gm-btn" onClick={start}>Ещё раз</div><div className="gm-btn ghost" onClick={onBack}>К играм</div></div>
                    <GameBoard type="circuit" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

// ─────────────── 4. БОЛЬШЕ ИЛИ МЕНЬШЕ ───────────────
// 24.09: пары подбираются по близости значений (Егору попадался «Хэмилтон
// против новичка»). С каждым верным ответом разница сужается. Кроме текущей
// решётки — сезоны 1980–2025: очки и победы соперников в одном чемпионате.
const gmCareer = (c) => { if (typeof c === 'string') { try { return JSON.parse(c.replace(/'/g, '"')); } catch (e) { return {}; } } return c || {}; };
// окно относительной разницы |a-b|/max по длине серии
const hlWindow = (s) => s < 3 ? [0.25, 0.6] : s < 6 ? [0.12, 0.4] : s < 10 ? [0.05, 0.25] : [0.01, 0.15];

const hlSets = (db, hist, careers) => {
    const sets = [];
    const all = Object.values(db);
    const card = (d, extra = {}) => ({id: d.id, name: d.name, last: d.last, team: d.team, color: d.color, photo: d.photo, ...extra});
    sets.push({w: 3, label: 'побед в карьере', items: all.filter(d => d.wins > 0).map(d => card(d, {v: d.wins}))});
    sets.push({w: 2, label: 'сезонов в F1', items: all.filter(d => d.seasons.length >= 3 && d.debut >= 1990).map(d => card(d, {v: d.seasons.length}))});
    const cs = Object.values(careers);
    if (cs.length) {
        sets.push({w: 2, label: 'подиумов в карьере', items: cs.filter(c => c.podiums > 0).map(c => card(db[c.id] || c, {v: c.podiums}))});
        sets.push({w: 2, label: 'поулов в карьере', items: cs.filter(c => c.poles > 0).map(c => card(db[c.id] || c, {v: c.poles}))});
        sets.push({w: 1, label: 'стартов в F1', items: cs.filter(c => c.races > 0).map(c => card(db[c.id] || c, {v: c.races}))});
    }
    // сезонные: оба пилота из одного чемпионата
    Object.entries(hist.seasons).forEach(([y, s]) => {
        if (+y < 1990) return;
        const top = s.drivers.filter(r => r.pts > 0 && r.pos && r.pos <= 16);
        const mk = (r, v) => { const d = db[r.id]; return d && card(d, {v, team: gmTeam(r.teams[r.teams.length - 1]), color: null, photo: null}); };
        sets.push({w: 0.25, label: 'очков в сезоне ' + y, items: top.map(r => mk(r, Math.round(r.pts))).filter(Boolean)});
        const wn = s.drivers.filter(r => r.wins > 0);
        if (wn.length >= 3) sets.push({w: 0.12, label: 'побед в сезоне ' + y, items: wn.map(r => mk(r, r.wins)).filter(Boolean)});
    });
    return sets.filter(s => s.items.length >= 4);
};

const hlPair = (sets, streak, recent) => {
    const tot = sets.reduce((s, x) => s + x.w, 0);
    const [lo, hi] = hlWindow(streak);
    for (let tries = 0; tries < 40; tries++) {
        let r = Math.random() * tot, set = sets[0];
        for (const s of sets) { r -= s.w; if (r <= 0) { set = s; break; } }
        const a = set.items[gmRand(set.items.length)];
        const rel = (b) => Math.abs(a.v - b.v) / Math.max(a.v, b.v, 1);
        const cand = set.items.filter(b => b.id !== a.id && b.v !== a.v && rel(b) >= lo && rel(b) <= hi && !recent.includes(a.id + b.id));
        if (!cand.length) continue;
        const b = cand[gmRand(cand.length)];
        return {set, a, b};
    }
    return null;
};

const HLPhoto = ({c}) => c.photo ? <img src={c.photo} alt=""/> : <div className="hl-mono">{(c.last || c.name || '?').slice(0, 3).toUpperCase()}</div>;

const HigherLower = ({onBack}) => {
    const [data, retry] = useGm([gmHist, gmGrid]);
    const [sets, setSets] = useState(null);
    const [phase, setPhase] = useState('intro');
    const [q, setQ] = useState(null);
    const [streak, setStreak] = useState(0);
    const [shown, setShown] = useState(null);
    const [boardKey, setBoardKey] = useState(0);
    const recent = useRef([]);

    useEffect(() => {
        if (!data) return;
        const [hist, grid] = data;
        const db = gmDrivers(hist, grid);
        const ids = grid.drivers.map(d => d.ergast_id).filter(Boolean);
        api.get('/api/drivers/career/batch?ids=' + ids.join(',')).then(b => {
            const careers = {};
            grid.drivers.forEach(d => {
                const c = gmCareer(b?.drivers?.[d.ergast_id]?.career);
                if (!d.ergast_id) return;
                careers[d.ergast_id] = {id: d.ergast_id, name: d.name, last: d.last_name, team: d.team, color: d.team_color, photo: d.photo_url,
                    podiums: +c.podiums || 0, poles: +c.poles || 0, races: +c.races || 0};
            });
            setSets(hlSets(db, hist, careers));
        });
    }, [data]);

    const next = (s) => {
        const p = hlPair(sets, s, recent.current);
        if (!p) return;
        recent.current = [...recent.current, p.a.id + p.b.id, p.b.id + p.a.id].slice(-60);
        setQ(p); setShown(null);
    };
    const start = () => { setStreak(0); recent.current = []; next(0); setPhase('guess'); };
    const choose = (dir) => {
        if (phase !== 'guess') return;
        const {a, b} = q;
        const ok = dir === 'up' ? b.v > a.v : b.v < a.v;
        setPhase('reveal');
        const s0 = performance.now();
        const tick = (n) => { const k = Math.min(1, (n - s0) / 650); setShown(Math.round(b.v * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
        setTimeout(() => {
            if (ok) { gHaptic('success'); const s = streak + 1; setStreak(s); next(s); setPhase('guess'); }
            else {
                gHaptic('error'); setPhase('over');
                gmPostResult({game_type: 'higher_lower', score: streak}).then(() => setBoardKey(k => k + 1));
            }
        }, 1400);
    };

    if (!data || !sets) return <GmLoading title="Больше/меньше" onBack={onBack} data={data === null ? null : undefined} retry={retry}/>;
    const Card = ({c, val, hidden}) => (
        <div className="hl-card" style={{'--tc': c.color || '#3a3a4a'}}>
            <HLPhoto c={c}/>
            <div className="hl-tx">
                <div className="hl-name">{c.last}</div>
                <div className="hl-team">{c.team}</div>
                <div className="hl-val">{hidden ? '?' : val}</div>
                <div className="hl-lab">{q.set.label}</div>
            </div>
        </div>
    );
    const [lo, hi] = hlWindow(streak);
    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Больше/меньше" onBack={onBack} right={phase !== 'intro' ? <span className="gm-chip">Серия {streak}</span> : null}/>
            {phase === 'intro' && (
                <div className="gm-intro">
                    <div className="gm-h">У кого больше?</div>
                    <div className="gm-p">Пилоты с 1990 года и текущая решётка: победы, подиумы, поулы, очки за сезон. Соперники подобраны по уровню, и с каждым верным ответом разница всё меньше.</div>
                    <div className="gm-btn" onClick={start}>Начать</div>
                    <GameBoard type="higher_lower" fmt={s => 'серия ' + s} refreshKey={boardKey}/>
                </div>
            )}
            {(phase === 'guess' || phase === 'reveal') && q && (
                <div className="hl-play">
                    <div className="hl-q">У кого больше <b>{q.set.label}</b>?</div>
                    <Card c={q.a} val={q.a.v}/>
                    <div className="hl-vs">VS</div>
                    <Card c={q.b} val={shown ?? q.b.v} hidden={phase === 'guess'}/>
                    {phase === 'guess' && (
                        <div className="hl-btns">
                            <div className="gm-btn" onClick={() => choose('up')}>Больше ▲</div>
                            <div className="gm-btn ghost" onClick={() => choose('down')}>Меньше ▼</div>
                        </div>
                    )}
                    <div className="hl-diff">Сложность: разница {Math.round(lo * 100)}–{Math.round(hi * 100)}%</div>
                </div>
            )}
            {phase === 'over' && q && (
                <div className="gm-result">
                    <div className="gm-result-k">Серия</div>
                    <div className="gm-result-big">{streak}</div>
                    <div className="gm-result-s">{q.b.last}: {q.b.v}, а у {q.a.last} — {q.a.v} ({q.set.label}).</div>
                    <div className="gm-row"><div className="gm-btn" onClick={start}>Ещё раз</div><div className="gm-btn ghost" onClick={onBack}>К играм</div></div>
                    <GameBoard type="higher_lower" fmt={s => 'серия ' + s} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

// ─────────────── 5. ПИТ-УОЛЛ: стратегия гонки ───────────────
// Упрощённая модель: время круга = база + класс пилота + состав шин + износ,
// после «обрыва» шины сильно теряют. Пит-стоп −20 с, под сейфти-каром −10 с.
// Обязательны два разных состава, иначе +10 с.
// 24.09: этап выбирается из календаря, стартовая позиция — жребий, круг 0.9 с,
// на сейфти-каре и в меню пит-стопа гонка встаёт на паузу (Егор не успевал).
const STR_TYRES = {
    S: {name: 'Soft', c: '#FF2A2A', d: -0.75, deg: 0.085, life: 15},
    M: {name: 'Medium', c: '#FFD21F', d: 0, deg: 0.05, life: 25},
    H: {name: 'Hard', c: '#F2F2F2', d: 0.45, deg: 0.03, life: 38},
};
const STR_PTS = [25, 18, 15, 12, 10, 8, 6, 4, 2, 1];
const STR_LAP_MS = 900;
const gmNoise = (a) => (Math.random() * 2 - 1) * a;

const StrategyGame = ({onBack}) => {
    const [data, retry] = useGm([gmSched, gmGrid]);
    const [phase, setPhase] = useState('intro');       // intro | race | done
    const [round, setRound] = useState(null);
    const [gridPos, setGridPos] = useState(() => 4 + gmRand(11));
    const [view, setView] = useState(null);
    const [pitOpen, setPitOpen] = useState(false);
    const [scAsk, setScAsk] = useState(false);
    const [paused, setPaused] = useState(false);
    const [speed, setSpeed] = useState(1);
    const [boardKey, setBoardKey] = useState(0);
    const sim = useRef(null);
    const timer = useRef(null);

    const races = data ? data[0] : null;
    const selIdx = races ? (round != null ? races.findIndex(r => r.round === round) : Math.max(0, races.findIndex(x => x.is_next))) : 0;
    const gp = useMemo(() => {
        if (!races) return null;
        const r = races[selIdx] || races[0];
        return {name: r.name, city: GM_CITY[r.circuit_id] || r.locality, laps: Math.min(60, +r.laps || 55), round: r.round};
    }, [races, selIdx]);

    const snap = () => {
        const s = sim.current;
        const sorted = [...s.cars].sort((a, b) => a.total - b.total);
        return {lap: s.lap, laps: s.laps, sc: s.sc, rows: sorted.map((c, i) => ({...c, pos: i + 1, gap: i ? c.total - sorted[i - 1].total : 0})), log: s.log.slice(-2)};
    };

    const start = (tyre) => {
        const ds = data[1].drivers.slice(0, 21);
        const maxPts = Math.max(...ds.map(d => +d.points || 0), 1);
        const laps = gp.laps, sc = laps / 57;
        const cars = ds.map(d => {
            const st = Math.random() < 0.3 ? 'S' : Math.random() < 0.7 ? 'M' : 'H';
            const next = st === 'H' ? 'M' : 'H';
            const pitAt = Math.round(STR_TYRES[st].life * sc * (0.85 + Math.random() * 0.3));
            return {id: d.ergast_id || String(d.driver_number), name: d.last_name, color: d.team_color, skill: (1 - (+d.points || 0) / maxPts) * 1.5,
                tyre: st, age: 0, used: [st], plan: [{lap: pitAt, tyre: next}], total: 0, me: false};
        });
        // класс игрока — как у соседей по решётке, чтобы стартовая позиция имела смысл
        const order = cars.sort((a, b) => a.skill + gmNoise(0.3) - (b.skill + gmNoise(0.3)));
        const nb = order.slice(Math.max(0, gridPos - 2), gridPos + 1);
        const me = {id: 'me', name: 'ТЫ', color: '#E10600', skill: nb.reduce((s, c) => s + c.skill, 0) / nb.length - 0.1, tyre, age: 0, used: [tyre], plan: [], total: 0, me: true};
        order.splice(gridPos - 1, 0, me);
        order.forEach((c, i) => { c.total = i * 0.4; });
        // 0–2 сейфти-кара за гонку
        const scLaps = [];
        if (Math.random() < 0.6) scLaps.push(Math.round(laps * (0.2 + Math.random() * 0.3)));
        if (Math.random() < 0.3) scLaps.push(Math.round(laps * (0.55 + Math.random() * 0.3)));
        sim.current = {cars: order, lap: 0, laps, sc: 0, scLaps, lifeScale: sc, pitReq: null, log: ['Старт с P' + gridPos + ' на ' + STR_TYRES[tyre].name]};
        setPhase('race'); setPitOpen(false); setScAsk(false); setPaused(false);
        setView(snap());
    };

    const lapStep = () => {
        const s = sim.current;
        if (!s || s.lap >= s.laps) return;
        s.lap += 1;
        let newSC = false;
        if (s.scLaps.includes(s.lap)) { s.sc = 5; newSC = true; s.log.push('Круг ' + s.lap + ': сейфти-кар на трассе'); gHaptic('warning'); }
        const underSC = s.sc > 0;
        const meBefore = [...s.cars].sort((a, b) => a.total - b.total).findIndex(c => c.me) + 1;
        let iPitted = null;
        s.cars.forEach(c => {
            const t = STR_TYRES[c.tyre];
            const life = t.life * s.lifeScale;
            let lt = 95 + c.skill + t.d + t.deg * c.age + (c.age > life ? (c.age - life) * 0.4 : 0) + gmNoise(0.2);
            if (underSC) lt = 125;
            let pitTo = null;
            if (c.me && s.pitReq) { pitTo = s.pitReq; s.pitReq = null; }
            if (!c.me) {
                if (c.plan.length && c.plan[0].lap <= s.lap) pitTo = c.plan.shift().tyre;
                else if (underSC && c.age > life * 0.45 && c.used.length < 2) { pitTo = c.tyre === 'H' ? 'M' : 'H'; c.plan = []; }
            }
            if (pitTo) {
                lt += underSC ? 10 : 20;
                c.tyre = pitTo; c.age = 0; if (!c.used.includes(pitTo)) c.used.push(pitTo);
                if (c.me) iPitted = pitTo;
            } else c.age += 1;
            c.total += lt;
        });
        if (underSC) {
            const sorted = [...s.cars].sort((a, b) => a.total - b.total);
            sorted.forEach((c, i) => { c.total = sorted[0].total + i * 0.6; });
            s.sc -= 1;
            if (!s.sc) s.log.push('Круг ' + s.lap + ': рестарт!');
        }
        if (iPitted) {
            const after = [...s.cars].sort((a, b) => a.total - b.total).findIndex(c => c.me) + 1;
            s.log.push('Круг ' + s.lap + ': пит-стоп, ' + STR_TYRES[iPitted].name + '. P' + meBefore + ' → P' + after + (after > meBefore ? ' — на свежих шинах отыграешь' : ''));
        }
        if (s.lap >= s.laps) { finish(); return; }
        setView(snap());
        // решение под сейфти-каром — гонка ждёт игрока
        if (newSC) { clearInterval(timer.current); setScAsk(true); }
    };

    const finish = () => {
        clearInterval(timer.current);
        const s = sim.current;
        const me = s.cars.find(c => c.me);
        let pen = 0;
        if (me.used.length < 2) { pen = 10; me.total += 10; }
        const v = snap();
        const pos = v.rows.find(r => r.me).pos;
        setView({...v, pen, pos, start: gridPos});
        setPhase('done');
        gHaptic(pos <= 3 ? 'success' : 'medium');
        gmPostResult({game_type: 'strategy', score: pos}).then(() => setBoardKey(k => k + 1));
    };

    const running = phase === 'race' && !pitOpen && !scAsk && !paused;
    useEffect(() => {
        if (!running) return;
        timer.current = setInterval(lapStep, speed === 2 ? STR_LAP_MS / 2 : STR_LAP_MS);
        return () => clearInterval(timer.current);
    }, [running, speed]);
    useEffect(() => () => clearInterval(timer.current), []);

    const pit = (t) => { if (sim.current) { sim.current.pitReq = t; setPitOpen(false); setScAsk(false); gHaptic('medium'); } };
    // где выедешь после пит-стопа: +20 с (под SC +10) к своему времени
    const predict = () => {
        const s = sim.current; if (!s) return null;
        const me = s.cars.find(c => c.me);
        const loss = s.sc > 0 ? 10 : 20;
        return 1 + s.cars.filter(c => !c.me && c.total < me.total + loss).length;
    };
    const newGame = () => { setGridPos(4 + gmRand(11)); setPhase('intro'); };

    if (!gp) return <GmLoading title="Пит-уолл" onBack={onBack} data={data} retry={retry}/>;
    const me = view?.rows?.find(r => r.me);
    const meIdx = view?.rows ? view.rows.findIndex(r => r.me) : 0;
    const tower = view?.rows ? view.rows.filter((r, i) => i < 3 || Math.abs(i - meIdx) <= 2) : [];
    const life = me ? STR_TYRES[me.tyre].life * (sim.current?.lifeScale || 1) : 1;
    const TyrePick = ({onPick}) => (
        <div className="str-tyres small">{Object.entries(STR_TYRES).map(([k, t]) => (
            <div key={k} className={'str-tyre' + (me && me.tyre === k ? ' cur' : '')} onClick={() => onPick(k)}><i style={{'--tc': t.c}}/><b>{t.name}</b></div>
        ))}</div>
    );

    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Пит-уолл" onBack={() => { clearInterval(timer.current); onBack(); }}/>
            {phase === 'intro' && (
                <div className="gm-intro">
                    <div className="str-pick-h">Этап</div>
                    <div className="str-gps">
                        {races.map((r, i) => (
                            <div key={r.round} className={'str-gp' + (i === selIdx ? ' on' : '') + (r.is_next ? ' next' : '')} onClick={() => setRound(r.round)}
                                 ref={i === selIdx ? (el => { if (el && !el.dataset.sc) { el.dataset.sc = 1; el.scrollIntoView({inline: 'center', block: 'nearest'}); } }) : undefined}>
                                <span>{r.is_next ? 'Следующий' : 'Этап ' + r.round}</span><b>{GM_CITY[r.circuit_id] || r.locality}</b>
                            </div>
                        ))}
                    </div>
                    <div className="gm-h">{gp.name}</div>
                    <div className="str-grid-pos"><span>Квалификация</span><b>P{gridPos}</b><em onClick={() => setGridPos(4 + gmRand(11))}>перебросить</em></div>
                    <div className="gm-p">{gp.laps} {plural(gp.laps, 'круг', 'круга', 'кругов')}. Ты решаешь, когда ехать в боксы и какие шины ставить. Пит-стоп стоит ~20 с — сначала потеряешь места, потом отыграешь их на свежих шинах. На сейфти-каре гонка встанет на паузу: там пит-стоп в два раза дешевле. Нужны <b>два разных состава</b>, иначе +10 с.</div>
                    <div className="str-pick-h">Шины на старт</div>
                    <div className="str-tyres">
                        {Object.entries(STR_TYRES).map(([k, t]) => (
                            <div key={k} className="str-tyre" onClick={() => start(k)}>
                                <i style={{'--tc': t.c}}/><b>{t.name}</b>
                                <span>{k === 'S' ? 'быстрые, живут мало' : k === 'M' ? 'золотая середина' : 'медленные, но долго'}</span>
                            </div>
                        ))}
                    </div>
                    <GameBoard type="strategy" fmt={p => 'P' + p} refreshKey={boardKey}/>
                </div>
            )}
            {phase === 'race' && view && me && (
                <div className="str-race">
                    <div className="str-top">
                        <div className="str-lap">Круг <b>{view.lap}</b> / {view.laps}</div>
                        {view.sc > 0 && <div className="str-sc">SAFETY CAR · {view.sc}</div>}
                        <div className="str-speed" onClick={() => setPaused(p => !p)}>{paused ? '▶' : '❚❚'}</div>
                        <div className="str-speed" onClick={() => setSpeed(s => s === 1 ? 2 : 1)}>×{speed}</div>
                    </div>
                    <div className="str-tower">
                        {tower.map(r => (
                            <div key={r.id} className={'str-row' + (r.me ? ' me' : '')}>
                                <span className="p">{r.pos}</span><i style={{background: r.color}}/><span className="n">{r.name}</span>
                                <span className="ty" style={{'--tc': STR_TYRES[r.tyre].c}}>{r.tyre}</span>
                                <span className="g">{r.pos === 1 ? 'Лидер' : '+' + r.gap.toFixed(1)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="str-me">
                        <div className="str-me-row"><span>Шины</span><b style={{color: STR_TYRES[me.tyre].c}}>{STR_TYRES[me.tyre].name}</b><span>{me.age} {plural(me.age, 'круг', 'круга', 'кругов')}</span></div>
                        <div className="str-wear"><i style={{width: Math.min(100, me.age / life * 100) + '%'}} className={me.age > life ? 'dead' : me.age > life * 0.8 ? 'warn' : ''}/></div>
                        <div className="str-hint">{me.age > life ? 'Шины «кончились» — теряешь по полсекунды и больше с каждым кругом' : me.used.length < 2 ? 'Ещё не было пит-стопа: нужен второй состав' : ' '}</div>
                    </div>
                    {view.log.map((l, i) => <div key={i} className="str-log">{l}</div>)}
                    {scAsk ? (
                        <div className="str-ask sc">
                            <div className="str-ask-h">🟡 Сейфти-кар! Гонка на паузе</div>
                            <div className="str-ask-p">Пит-стоп сейчас стоит ~10 с вместо 20. Выедешь примерно на <b>P{predict()}</b>.</div>
                            <TyrePick onPick={pit}/>
                            <div className="gm-btn ghost" onClick={() => setScAsk(false)}>Остаёмся на трассе</div>
                        </div>
                    ) : pitOpen ? (
                        <div className="str-ask">
                            <div className="str-ask-h">Пит-стоп на этом круге</div>
                            <div className="str-ask-p">Потеряешь ~{view.sc > 0 ? 10 : 20} с и выедешь примерно на <b>P{predict()}</b>. Какие шины?</div>
                            <TyrePick onPick={pit}/>
                            <div className="gm-btn ghost" onClick={() => setPitOpen(false)}>Отмена</div>
                        </div>
                    ) : (
                        <div className={'pit2-gun' + (sim.current?.pitReq ? ' off' : '') + (me.age > life * 0.9 ? ' hot' : '')} onClick={() => !sim.current?.pitReq && setPitOpen(true)}>
                            {sim.current?.pitReq ? 'Заезжаем на этом круге…' : 'В БОКСЫ'}
                        </div>
                    )}
                </div>
            )}
            {phase === 'done' && view && (
                <div className="gm-result">
                    <div className="gm-result-k">{gp.city} · финиш</div>
                    <div className="gm-result-big">P{view.pos}</div>
                    <div className="gm-result-t">{view.pos === 1 ? 'Победа стратегией!' : view.pos <= 3 ? 'Подиум' : view.pos <= 10 ? '+' + STR_PTS[view.pos - 1] + ' ' + plural(STR_PTS[view.pos - 1], 'очко', 'очка', 'очков') : 'Без очков'}</div>
                    <div className="gm-result-s">Старт P{view.start} → финиш P{view.pos}{view.start > view.pos ? ' · +' + (view.start - view.pos) + ' ' + plural(view.start - view.pos, 'позиция', 'позиции', 'позиций') : ''}</div>
                    {view.pen > 0 && <div className="pit2-pen">+10 с штрафа: не использовал два состава шин</div>}
                    <div className="gm-row"><div className="gm-btn" onClick={newGame}>Ещё гонку</div><div className="gm-btn ghost" onClick={onBack}>К играм</div></div>
                    <GameBoard type="strategy" fmt={p => 'P' + p} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

// ─────────────── 6. МЕНЕДЖЕР: сезон руководителя команды ───────────────
// Сезон за реальную команду: спонсор и цель от совета директоров, на каждом
// этапе — крыло под тип трассы и погоду, тактика и число пит-стопов каждому
// пилоту, доработки на призовые. Квалификация Q1–Q3 с временами, гонка с
// хроникой событий, личный зачёт и Кубок конструкторов. Форма пилотов
// меняется от результатов. У слабых команд денег на старте больше.
const MGR_RACES = 8;
const MGR_TRACK = {
    monaco: 'street', baku: 'street', marina_bay: 'street', jeddah: 'street', vegas: 'street', madring: 'street', miami: 'street', albert_park: 'street',
    monza: 'fast', spa: 'fast', silverstone: 'fast', red_bull_ring: 'fast', villeneuve: 'fast', losail: 'fast',
    hungaroring: 'tech', zandvoort: 'tech', catalunya: 'tech', suzuka: 'tech', imola: 'tech',
};
const MGR_TYPES = {
    street: {name: 'Городская', hint: 'медленные повороты у стен — нужна прижимная сила', ideal: 'high'},
    fast: {name: 'Скоростная', hint: 'длинные прямые — срезай крыло', ideal: 'low'},
    tech: {name: 'Техничная', hint: 'связки поворотов — нужна прижимная сила', ideal: 'high'},
    mixed: {name: 'Сбалансированная', hint: 'всего понемногу — лучше баланс', ideal: 'mid'},
};
const MGR_RAIN = {spa: 45, silverstone: 35, interlagos: 35, suzuka: 30, marina_bay: 25, villeneuve: 25, shanghai: 20, hungaroring: 20, zandvoort: 25,
    bahrain: 2, losail: 2, yas_marina: 2, jeddah: 2, vegas: 3};
// износ шин: на «высоком» выгоднее два пит-стопа, на «низком» — один
const MGR_WEAR = {bahrain: 'high', silverstone: 'high', suzuka: 'high', losail: 'high', catalunya: 'high', shanghai: 'high', zandvoort: 'high',
    monaco: 'low', monza: 'low', vegas: 'low', baku: 'low', madring: 'low', miami: 'low', villeneuve: 'low'};
const MGR_WEAR_TXT = {high: 'высокий', mid: 'средний', low: 'низкий'};
const MGR_SETUPS = [
    {k: 'low', name: 'Низкое крыло', sub: 'скорость на прямых'},
    {k: 'mid', name: 'Баланс', sub: 'универсально'},
    {k: 'high', name: 'Высокое крыло', sub: 'сцепление в поворотах'},
];
const MGR_TACTICS = [
    {k: 'safe', name: 'Беречь', d: -0.03, risk: -0.02},
    {k: 'std', name: 'Обычно', d: 0, risk: 0},
    {k: 'push', name: 'Атака', d: 0.045, risk: 0.05},
];
const MGR_UPG = [
    {k: 'eng', name: 'Мотор', sub: 'быстрее на прямых', icon: '⚙️'},
    {k: 'aero', name: 'Аэродинамика', sub: 'быстрее в поворотах', icon: '🪽'},
    {k: 'rel', name: 'Надёжность', sub: 'меньше сходов', icon: '🛡️'},
    {k: 'crew', name: 'Пит-экипаж', sub: 'быстрые пит-стопы', icon: '🔧'},
];
const MGR_UPG_COST = [6, 10, 15];
const MGR_SPONSORS = [
    {k: 'energy', icon: '⚡', name: 'Энергетик', sub: '+0,6 млн за каждое очко команды'},
    {k: 'bank', icon: '🏦', name: 'Банк', sub: '+4 млн за этап, если оба пилота финишировали'},
    {k: 'tel', icon: '📡', name: 'Телеком', sub: '22 млн сразу, дальше ничего'},
];
const MGR_DNF = {push: ['авария', 'вылет в гравий', 'столкновение'], any: ['отказ мотора', 'гидравлика', 'коробка передач', 'перегрев тормозов', 'столкновение']};

const mgrSetupFit = (setup, type, wet) => {
    const ideal = wet ? 'high' : MGR_TYPES[type].ideal;
    if (setup === ideal) return 0.05;
    if (setup === 'mid' || ideal === 'mid') return 0;
    return -0.06;
};
const mgrStopFit = (stops, wear) => wear === 'high' ? (stops === 2 ? 0.03 : -0.03) : wear === 'low' ? (stops === 1 ? 0.03 : -0.02) : (stops === 1 ? 0.01 : 0);
const mgrUpgBonus = (u, type) => (u.eng || 0) * (type === 'fast' ? 0.04 : 0.02) + (u.aero || 0) * (type === 'fast' ? 0.02 : 0.04);
const mgrLap = (s) => { const m = Math.floor(s / 60); const r = (s - m * 60).toFixed(3).padStart(6, '0'); return m + ':' + r; };
const mgrPlace = (n) => n + '-е';
const mgrRaceTime = (s) => { const h = Math.floor(s / 3600), mm = Math.floor(s % 3600 / 60), ss = Math.floor(s % 60); return h + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0'); };

const ManagerGame = ({onBack}) => {
    const [data, retry] = useGm([gmGrid, gmSched]);
    const [phase, setPhase] = useState('team');     // team | sponsor | prep | quali | race | done
    const [me, setMe] = useState(null);
    const [st, setSt] = useState(null);
    const [setup, setSetup] = useState('mid');
    const [tac, setTac] = useState({});
    const [stops, setStops] = useState({});
    const [tab, setTab] = useState('report');
    const [boardKey, setBoardKey] = useState(0);

    const m = useMemo(() => {
        if (!data) return null;
        const [grid, races] = data;
        const maxT = Math.max(...grid.teams.map(t => +t.points || 0), 1);
        const teams = grid.teams.map(t => {
            const ds = grid.drivers.filter(d => d.team === t.team);
            const tp = Math.max(1, ds.reduce((s, d) => s + (+d.points || 0), 0));
            return {name: t.team, color: t.team_color, logo: t.logo_url, power: Math.pow((+t.points || 0) / maxT, 0.6),
                drivers: ds.slice(0, 2).map(d => ({id: d.ergast_id || String(d.driver_number), name: d.last_name, full: d.name, photo: d.photo_url, color: d.team_color, team: t.team,
                    skill: 0.35 + 0.65 * ((+d.points || 0) / tp)}))};
        }).filter(t => t.drivers.length === 2);
        teams.forEach((t, i) => { t.rank = i + 1; });
        const next = Math.max(0, races.findIndex(r => r.is_next));
        const cal = [...races.slice(next), ...races.slice(0, next)].slice(0, MGR_RACES).map(r => ({
            city: GM_CITY[r.circuit_id] || r.locality, name: r.name, type: MGR_TRACK[r.circuit_id] || 'mixed', rain: MGR_RAIN[r.circuit_id] ?? 12,
            wear: MGR_WEAR[r.circuit_id] || 'mid', laps: +r.laps || 57}));
        const names = {}; teams.forEach(t => t.drivers.forEach(d => { names[d.id] = d; }));
        return {teams, cal, names};
    }, [data]);

    const pickTeam = (t) => { setMe(t.name); setPhase('sponsor'); gHaptic('light'); };
    const pickSponsor = (sp) => {
        const t = m.teams.find(x => x.name === me);
        const cash = 8 + Math.round((1 - t.power) * 22) + (sp === 'tel' ? 22 : 0);
        const cal = m.cal.map(r => {
            const fc = Math.max(0, Math.min(90, r.rain + gmRand(21) - 10));
            const ev = Math.random() < 0.3 ? 'bonus' : Math.random() < 0.2 ? 'penalty' : null;
            return {...r, forecast: fc, event: ev, penaltyIdx: gmRand(2), qt: 76 + gmRand(18) + Math.random()};
        });
        // цель совета: реальное место команды в чемпионате с запасом в одну позицию (лидеру — только победа)
        const goal = t.rank === 1 ? 1 : Math.min(m.teams.length, t.rank + 1);
        setSt({cash, upg: {}, ai: {}, i: 0, pts: {}, dpts: {}, form: {}, cal, history: [], last: null, sponsor: sp, goal, best: null});
        setSetup('mid'); setTac({}); setStops({});
        setPhase('prep'); gHaptic('medium');
    };

    if (!m) return <GmLoading title="Менеджер" onBack={onBack} data={data} retry={retry}/>;
    const my = me && m.teams.find(t => t.name === me);
    const race = st && st.cal[st.i];

    const buy = (k) => {
        const lvl = st.upg[k] || 0;
        if (lvl >= 3 || st.cash < MGR_UPG_COST[lvl]) { gHaptic('warning'); return; }
        setSt({...st, cash: st.cash - MGR_UPG_COST[lvl], upg: {...st.upg, [k]: lvl + 1}}); gHaptic('success');
    };

    const simulate = () => {
        const wet = Math.random() * 100 < race.forecast;
        const best = race.wear === 'high' ? 2 : 1;
        const field = [];
        m.teams.forEach(t => {
            const mine = t.name === me;
            const aiSetup = Math.random() < 0.6 ? (wet ? 'high' : MGR_TYPES[race.type].ideal) : MGR_SETUPS[gmRand(3)].k;
            const aiStops = Math.random() < 0.6 ? best : 1 + gmRand(2);
            const car = t.power * 0.55 + (mine ? mgrUpgBonus(st.upg, race.type) : (st.ai[t.name] || 0)) + mgrSetupFit(mine ? setup : aiSetup, race.type, wet);
            t.drivers.forEach((d, j) => {
                const tk = mine ? tac[d.id] || 'std' : 'std';
                const tc = MGR_TACTICS.find(x => x.k === tk);
                const ns = mine ? stops[d.id] || 1 : aiStops;
                const sFit = wet ? 0 : mgrStopFit(ns, race.wear);
                const pace = car + d.skill * (wet ? 0.45 : 0.3) + (st.form[d.id] || 0);
                const dnfP = 0.05 + tc.risk + (wet ? 0.04 : 0) - (mine ? (st.upg.rel || 0) * 0.015 : 0);
                field.push({...d, mine, tactic: tk, stops: ns, q: pace + gmNoise(0.05), base: pace + tc.d + sFit,
                    pen: mine && race.event === 'penalty' && race.penaltyIdx === j, dnf: Math.random() < dnfP});
            });
        });
        // квалификация: Q1 и Q2 отсекают по шесть машин
        const qs = [...field].sort((a, b) => b.q - a.q);
        const qTop = qs[0].q;
        qs.forEach((x, i) => { x.qpos = i + 1; x.qtime = race.qt + (wet ? 9 : 0) + (qTop - x.q) * 4.5; x.qout = i >= qs.length - 6 ? 'Q1' : i >= 10 ? 'Q2' : null; });
        const grid = [...qs];
        grid.filter(x => x.pen).forEach(p => { grid.splice(grid.indexOf(p), 1); grid.push(p); });
        grid.forEach((x, i) => { x.grid = i + 1; });

        const laps = race.laps;
        const sc = Math.random() < (wet ? 0.6 : 0.35);
        const scLap = 5 + gmRand(Math.max(1, laps - 15));
        const noise = (wet ? 0.16 : 0.1) + (sc ? 0.04 : 0);
        const ev = [];
        grid.forEach(x => {
            x.r = x.base + gmNoise(noise) - (x.grid - 1) * 0.006;
            // пит-стопы: круги и время на месте
            x.pits = [];
            const at = x.stops === 2 ? [0.3, 0.64] : [0.42];
            const slowP = 0.12 - (x.mine ? (st.upg.crew || 0) * 0.035 : 0);
            at.forEach(f => {
                const slow = Math.random() < slowP;
                x.pits.push({lap: Math.round(laps * (f + gmNoise(0.06))), t: slow ? 5 + Math.random() * 3 : 2.1 + Math.random() * 0.9, slow});
            });
            x.lost = x.pits.reduce((s, p) => s + Math.max(0, p.t - 2.5), 0);
            if (x.dnf) x.dnfLap = 1 + gmRand(laps - 1);
        });
        const rTop = Math.max(...grid.map(x => x.r));
        const live = grid.filter(x => !x.dnf).map(x => ({x, t: (rTop - x.r) * laps * 0.9 * (sc ? 0.55 : 1) + x.lost})).sort((a, b) => a.t - b.t);
        const t0 = live[0].t;
        const fin = [...live.map((o, i) => ({...o.x, pos: i + 1, gap: o.t - t0})), ...grid.filter(x => x.dnf).sort((a, b) => b.dnfLap - a.dnfLap).map(x => ({...x, pos: null}))];
        fin.forEach((x, i) => { x.p = x.pos ? (STR_PTS[i] || 0) : 0; });
        const winTime = laps * (race.qt + (wet ? 12 : 4));

        // хроника гонки
        fin.filter(x => x.mine).forEach(x => {
            const g = Math.max(-3, Math.min(3, Math.round(gmNoise(2.2) + (x.tactic === 'push' ? 0.8 : x.tactic === 'safe' ? -0.5 : 0))));
            if (g) ev.push({lap: 1, mine: true, t: x.name + (g > 0 ? ' отыгрывает на старте ' + g + ' ' + plural(g, 'позицию', 'позиции', 'позиций') : ' теряет на старте ' + -g + ' ' + plural(-g, 'позицию', 'позиции', 'позиций'))});
            x.pits.filter(p => !x.dnf || p.lap < x.dnfLap).forEach((p, k) => ev.push({lap: p.lap, mine: true, bad: p.slow,
                t: x.name + ': пит-стоп ' + p.t.toFixed(1) + ' с' + (p.slow ? ' — заело колесо' : '') + (x.stops === 2 ? (k ? ', Medium → Hard' : ', Soft → Medium') : ', Medium → Hard')}));
        });
        fin.filter(x => x.dnf).forEach(x => {
            const why = x.tactic === 'push' && Math.random() < 0.6 ? MGR_DNF.push[gmRand(3)] : MGR_DNF.any[gmRand(MGR_DNF.any.length)];
            x.why = why;
            ev.push({lap: x.dnfLap, mine: x.mine, bad: true, t: 'Сход: ' + x.name + ' — ' + why});
        });
        if (sc) ev.push({lap: scLap, t: 'Сейфти-кар — отрывы обнулились'});
        if (wet) ev.push({lap: 0, t: 'Гонка под дождём: все на промежуточной резине'});
        fin.filter(x => x.mine && x.pos && x.pos < x.grid).forEach(x => {
            const passed = fin.filter(o => o.pos && o.pos > x.pos && o.grid < x.grid);
            if (passed.length) { const o = passed[gmRand(passed.length)]; ev.push({lap: 8 + gmRand(Math.max(1, laps - 12)), mine: true, good: true, t: x.name + ' обгоняет ' + o.name}); }
        });
        const fl = fin.filter(x => x.pos && x.pos <= 8)[gmRand(Math.min(8, live.length))];
        const flTime = race.qt + (wet ? 11 : 1.3) + Math.random() * 0.8;
        ev.push({lap: Math.round(laps * (0.6 + Math.random() * 0.35)), t: 'Лучший круг: ' + fl.name + ' — ' + mgrLap(flTime), mine: fl.mine});
        ev.push({lap: laps, t: 'Финиш: побеждает ' + fin[0].name + ' (' + fin[0].team + ')', good: fin[0].mine});
        ev.sort((a, b) => a.lap - b.lap);

        // очки, деньги, форма
        const myFin = fin.filter(x => x.mine);
        const myPts = myFin.reduce((s, x) => s + x.p, 0);
        const both = myFin.every(x => x.pos);
        const bothPts = myFin.every(x => x.p > 0);
        const spMoney = st.sponsor === 'energy' ? Math.round(myPts * 0.6) : st.sponsor === 'bank' && both ? 4 : 0;
        const bonus = race.event === 'bonus' && bothPts ? 6 : 0;
        const prize = 3 + Math.round(myPts * 0.35) + spMoney + bonus;
        const pts = {...st.pts}, dpts = {...st.dpts}, form = {...st.form};
        fin.forEach(x => {
            pts[x.team] = (pts[x.team] || 0) + x.p; dpts[x.id] = (dpts[x.id] || 0) + x.p;
            const f = (form[x.id] || 0) + (x.pos ? Math.max(-0.01, Math.min(0.01, (x.grid - x.pos) * 0.002)) : -0.005);
            form[x.id] = Math.max(-0.04, Math.min(0.04, f));
        });
        const ai = {...st.ai}; m.teams.forEach(t => { if (t.name !== me) ai[t.name] = (ai[t.name] || 0) + Math.random() * 0.012; });
        const bestPos = Math.min(...myFin.map(x => x.pos || 99), st.best || 99);
        const last = {wet, sc, qs, grid, fin, ev, myPts, prize, spMoney, bonus, bothPts, winTime};
        setSt({...st, last, pts, dpts, form, ai, cash: st.cash + prize, best: bestPos, history: [...st.history, {city: race.city, pts: myPts}]});
        setTab('report'); setPhase('quali'); gHaptic('medium');
    };

    const nextRace = () => {
        if (st.i + 1 >= MGR_RACES) {
            setPhase('done');
            gmPostResult({game_type: 'manager', score: st.pts[me] || 0}).then(() => setBoardKey(k => k + 1));
        } else { setSt({...st, i: st.i + 1, last: null}); setSetup('mid'); setPhase('prep'); }
        gHaptic('light');
    };

    const standings = st ? m.teams.map(t => ({name: t.name, color: t.color, pts: st.pts[t.name] || 0, mine: t.name === me})).sort((a, b) => b.pts - a.pts) : [];
    const myPlace = standings.findIndex(t => t.name === me) + 1;
    const drvSt = st ? Object.values(m.names).map(d => ({...d, pts: st.dpts[d.id] || 0, mine: d.team === me})).sort((a, b) => b.pts - a.pts) : [];
    const goalTxt = st ? (st.goal === 1 ? 'выиграть Кубок' : 'место не ниже ' + st.goal + '-го') : '';
    const Form = ({id}) => { const f = st.form[id] || 0; return <em className={'mgr-form' + (f > 0.005 ? ' up' : f < -0.005 ? ' down' : '')}>{f > 0.005 ? '▲ в форме' : f < -0.005 ? '▼ спад' : 'форма ровная'}</em>; };
    const Table = ({rows, limit = 10, val}) => {
        const top = rows.slice(0, limit);
        const extra = rows.map((x, i) => ({x, i})).filter(o => o.i >= limit && o.x.mine);
        return (
            <div className="mgr-last">
                {top.map((x, i) => <div key={x.id || x.name} className={'mgr-res' + (x.mine ? ' mine' : '')}><span>{i + 1}</span><i style={{background: x.color}}/><em>{x.name}</em><small>{val(x)}</small></div>)}
                {extra.map(({x, i}) => <div key={x.id || x.name} className="mgr-res mine"><span>{i + 1}</span><i style={{background: x.color}}/><em>{x.name}</em><small>{val(x)}</small></div>)}
            </div>
        );
    };

    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Менеджер" onBack={onBack} right={st ? <span className="gm-chip">{st.cash} млн</span> : null}/>

            {phase === 'team' && (
                <div>
                    <div className="gm-h left">Ты — руководитель команды</div>
                    <div className="gm-p left">Сезон из {MGR_RACES} этапов по реальному календарю. Выбери команду и спонсора — совет директоров поставит цель. Перед каждой гонкой: крыло под трассу и погоду, тактика и пит-стопы пилотам, доработки на призовые.</div>
                    <div className="mgr-teams">
                        {m.teams.map(t => (
                            <div key={t.name} className="mgr-team" style={{'--tc': t.color}} onClick={() => pickTeam(t)}>
                                {t.logo ? <img src={t.logo} alt=""/> : <i/>}
                                <div className="mgr-team-tx"><b>{t.name}</b><span>{t.drivers.map(d => d.name).join(' · ')}</span></div>
                                <div className="mgr-team-r"><div className="mgr-bar"><i style={{width: Math.round(20 + t.power * 80) + '%'}}/></div><span>{8 + Math.round((1 - t.power) * 22)} млн</span></div>
                            </div>
                        ))}
                    </div>
                    <GameBoard type="manager" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}

            {phase === 'sponsor' && my && (
                <div>
                    <div className="mgr-stage" style={{'--tc': my.color}}>
                        <span>Твоя команда</span><b>{my.name}</b>
                        <div className="mgr-stage-h">Совет директоров ждёт: <b>{my.rank === 1 ? 'выиграть Кубок конструкторов' : 'место в Кубке не ниже ' + Math.min(m.teams.length, my.rank + 1) + '-го'}</b></div>
                    </div>
                    <div className="mgr-h">Титульный спонсор</div>
                    <div className="mgr-spons">
                        {MGR_SPONSORS.map(s => (
                            <div key={s.k} className="mgr-spon" onClick={() => pickSponsor(s.k)}>
                                <div className="ic">{s.icon}</div><div><b>{s.name}</b><span>{s.sub}</span></div>
                            </div>
                        ))}
                    </div>
                    <div className="gm-p left small">Энергетик выгоден сильным командам, банк — надёжным, телеком — если хочешь сразу вложиться в доработки.</div>
                </div>
            )}

            {phase === 'prep' && my && race && (
                <div>
                    <div className="mgr-stage" style={{'--tc': my.color}}>
                        <span>Этап {st.i + 1} из {MGR_RACES} · {st.i > 0 ? 'ты ' + myPlace + '-й в Кубке' : 'старт сезона'} · цель: {goalTxt}</span>
                        <b>{race.city}</b>
                        <div className="mgr-tags">
                            <em>{MGR_TYPES[race.type].name}</em>
                            <em>{race.laps} {plural(race.laps, 'круг', 'круга', 'кругов')}</em>
                            <em>износ шин: {MGR_WEAR_TXT[race.wear]}</em>
                            <em className={race.forecast >= 40 ? 'wet' : ''}>{race.forecast >= 40 ? '🌧 скорее всего дождь · ' + race.forecast + '%' : race.forecast >= 15 ? '⛅ возможен дождь · ' + race.forecast + '%' : '☀️ сухо'}</em>
                        </div>
                        <div className="mgr-stage-h">{MGR_TYPES[race.type].hint}{race.forecast >= 40 ? '; в дождь выручает высокое крыло' : ''}. {race.wear === 'high' ? 'Шины горят — два пит-стопа выгоднее.' : race.wear === 'low' ? 'Шины живут долго — хватит одного пит-стопа.' : 'Обычно хватает одного пит-стопа.'}</div>
                    </div>
                    {race.event === 'bonus' && <div className="mgr-event">💰 Партнёр: +6 млн, если оба пилота привезут очки</div>}
                    {race.event === 'penalty' && <div className="mgr-event bad">🔧 {my.drivers[race.penaltyIdx].name}: замена мотора — старт с последнего ряда</div>}

                    <div className="mgr-h">Настройка машины</div>
                    <div className="mgr-seg three">
                        {MGR_SETUPS.map(s => <div key={s.k} className={setup === s.k ? 'on' : ''} onClick={() => setSetup(s.k)}><b>{s.name}</b><span>{s.sub}</span></div>)}
                    </div>

                    <div className="mgr-h">Пилоты</div>
                    {my.drivers.map(d => (
                        <div key={d.id} className="mgr-drv">
                            <div className="mgr-drv-n">{d.photo ? <img src={d.photo} alt=""/> : <i style={{background: d.color}}/>}<b>{d.name}</b><Form id={d.id}/><span>{st.dpts[d.id] || 0} очк.</span></div>
                            <div className="mgr-seg">
                                {MGR_TACTICS.map(t => <div key={t.k} className={(tac[d.id] || 'std') === t.k ? 'on' : ''} onClick={() => setTac({...tac, [d.id]: t.k})}>{t.name}</div>)}
                            </div>
                            <div className="mgr-seg two">
                                {[1, 2].map(n => <div key={n} className={(stops[d.id] || 1) === n ? 'on' : ''} onClick={() => setStops({...stops, [d.id]: n})}>{n === 1 ? '1 пит-стоп' : '2 пит-стопа'}</div>)}
                            </div>
                        </div>
                    ))}
                    <div className="gm-p left small">«Атака» — быстрее, но чаще сходы. «Беречь» — медленнее, зато почти всегда финиш. Можно разделить стратегии: одному пилоту один стоп, другому два.</div>

                    <div className="mgr-h">Доработки · {st.cash} млн</div>
                    <div className="mgr-upgs">
                        {MGR_UPG.map(u => { const lvl = st.upg[u.k] || 0; const cost = MGR_UPG_COST[lvl]; return (
                            <div key={u.k} className={'mgr-upg2' + (lvl >= 3 || st.cash < cost ? ' off' : '')} onClick={() => buy(u.k)}>
                                <div className="ic">{u.icon}</div><b>{u.name}</b><span>{u.sub}</span>
                                <div className="lv">{[0, 1, 2].map(i => <i key={i} className={i < lvl ? 'on' : ''}/>)}</div>
                                <em>{lvl >= 3 ? 'максимум' : cost + ' млн'}</em>
                            </div>
                        ); })}
                    </div>
                    <div className="mgr-go"><div className="gm-btn" onClick={simulate}>Квалификация</div></div>
                </div>
            )}

            {phase === 'quali' && st.last && (
                <div>
                    <div className="mgr-race-h">{race.city} · <b>Квалификация</b>{st.last.wet ? ' · 🌧 пошёл дождь' : ' · ☀️ сухо'}</div>
                    <div className="mgr-mine">
                        {st.last.qs.filter(x => x.mine).map(x => (
                            <div key={x.id}><b>{x.name}</b><span>{x.qout ? 'вылет в ' + x.qout : 'в Q3'}{x.pen ? ' · штраф' : ''}</span><em>P{x.grid}</em></div>
                        ))}
                    </div>
                    <div className="mgr-last">
                        {st.last.qs.map((x, i) => (
                            <React.Fragment key={x.id}>
                                {(i === 10 || i === st.last.qs.length - 6) && <div className="mgr-cut">{i === 10 ? 'выбыли в Q2' : 'выбыли в Q1'}</div>}
                                <div className={'mgr-res' + (x.mine ? ' mine' : '')}><span>{i + 1}</span><i style={{background: x.color}}/><em>{x.name}</em>
                                    <small>{i === 0 ? mgrLap(x.qtime) : '+' + (x.qtime - st.last.qs[0].qtime).toFixed(3)}</small></div>
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="mgr-go"><div className="gm-btn" onClick={() => { setPhase('race'); gHaptic('medium'); }}>Старт гонки</div></div>
                </div>
            )}

            {phase === 'race' && st.last && (
                <div>
                    <div className="mgr-race-h">{race.city} · <b>Финиш</b>{st.last.wet ? ' · 🌧 дождевая гонка' : ''}{st.last.sc ? ' · был сейфти-кар' : ''}</div>
                    <div className="mgr-mine">
                        {st.last.fin.filter(x => x.mine).map(x => (
                            <div key={x.id} className={x.dnf ? 'dnf' : ''}><b>{x.name}</b><span>P{x.grid} → {x.dnf ? 'сход, ' + x.dnfLap + ' круг' : 'P' + x.pos}</span><em>+{x.p}</em></div>
                        ))}
                    </div>
                    <div className="mgr-tabs">
                        {[['report', 'Хроника'], ['result', 'Протокол'], ['cup', 'Кубок'], ['drv', 'Пилоты']].map(([k, n]) => <div key={k} className={tab === k ? 'on' : ''} onClick={() => setTab(k)}>{n}</div>)}
                    </div>
                    {tab === 'report' && (
                        <div className="mgr-ev">
                            {st.last.ev.map((e, i) => (
                                <div key={i} className={(e.mine ? 'mine' : '') + (e.bad ? ' bad' : '') + (e.good ? ' good' : '')}><span>{e.lap ? 'Круг ' + e.lap : 'Старт'}</span><p>{e.t}</p></div>
                            ))}
                        </div>
                    )}
                    {tab === 'result' && <Table rows={st.last.fin.map(x => ({...x}))} limit={22} val={x => x.dnf ? 'сход' : x.pos === 1 ? mgrRaceTime(st.last.winTime) : '+' + x.gap.toFixed(1) + ' с'}/>}
                    {tab === 'cup' && <Table rows={standings} limit={11} val={x => x.pts}/>}
                    {tab === 'drv' && <Table rows={drvSt} limit={10} val={x => x.pts}/>}
                    <div className="mgr-money">Призовые: <b>+{st.last.prize} млн</b>
                        {st.last.spMoney > 0 && <> · спонсор +{st.last.spMoney}</>}
                        {race.event === 'bonus' && (st.last.bonus ? <> · партнёр +6</> : <> · бонус партнёра не взяли</>)}
                    </div>
                    <div className="mgr-go"><div className="gm-btn" onClick={nextRace}>{st.i + 1 >= MGR_RACES ? 'Итоги сезона' : 'Следующий этап'}</div></div>
                </div>
            )}

            {phase === 'done' && (
                <div className="gm-result">
                    <div className="gm-result-k">{me} · итог сезона</div>
                    <div className="gm-result-big">{st.pts[me] || 0}<span>очков</span></div>
                    <div className="gm-result-t">{myPlace === 1 ? 'Кубок конструкторов твой!' : mgrPlace(myPlace) + ' место в Кубке'}</div>
                    <div className={'mgr-verdict' + (myPlace <= st.goal ? ' ok' : '')}>{myPlace <= st.goal ? '✅ Совет директоров доволен: цель «' + goalTxt + '» выполнена' : '❌ Цель «' + goalTxt + '» не выполнена — совет недоволен'}</div>
                    <div className="mgr-bars">
                        {st.history.map((r, i) => { const mx = Math.max(...st.history.map(h => h.pts), 1); return (
                            <div key={i}><b>{r.pts}</b><i style={{height: Math.max(3, r.pts / mx * 70) + 'px'}}/><span>{r.city}</span></div>
                        ); })}
                    </div>
                    <div className="mgr-sum">
                        <div><span>Лучший финиш</span><b>{st.best && st.best < 99 ? 'P' + st.best : '—'}</b></div>
                        <div><span>Лучший пилот команды</span><b>{my.drivers.map(d => ({d, p: st.dpts[d.id] || 0})).sort((a, b) => b.p - a.p)[0].d.name}</b></div>
                        <div><span>Чемпион среди пилотов</span><b>{drvSt[0]?.name} · {drvSt[0]?.pts}</b></div>
                    </div>
                    <div className="gm-row"><div className="gm-btn" onClick={() => { setSt(null); setMe(null); setPhase('team'); }}>Новый сезон</div><div className="gm-btn ghost" onClick={onBack}>К играм</div></div>
                    <GameBoard type="manager" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

// ─────────────── 7. КВИЗ ───────────────
// Вопросы собираются из данных (сезоны 1980–2025, решётка и календарь 2026) —
// это больше тысячи разных вопросов, плюс ручной набор фактов. Последние
// 300 заданных вопросов запоминаются и не повторяются.
const QUIZ_FIXED = [
    {q: 'Кто выиграл первый чемпионат мира F1 в 1950 году?', o: ['Джузеппе Фарина', 'Хуан Мануэль Фанхио', 'Альберто Аскари', 'Стирлинг Мосс'], a: 0},
    {q: 'Какая команда выиграла больше всего Кубков конструкторов?', o: ['Ferrari', 'McLaren', 'Mercedes', 'Williams'], a: 0},
    {q: 'Кто самый молодой чемпион мира F1?', o: ['Себастьян Феттель', 'Макс Ферстаппен', 'Льюис Хэмилтон', 'Фернандо Алонсо'], a: 0},
    {q: 'Что такое DRS?', o: ['Подвижный элемент заднего крыла', 'Система торможения', 'Система рекуперации', 'Ограничитель скорости'], a: 0},
    {q: 'Что означает синий флаг?', o: ['Пропусти более быструю машину', 'Опасность на трассе', 'Конец сессии', 'Мокрая трасса'], a: 0},
    {q: 'Сколько очков получает победитель гонки?', o: ['25', '20', '30', '10'], a: 0},
    {q: 'Сколько очков дают за второе место?', o: ['18', '20', '15', '19'], a: 0},
    {q: 'Сколько очков дают за десятое место?', o: ['1', '2', '0', '3'], a: 0},
    {q: 'Сколько цилиндров в моторе F1 с 2014 года?', o: ['6', '8', '10', '4'], a: 0},
    {q: 'Кто единственный стал чемпионом посмертно?', o: ['Йохен Риндт', 'Айртон Сенна', 'Джим Кларк', 'Жиль Вильнёв'], a: 0},
    {q: 'В каком году появилась защита «гало»?', o: ['2018', '2016', '2020', '2014'], a: 0},
    {q: 'Сколько побед одержал Ферстаппен в сезоне-2023?', o: ['19', '15', '17', '21'], a: 0},
    {q: 'Сколько передач в коробке болида F1?', o: ['8', '6', '7', '10'], a: 0},
    {q: 'Где базируется Ferrari?', o: ['Маранелло', 'Монца', 'Турин', 'Имола'], a: 0},
    {q: 'Где базируется Red Bull Racing?', o: ['Милтон-Кинс', 'Зальцбург', 'Брэкли', 'Энстоун'], a: 0},
    {q: 'На какой трассе проходит Гран-при Италии?', o: ['Монца', 'Имола', 'Муджелло', 'Имола и Монца по очереди'], a: 0},
    {q: 'Какой цвет боковины у мягких шин Pirelli?', o: ['Красный', 'Жёлтый', 'Белый', 'Зелёный'], a: 0},
    {q: 'Какой цвет у шин для сильного дождя?', o: ['Синий', 'Зелёный', 'Белый', 'Оранжевый'], a: 0},
    {q: 'Какого цвета промежуточные шины (intermediate)?', o: ['Зелёные', 'Синие', 'Жёлтые', 'Фиолетовые'], a: 0},
    {q: 'Что такое андеркат?', o: ['Ранний пит-стоп, чтобы обогнать соперника на свежих шинах', 'Обгон по внутренней траектории', 'Срез шиканы', 'Старт с пит-лейн'], a: 0},
    {q: 'Что означает жёлтый флаг?', o: ['Опасность, обгоны запрещены', 'Пропусти быструю машину', 'Скользкая трасса', 'Последний круг'], a: 0},
    {q: 'Что означает красный флаг?', o: ['Сессия остановлена', 'Опасность впереди', 'Дисквалификация', 'Пит-лейн закрыт'], a: 0},
    {q: 'Что такое «закрытый парк» (parc fermé)?', o: ['Запрет менять настройки машины после квалификации', 'Стоянка болидов в боксах', 'Зона для болельщиков', 'Штрафная зона'], a: 0},
    {q: 'Что такое поул-позиция?', o: ['Первое место на старте', 'Лучший круг гонки', 'Место в боксах', 'Позиция на подиуме'], a: 0},
    {q: 'Какой автодром называют «Храмом скорости»?', o: ['Монца', 'Спа', 'Сильверстоун', 'Сузука'], a: 0},
    {q: 'На какой трассе знаменитая связка Eau Rouge?', o: ['Спа-Франкоршам', 'Монца', 'Сузука', 'Интерлагос'], a: 0},
    {q: 'Как называют Северную петлю Нюрбургринга?', o: ['Зелёный ад', 'Храм скорости', 'Красный ад', 'Королевская трасса'], a: 0},
    {q: 'В какой стране трасса Интерлагос?', o: ['Бразилия', 'Аргентина', 'Мексика', 'Португалия'], a: 0},
    {q: 'Какая трасса самая короткая в календаре?', o: ['Монако', 'Зандворт', 'Баку', 'Сингапур'], a: 0},
    {q: 'Где с 2008 года проходит первая ночная гонка F1?', o: ['Сингапур', 'Бахрейн', 'Абу-Даби', 'Лас-Вегас'], a: 0},
    {q: 'Кто основал Ferrari?', o: ['Энцо Феррари', 'Фрэнк Уильямс', 'Брюс Макларен', 'Колин Чепмен'], a: 0},
    {q: 'Кто основал McLaren?', o: ['Брюс Макларен', 'Рон Деннис', 'Колин Чепмен', 'Кен Тиррелл'], a: 0},
    {q: 'Какое прозвище было у Алена Проста?', o: ['Профессор', 'Барон', 'Летучий финн', 'Ледяной'], a: 0},
    {q: 'Кого называли «Ледяным» (Iceman)?', o: ['Кими Райкконена', 'Мику Хаккинена', 'Нико Росберга', 'Дженсона Баттона'], a: 0},
    {q: 'Кто первый российский пилот F1?', o: ['Виталий Петров', 'Даниил Квят', 'Сергей Сироткин', 'Никита Мазепин'], a: 0},
    {q: 'Кто выиграл первый Гран-при России в Сочи (2014)?', o: ['Льюис Хэмилтон', 'Нико Росберг', 'Себастьян Феттель', 'Фернандо Алонсо'], a: 0},
    {q: 'Сколько титулов у Михаэля Шумахера?', o: ['7', '5', '6', '4'], a: 0},
    {q: 'Сколько титулов у Айртона Сенны?', o: ['3', '2', '4', '5'], a: 0},
    {q: 'Сколько титулов у Алена Проста?', o: ['4', '3', '2', '5'], a: 0},
    {q: 'Сколько титулов у Фернандо Алонсо?', o: ['2', '1', '3', '4'], a: 0},
    {q: 'Кто выиграл больше всего Гран-при Монако?', o: ['Айртон Сенна', 'Михаэль Шумахер', 'Грэм Хилл', 'Ален Прост'], a: 0},
    {q: 'Кто стал чемпионом 2008 года с отрывом в одно очко?', o: ['Льюис Хэмилтон', 'Фелипе Масса', 'Кими Райкконен', 'Роберт Кубица'], a: 0},
    {q: 'На каком Гран-при Ферстаппен одержал первую победу?', o: ['Испания 2016', 'Малайзия 2016', 'Бразилия 2016', 'Австрия 2018'], a: 0},
    {q: 'В какой команде Шумахер вернулся в F1 в 2010 году?', o: ['Mercedes', 'Ferrari', 'Benetton', 'Sauber'], a: 0},
    {q: 'Какая команда дебютирует в F1 в 2026 году?', o: ['Cadillac', 'Andretti', 'Porsche', 'Toyota'], a: 0},
    {q: 'Кто поставляет шины для F1?', o: ['Pirelli', 'Bridgestone', 'Michelin', 'Goodyear'], a: 0},
    {q: 'Сколько длится гонка максимум (без остановок)?', o: ['2 часа', '1,5 часа', '3 часа', '1 час'], a: 0},
    {q: 'Под каким номером может выступать действующий чемпион?', o: ['1', '0', '100', '99'], a: 0},
    {q: 'Как в 1988 году выступила McLaren?', o: ['Выиграла 15 гонок из 16', 'Не набрала очков', 'Выиграла все гонки', 'Пропустила сезон'], a: 0},
    {q: 'Кто выиграл первую гонку для Red Bull (Китай-2009)?', o: ['Себастьян Феттель', 'Марк Уэббер', 'Дэвид Култхард', 'Макс Ферстаппен'], a: 0},
];

const QUIZ_SEEN = 'gm_quiz_seen';
const quizMake = (hist, grid, races) => {
    const yrs = Object.keys(hist.seasons).filter(y => +y >= 1980);
    const nm = (id) => { const d = hist.drivers[id] || {}; return ((d.first || '') + ' ' + (d.last || '')).trim(); };
    const ry = () => yrs[gmRand(yrs.length)];
    const debut = {};
    yrs.forEach(y => hist.seasons[y].drivers.forEach(r => { if (!debut[r.id]) debut[r.id] = +y; }));
    // чемпионы: id → годы титулов
    const titles = {};
    yrs.forEach(y => { const c = hist.seasons[y].drivers.find(x => x.pos === 1); if (c) (titles[c.id] = titles[c.id] || []).push(+y); });
    // только те, чья карьера целиком после 1980 — иначе «первый титул» соврёт (Лауда)
    const champs = Object.keys(titles).filter(id => debut[id] > 1980);
    const numOpts = (v, spread) => { const o = []; for (let x = v - spread; x <= v + spread; x++) if (x >= 0 && x !== v) o.push(String(x)); return o; };
    const gens = [
        () => { const y = ry(); const s = hist.seasons[y].drivers; const ch = s.find(x => x.pos === 1); if (!ch) return null;
            return {q: 'Кто стал чемпионом мира в ' + y + ' году?', right: nm(ch.id), opts: s.filter(x => x.pos > 1 && x.pos <= 8).map(x => nm(x.id))}; },
        () => { const y = ry(); const s = hist.seasons[y].drivers; const v = s.find(x => x.pos === 2); if (!v) return null;
            return {q: 'Кто стал вице-чемпионом в ' + y + ' году?', right: nm(v.id), opts: s.filter(x => x.pos !== 2 && x.pos <= 8).map(x => nm(x.id))}; },
        () => { const y = ry(); const c = hist.seasons[y].constructors; if (c.length < 4) return null;
            return {q: 'Кто выиграл Кубок конструкторов в ' + y + ' году?', right: gmTeam(c[0].name), opts: c.slice(1, 8).map(x => gmTeam(x.name))}; },
        () => { const y = ry(); const s = hist.seasons[y]; const d = gmShuffle(s.drivers.filter(x => x.pos && x.pos <= 10 && x.teams.length === 1))[0]; if (!d) return null;
            return {q: 'За какую команду выступал ' + nm(d.id) + ' в ' + y + ' году?', right: gmTeam(d.teams[0]), opts: s.constructors.map(x => gmTeam(x.name))}; },
        () => { const y = ry(); const s = hist.seasons[y].drivers; const d = gmShuffle(s.filter(x => x.pos && x.pos <= 8 && x.teams.length === 1))[0]; if (!d) return null;
            const mate = s.filter(x => x.id !== d.id && x.teams.includes(d.teams[0])); if (mate.length !== 1) return null;
            return {q: 'Кто был напарником ' + nm(d.id) + ' в ' + y + ' году?', right: nm(mate[0].id), opts: s.filter(x => !x.teams.includes(d.teams[0])).map(x => nm(x.id))}; },
        () => { const y = ry(); const s = hist.seasons[y].drivers; const mx = Math.max(...s.map(x => x.wins)); const top = s.filter(x => x.wins === mx); if (top.length !== 1 || !mx) return null;
            return {q: 'Кто выиграл больше всего гонок в сезоне-' + y + '?', right: nm(top[0].id), opts: s.filter(x => x.id !== top[0].id && x.pos <= 8).map(x => nm(x.id))}; },
        () => { const y = ry(); const ch = hist.seasons[y].drivers.find(x => x.pos === 1); if (!ch || !ch.wins) return null;
            return {q: 'Сколько гонок выиграл чемпион ' + y + ' года ' + nm(ch.id) + '?', right: String(ch.wins), opts: numOpts(ch.wins, 4).filter(x => +x > 0)}; },
        () => { const id = champs[gmRand(champs.length)];
            return {q: 'В каком году ' + nm(id) + ' впервые стал чемпионом мира?', right: String(titles[id][0]), opts: numOpts(titles[id][0], 5).filter(x => +x <= 2025)}; },
        () => { const id = champs[gmRand(champs.length)]; const n = titles[id].length;
            return {q: 'Сколько чемпионских титулов у ' + nm(id) + '?', right: String(n), opts: numOpts(n, 3).filter(x => +x > 0)}; },
        () => { const y = ry(); const s = hist.seasons[y].drivers.filter(x => x.pos && x.pos <= 6 && debut[x.id] === +y && +y > 1980); if (!s.length) return null; const d = s[0];
            return {q: 'Кто из этих пилотов дебютировал в F1 в ' + y + ' году?', right: nm(d.id), opts: hist.seasons[y].drivers.filter(x => debut[x.id] < +y - 2 && x.pos <= 12).map(x => nm(x.id))}; },
        () => { const d = grid.drivers[gmRand(grid.drivers.length)]; if (!d.nationality) return null;
            return {q: 'Из какой страны ' + d.name + '?', right: gmNat(d.nationality), opts: [...new Set(grid.drivers.map(x => gmNat(x.nationality)))]}; },
        () => { const d = grid.drivers[gmRand(grid.drivers.length)];
            return {q: 'Под каким номером выступает ' + d.name + '?', right: String(d.driver_number), opts: grid.drivers.map(x => String(x.driver_number))}; },
        () => { const d = grid.drivers[gmRand(grid.drivers.length)];
            return {q: 'За какую команду ' + d.name + ' выступает в 2026 году?', right: d.team, opts: grid.teams.map(t => t.team)}; },
        () => { const r = races[gmRand(races.length)]; const c = GM_CITY[r.circuit_id]; if (!c) return null;
            return {q: 'Где проходит ' + r.name + ' в 2026 году?', right: c, opts: races.map(x => GM_CITY[x.circuit_id]).filter(Boolean)}; },
    ];
    const seen = new Set(gmLS.get(QUIZ_SEEN, []));
    const out = [], used = new Set();
    let guard = 0;
    while (out.length < 7 && guard++ < 300) {
        const q = gens[gmRand(gens.length)]();
        if (!q || used.has(q.q) || (seen.has(q.q) && guard < 200)) continue;
        const wrong = gmPickN([...new Set(q.opts)].filter(Boolean), 3, [q.right]);
        if (wrong.length < 3) continue;
        used.add(q.q);
        const o = gmShuffle([q.right, ...wrong]);
        out.push({q: q.q, o, a: o.indexOf(q.right)});
    }
    const fresh = QUIZ_FIXED.filter(f => !seen.has(f.q));
    gmPickN(fresh.length >= 3 ? fresh : QUIZ_FIXED, 3).forEach(f => { used.add(f.q); const o = gmShuffle(f.o.map((t, i) => ({t, i}))); out.push({q: f.q, o: o.map(x => x.t), a: o.findIndex(x => x.i === f.a)}); });
    gmLS.set(QUIZ_SEEN, [...seen, ...used].slice(-300));
    return gmShuffle(out);
};

const QUIZ_TIME = 12;
const QuizGame2 = ({onBack}) => {
    const [data, retry] = useGm([gmHist, gmGrid, gmSched]);
    const [phase, setPhase] = useState('intro');
    const [qs, setQs] = useState([]);
    const [i, setI] = useState(0);
    const [pick, setPick] = useState(null);
    const [score, setScore] = useState(0);
    const [right, setRight] = useState(0);
    const [left, setLeft] = useState(QUIZ_TIME);
    const [boardKey, setBoardKey] = useState(0);
    const t0 = useRef(0);
    const lock = useRef(false);

    const answer = (idx) => {
        if (lock.current || phase !== 'play') return;
        lock.current = true;
        const ok = idx === qs[i].a;
        const secs = Math.max(0, QUIZ_TIME - (performance.now() - t0.current) / 1000);
        const sc = score + (ok ? 100 + Math.round(secs * 5) : 0);
        setPick(idx === null ? -1 : idx); setScore(sc); if (ok) setRight(r => r + 1);
        gHaptic(ok ? 'success' : 'error');
        setTimeout(() => {
            if (i + 1 >= qs.length) {
                setPhase('done');
                gmPostResult({game_type: 'quiz2', score: sc}).then(() => setBoardKey(k => k + 1));
            } else { setI(i + 1); setPick(null); lock.current = false; t0.current = performance.now(); setLeft(QUIZ_TIME); }
        }, 1100);
    };
    useEffect(() => {
        if (phase !== 'play') return;
        let raf;
        const tick = () => {
            const l = QUIZ_TIME - (performance.now() - t0.current) / 1000;
            setLeft(Math.max(0, l));
            if (l <= 0 && !lock.current) { answer(null); return; }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [phase, i]);

    useGmKeys(e => {
        const k = '1234'.indexOf(e.key);
        if (k >= 0 && phase === 'play' && qs[i] && k < qs[i].o.length) { answer(k); return true; }
    });
    if (!data) return <GmLoading title="Квиз" onBack={onBack} data={data} retry={retry}/>;
    const start = () => {
        setQs(quizMake(data[0], data[1], data[2])); setI(0); setPick(null); setScore(0); setRight(0);
        lock.current = false; t0.current = performance.now(); setLeft(QUIZ_TIME); setPhase('play');
    };
    const q = qs[i];
    return (
        <div className="page-container fade-in gm-page">
            <GameTop title="Квиз" onBack={onBack} right={phase === 'play' ? <span className="gm-chip">{i + 1} / {qs.length}</span> : null}/>
            {phase === 'intro' && (
                <div className="gm-intro">
                    <div className="gm-h">10 вопросов</div>
                    <div className="gm-p">Больше тысячи вопросов: чемпионы и напарники с 1980 года, рекорды, правила, трассы, решётка 2026. Недавние вопросы не повторяются. На ответ — {QUIZ_TIME} секунд.</div>
                    <div className="gm-btn" onClick={start}>Старт</div>
                    <GameBoard type="quiz2" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}
            {phase === 'play' && q && (
                <div className="qz-play" key={i}>
                    <div className="trk-timer"><i style={{transform: 'scaleX(' + (left / QUIZ_TIME) + ')'}} className={left < 4 ? 'hot' : ''}/></div>
                    <div className="trk-score">{score}<span>очков</span></div>
                    <div className="qz-q">{q.q}</div>
                    <div className="qz-opts">
                        {q.o.map((o, k) => (
                            <div key={k} className={'trk-opt' + (pick !== null ? (k === q.a ? ' ok' : k === pick ? ' bad' : ' dim') : '')} onClick={() => answer(k)}>
                                <span className="qz-l">{'ABCD'[k]}</span>{o}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {phase === 'done' && (
                <div className="gm-result">
                    <div className="gm-result-k">Верно {right} из {qs.length}</div>
                    <div className="gm-result-big">{score}<span>очков</span></div>
                    <div className="gm-result-t">{right >= 9 ? 'Энциклопедия F1' : right >= 6 ? 'Настоящий болельщик' : right >= 3 ? 'Неплохо' : 'Есть куда расти'}</div>
                    <div className="gm-row"><div className="gm-btn" onClick={start}>Ещё раз</div><div className="gm-btn ghost" onClick={onBack}>К играм</div></div>
                    <GameBoard type="quiz2" fmt={s => s + ' очк.'} refreshKey={boardKey}/>
                </div>
            )}
        </div>
    );
};

const GamesPage = ({onChange}) => {
    // по приглашению в дурака открываем игру сразу
    const [activeGame, setActiveGame] = useState(DURAK_INVITE ? 'durak' : null);
    const goBack = () => setActiveGame(null);

    useEffect(() => { gmFlushPending(); }, []);
    const G = {pit_stop: PitStopGame, durak: DurakGame, reaction: ReactionGame, f1dle: DriverDle, career: CareerGuess,
        circuit: CircuitGuess, hl: HigherLower, strategy: StrategyGame, manager: ManagerGame, quiz: QuizGame2};
    if (activeGame && G[activeGame]) { const C = G[activeGame]; return <C onBack={goBack}/>; }

    const day = gmDay();
    const dleDone = gmLS.get('gm_dle_' + day, []).length > 0;
    const carDone = gmLS.get('gm_car_' + day, []).length > 0;
    const sections = [
        {h: 'Каждый день', items: [
            {id: 'f1dle', name: 'Пилот дня', desc: 'Загадка дня и бесконечный режим', cls: 'g-dle', badge: dleDone ? null : 'новый'},
            {id: 'career', name: 'Карьера', desc: 'Чья карьера — загадка дня и бесконечно', cls: 'g-car', badge: carDone ? null : 'новый'},
        ]},
        {h: 'Карты', items: [{id: 'durak', name: 'Дурак', desc: 'Подкидной на картах F1 — с компьютером или с другом', cls: 'g-durak', big: true}]},
        {h: 'Угадайки', items: [
            {id: 'circuit', name: 'Угадай трассу', desc: 'По силуэту, на время', cls: 'g-trk'},
            {id: 'hl', name: 'Больше / меньше', desc: 'Пилоты одного уровня, всё сложнее', cls: 'g-hl'},
            {id: 'quiz', name: 'Квиз', desc: 'Больше 1000 вопросов', cls: 'g-qz'},
        ]},
        {h: 'Стратегия', items: [
            {id: 'strategy', name: 'Пит-уолл', desc: 'Любой этап, шины и пит-стопы', cls: 'g-str'},
            {id: 'manager', name: 'Менеджер', desc: 'Сезон руководителя команды: стратегия, доработки, спонсоры', cls: 'g-mgr'},
        ]},
        {h: 'На реакцию', items: [
            {id: 'pit_stop', name: 'Пит-стоп', desc: 'Гайковёрт на время', cls: 'g-pit'},
            {id: 'reaction', name: 'Реакция', desc: 'Старт по огням F1', cls: 'g-rx'},
        ]},
    ];

    return (
        <div className="page-container fade-in gm-page">
            <div className="gm-list-head">
                <h2>Мини-игры</h2>
                {onChange && <div className="gm-back" onClick={() => onChange('home')}>← Главная</div>}
            </div>
            {sections.map(s => (
                <div key={s.h} className="gm-sec">
                    <div className="gm-sec-h">{s.h}</div>
                    <div className="gm-grid">
                        {s.items.map(g => (
                            <div key={g.id} className={'gm-card2 ' + g.cls + (g.big ? ' big' : '')} onClick={() => setActiveGame(g.id)}>
                                {g.badge && <span className={'gm-badge' + (g.badge === 'новый' ? ' hot' : '')}>{g.badge}</span>}
                                <div className="gm-card2-art" aria-hidden="true"/>
                                <div className="gm-card2-name">{g.name}</div>
                                <div className="gm-card2-desc">{g.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};



// ─── страница ───
const SG_SECTIONS = [
    {h: 'Каждый день', items: [
        {id: 'f1dle', name: 'Пилот дня', desc: 'Загадка дня и бесконечный режим', cls: 'g-dle'},
        {id: 'career', name: 'Карьера', desc: 'Чья карьера — загадка дня и бесконечно', cls: 'g-car'},
    ]},
    {h: 'Карты', items: [{id: 'durak', name: 'Дурак', desc: 'Подкидной на картах F1 — с компьютером или с другом', cls: 'g-durak'}]},
    {h: 'Угадайки', items: [
        {id: 'circuit', name: 'Угадай трассу', desc: 'По силуэту, на время', cls: 'g-trk'},
        {id: 'hl', name: 'Больше / меньше', desc: 'Пилоты одного уровня, всё сложнее', cls: 'g-hl'},
        {id: 'quiz', name: 'Квиз', desc: 'Больше 1000 вопросов', cls: 'g-qz'},
    ]},
    {h: 'Стратегия', items: [
        {id: 'strategy', name: 'Пит-уолл', desc: 'Любой этап, шины и пит-стопы', cls: 'g-str'},
        {id: 'manager', name: 'Менеджер', desc: 'Сезон руководителя команды: стратегия, доработки, спонсоры', cls: 'g-mgr'},
    ]},
    {h: 'На реакцию', items: [
        {id: 'pit_stop', name: 'Пит-стоп', desc: 'Тормоз на отметке, колёса, выпуск', cls: 'g-pit'},
        {id: 'reaction', name: 'Реакция', desc: 'Старт по огням F1', cls: 'g-rx'},
    ]},
];
const SG_ALL = SG_SECTIONS.flatMap(s => s.items);
const SG_COMP = {pit_stop: PitStopGame, durak: DurakGame, reaction: ReactionGame, f1dle: DriverDle, career: CareerGuess,
    circuit: CircuitGuess, hl: HigherLower, strategy: StrategyGame, manager: ManagerGame, quiz: QuizGame2};
// таблицы рекордов: тот же game_type, что пишет игра (общие с мини-аппом)
const SG_BOARD = {
    reaction: {type: 'reaction', fmt: v => v, unit: 'мс', hint: 'Время в миллисекундах — чем меньше, тем лучше'},
    pit_stop: {type: 'pit_real', fmt: v => (v / 1000).toFixed(2), unit: 'с', hint: 'Время стоянки с штрафами — чем меньше, тем лучше'},
    circuit: {type: 'circuit', fmt: v => v, unit: 'очк.', hint: 'Очки за угаданные трассы'},
    hl: {type: 'higher_lower', fmt: v => v, unit: 'подряд', hint: 'Самая длинная серия верных ответов'},
    strategy: {type: 'strategy', fmt: v => 'P' + v, unit: '', hint: 'Лучшее место на финише'},
    manager: {type: 'manager', fmt: v => v, unit: 'очк.', hint: 'Очки команды за сезон'},
    quiz: {type: 'quiz2', fmt: v => v, unit: 'очк.', hint: 'Очки за 10 вопросов'},
};
const SG_KEYS = {
    reaction: 'Пробел или Enter — старт и «жми». Можно и мышью.',
    pit_stop: 'Пробел — тормоз и выпуск, клавиши 1–4 — колёса. Можно и мышью.',
    quiz: 'Клавиши 1–4 — варианты ответа.',
    durak: 'Клик по карте поднимает её, второй клик — ход. Карту можно перетащить на стол.',
};

const sgFromUrl = () => {
    const q = new URLSearchParams(location.search);
    if (q.get('durak')) return 'durak';
    const g = q.get('g');
    return SG_COMP[g] ? g : null;
};

const SgBoard = ({id}) => {
    const b = SG_BOARD[id];
    const {saved} = useSG();
    const [d, setD] = useState(undefined);
    useEffect(() => { if (!b) return; setD(undefined); api.get('/api/games/leaderboard?game_type=' + b.type).then(setD); }, [id, saved]);
    if (!b) return null;
    const rows = (d?.leaderboard || []).slice(0, 10);
    const name = (u) => [u.first_name, u.last_name].filter(Boolean).join(' ') || 'Игрок';
    return (
        <div className="sg-board">
            <div className="sg-board-h">Рекорды</div>
            <p className="sg-board-hint">{b.hint}</p>
            {d === undefined ? <div className="sg-empty">Загружаем…</div> : !rows.length ? <div className="sg-empty">Пока никто не играл</div> : (
                <div className="gboard">
                    {rows.map(u => (
                        <div className="grow" key={u.user_id}>
                            <span className="p">{String(u.rank ?? '').padStart(2, '0')}</span>
                            {u.photo_url ? <img src={u.photo_url} alt="" onError={e => { e.target.style.visibility = 'hidden'; }}/>
                                : <span className="ini">{([...String(u.first_name || '?').trim()][0] || '?').toUpperCase()}</span>}
                            <span className="nm">{name(u)}<span>{u.attempts ? u.attempts + ' ' + plural(u.attempts, 'попытка', 'попытки', 'попыток') : ''}</span></span>
                            <span className="sc">{b.fmt(u.best_score ?? 0)}<span className="unit"> {b.unit}</span></span>
                        </div>
                    ))}
                    {d?.my_best != null && d.my_rank > 10 && (
                        <div className="grow me"><span className="p">{String(d.my_rank).padStart(2, '0')}</span><span className="ini">Я</span>
                            <span className="nm">Ты<span>{d.my_rank}-е место из {d.players}</span></span>
                            <span className="sc">{b.fmt(d.my_best)}<span className="unit"> {b.unit}</span></span></div>
                    )}
                </div>
            )}
        </div>
    );
};

const SgLoginNote = ({compact}) => {
    const {loggedIn, name} = useSG();
    if (loggedIn === null) return null;
    if (loggedIn) return compact ? null : <div className="sg-acc">Результаты сохраняются в аккаунт <b>{name || 'F1 Hub'}</b> — общие рекорды с приложением.</div>;
    return (
        <div className="sg-acc off">
            <span>Играть можно без входа, но рекорды сохраняются только у вошедших — и попадают в общую таблицу с приложением.</span>
            <a className="btn btn-red" href="/login">Войти через Telegram</a>
        </div>
    );
};

// подсказка после результата — поверх экрана игры
const SgToast = () => {
    const {note} = useSG();
    const [show, setShow] = useState(null);
    useEffect(() => {
        if (!note) return;
        setShow(note);
        const t = setTimeout(() => setShow(null), note.kind === 'nosave' ? 6000 : 2500);
        return () => clearTimeout(t);
    }, [note && note.k]);
    if (!show) return null;
    return show.kind === 'nosave'
        ? <div className="sg-toast"><span>Результат не сохранён — войдите, чтобы попасть в рекорды</span><a href="/login">Войти</a></div>
        : <div className="sg-toast ok"><span>Результат записан</span></div>;
};

const SgTile = ({g, onOpen, active}) => (
    <a href={'/games?g=' + g.id} className={'gm-card2 ' + g.cls + (active ? ' on' : '')} onClick={e => { e.preventDefault(); onOpen(g.id); }}>
        <div className="gm-card2-art" aria-hidden="true"/>
        <div className="gm-card2-name">{g.name}</div>
        <div className="gm-card2-desc">{g.desc}</div>
    </a>
);

const SgLanding = ({onOpen}) => {
    const [tab, setTab] = useState('reaction');
    return (
        <div className="sg-landing">
            <div className="sg-cat">
                {SG_SECTIONS.map(s => (
                    <section key={s.h} className="sg-sec">
                        <div className="sg-sec-h">{s.h}</div>
                        <div className="sg-tiles">{s.items.map(g => <SgTile key={g.id} g={g} onOpen={onOpen}/>)}</div>
                    </section>
                ))}
            </div>
            <aside className="sg-side-rec">
                <SgLoginNote/>
                <div className="sg-chips">
                    {Object.keys(SG_BOARD).map(id => (
                        <button key={id} className={'sg-chip' + (tab === id ? ' on' : '')} onClick={() => setTab(id)}>{SG_ALL.find(g => g.id === id).name}</button>
                    ))}
                </div>
                <SgBoard id={tab}/>
            </aside>
        </div>
    );
};

const SgPlay = ({id, onOpen, onClose}) => {
    const g = SG_ALL.find(x => x.id === id);
    const C = SG_COMP[id];
    const stageRef = useRef(null);
    // на телефоне игра занимает весь экран: прокручиваем страницу ровно к ней
    useEffect(() => {
        if (window.innerWidth <= 860 && stageRef.current) {
            const y = stageRef.current.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({top: Math.max(0, y), behavior: 'instant'});
        }
    }, [id]);
    return (
        <div className="sg-play">
            <nav className="sg-nav" aria-label="Игры">
                <a href="/games" className="sg-nav-all" onClick={e => { e.preventDefault(); onClose(); }}>← Все игры</a>
                {SG_ALL.map(x => (
                    <a key={x.id} href={'/games?g=' + x.id} className={'sg-nav-i' + (x.id === id ? ' on' : '')}
                       onClick={e => { e.preventDefault(); onOpen(x.id); }}>{x.name}</a>
                ))}
            </nav>
            <div className="sg-stage gm-host" ref={stageRef}>
                <C key={id} onBack={onClose}/>
                <SgToast/>
            </div>
            <aside className="sg-info">
                <div className="sg-info-k">Мини-игра</div>
                <h2 className="sg-info-h">{g.name}</h2>
                <p className="sg-info-p">{g.desc}</p>
                {SG_KEYS[id] && <p className="sg-keys">{SG_KEYS[id]}</p>}
                <SgLoginNote/>
                <SgBoard id={id}/>
            </aside>
        </div>
    );
};

const SiteGames = () => {
    const [id, setId] = useState(sgFromUrl);
    useEffect(() => {
        const t = _siteToken();
        if (!t) { SG.set({loggedIn: false}); return; }
        api.get('/api/user/me').then(u => {
            if (u && (u.user_id || u.id)) { SG.set({loggedIn: true, name: u.first_name || u.username || ''}); gmFlushPending(); }
            else SG.set({loggedIn: false});
        });
    }, []);
    useEffect(() => {
        const on = () => setId(sgFromUrl());
        window.addEventListener('popstate', on);
        return () => window.removeEventListener('popstate', on);
    }, []);
    const open = (g) => {
        if (g === id) return;
        history.pushState(null, '', '/games?g=' + g);
        setId(g);
    };
    const close = () => {
        history.pushState(null, '', '/games');
        setId(null);
        window.scrollTo({top: 0, behavior: 'instant'});
    };
    useEffect(() => {
        const g = SG_ALL.find(x => x.id === id);
        document.title = (g ? g.name + ' · ' : '') + 'Игры · F1 HUB';
        // за игрой большой заголовок страницы прячем — экран игры сразу целиком
        document.body.classList.toggle('sg-playing', !!g);
    }, [id]);
    return id && SG_COMP[id] ? <SgPlay id={id} onOpen={open} onClose={close}/> : <SgLanding onOpen={open}/>;
};

ReactDOM.createRoot(document.getElementById('games-app')).render(<SiteGames/>);
